//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AuthorizationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Authorization
     * @return Token
     */
    authorization_Exchange(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/connect/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorization_Exchange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorization_Exchange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAuthorization_Exchange(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AppLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Create AppLog
     */
    appLog_CreateAppLog(model: CreateAppLogRequestModel): Observable<CreateAppLogResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppLog_CreateAppLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppLog_CreateAppLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAppLogResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAppLogResponseModel>;
        }));
    }

    protected processAppLog_CreateAppLog(response: HttpResponseBase): Observable<CreateAppLogResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAppLogResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get AppLogs
     * @param atmId (optional) 
     * @param type (optional) 
     * @param sessionId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    appLog_GetAppLogs(atmId: string | null | undefined, type: number | null | undefined, sessionId: string | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetAppLogsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppLog?";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppLog_GetAppLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppLog_GetAppLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAppLogsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAppLogsResponseModel>;
        }));
    }

    protected processAppLog_GetAppLogs(response: HttpResponseBase): Observable<GetAppLogsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppLogsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AppNotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get App Notifications
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    appNotification_GetAppNotifications(isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetAppNotificationsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppNotification?";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppNotification_GetAppNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppNotification_GetAppNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAppNotificationsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAppNotificationsResponseModel>;
        }));
    }

    protected processAppNotification_GetAppNotifications(response: HttpResponseBase): Observable<GetAppNotificationsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppNotificationsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get App Notifications Unread
     */
    appNotification_GetAppNotificationUnReadCount(): Observable<GetAppNotificationUnReadCountResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppNotification/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppNotification_GetAppNotificationUnReadCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppNotification_GetAppNotificationUnReadCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAppNotificationUnReadCountResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAppNotificationUnReadCountResponseModel>;
        }));
    }

    protected processAppNotification_GetAppNotificationUnReadCount(response: HttpResponseBase): Observable<GetAppNotificationUnReadCountResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppNotificationUnReadCountResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Read All Unread Notification
     */
    appNotification_ReadAllUnReadNotification(): Observable<ReadAllUnReadNotificationResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppNotification/readAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppNotification_ReadAllUnReadNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppNotification_ReadAllUnReadNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReadAllUnReadNotificationResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReadAllUnReadNotificationResponseModel>;
        }));
    }

    protected processAppNotification_ReadAllUnReadNotification(response: HttpResponseBase): Observable<ReadAllUnReadNotificationResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReadAllUnReadNotificationResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Read Notification By Id
     */
    appNotification_ReadNotification(id: number): Observable<ReadNotificationResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppNotification/read/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppNotification_ReadNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppNotification_ReadNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReadNotificationResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReadNotificationResponseModel>;
        }));
    }

    protected processAppNotification_ReadNotification(response: HttpResponseBase): Observable<ReadNotificationResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReadNotificationResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AppTransactionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get App Transactions
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sessionId (optional) 
     * @param atmId (optional) 
     * @param phoneNumber (optional) 
     * @param type (optional) 
     * @param operatorType (optional) 
     * @param operator (optional) 
     * @param bankCode (optional) 
     * @param status (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    appTransaction_GetAppTransactions(startDate: string | null | undefined, endDate: string | null | undefined, sessionId: string | null | undefined, atmId: string | null | undefined, phoneNumber: string | null | undefined, type: number | null | undefined, operatorType: number | null | undefined, operator: string | null | undefined, bankCode: string | null | undefined, status: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetAppTransactionsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppTransaction?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (operatorType !== undefined && operatorType !== null)
            url_ += "OperatorType=" + encodeURIComponent("" + operatorType) + "&";
        if (operator !== undefined && operator !== null)
            url_ += "Operator=" + encodeURIComponent("" + operator) + "&";
        if (bankCode !== undefined && bankCode !== null)
            url_ += "BankCode=" + encodeURIComponent("" + bankCode) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppTransaction_GetAppTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppTransaction_GetAppTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAppTransactionsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAppTransactionsResponseModel>;
        }));
    }

    protected processAppTransaction_GetAppTransactions(response: HttpResponseBase): Observable<GetAppTransactionsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppTransactionsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Public App Transactions
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sessionId (optional) 
     * @param atmId (optional) 
     * @param phoneNumber (optional) 
     * @param type (optional) 
     * @param operatorType (optional) 
     * @param status (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    appTransaction_GetPublicAppTransactions(startDate: string | null | undefined, endDate: string | null | undefined, sessionId: string | null | undefined, atmId: string | null | undefined, phoneNumber: string | null | undefined, type: number | null | undefined, operatorType: number | null | undefined, status: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetPublicAppTransactionsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppTransaction/public?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (operatorType !== undefined && operatorType !== null)
            url_ += "OperatorType=" + encodeURIComponent("" + operatorType) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppTransaction_GetPublicAppTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppTransaction_GetPublicAppTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPublicAppTransactionsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPublicAppTransactionsResponseModel>;
        }));
    }

    protected processAppTransaction_GetPublicAppTransactions(response: HttpResponseBase): Observable<GetPublicAppTransactionsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicAppTransactionsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Public App Transactions By Id
     */
    appTransaction_GetPublicAppTransactionsById(id: number): Observable<GetPublicAppTransactionByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppTransaction/public/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppTransaction_GetPublicAppTransactionsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppTransaction_GetPublicAppTransactionsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPublicAppTransactionByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPublicAppTransactionByIdResponseModel>;
        }));
    }

    protected processAppTransaction_GetPublicAppTransactionsById(response: HttpResponseBase): Observable<GetPublicAppTransactionByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicAppTransactionByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get App Transactions By Id
     */
    appTransaction_GetAppTransactionById(id: number): Observable<GetAppTransactionByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppTransaction/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppTransaction_GetAppTransactionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppTransaction_GetAppTransactionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAppTransactionByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAppTransactionByIdResponseModel>;
        }));
    }

    protected processAppTransaction_GetAppTransactionById(response: HttpResponseBase): Observable<GetAppTransactionByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppTransactionByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Mark a successful transaction refunded (Admin, the ATM supervisor, or the ATM's partner and its staff)
     */
    appTransaction_MarkRefunded(id: number, model: MarkTransactionRefundedRequestModel): Observable<MarkTransactionRefundedResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppTransaction/{id}/refund";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppTransaction_MarkRefunded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppTransaction_MarkRefunded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarkTransactionRefundedResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarkTransactionRefundedResponseModel>;
        }));
    }

    protected processAppTransaction_MarkRefunded(response: HttpResponseBase): Observable<MarkTransactionRefundedResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarkTransactionRefundedResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Undo a refund marking made by mistake
     */
    appTransaction_UndoRefund(id: number): Observable<MarkTransactionRefundedResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppTransaction/{id}/refund";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppTransaction_UndoRefund(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppTransaction_UndoRefund(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarkTransactionRefundedResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarkTransactionRefundedResponseModel>;
        }));
    }

    protected processAppTransaction_UndoRefund(response: HttpResponseBase): Observable<MarkTransactionRefundedResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarkTransactionRefundedResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * ATM reports that it refunded one of its own transactions
     */
    appTransaction_ReportAtmRefund(model: ReportAtmRefundRequestModel): Observable<MarkTransactionRefundedResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppTransaction/refund";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppTransaction_ReportAtmRefund(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppTransaction_ReportAtmRefund(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarkTransactionRefundedResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarkTransactionRefundedResponseModel>;
        }));
    }

    protected processAppTransaction_ReportAtmRefund(response: HttpResponseBase): Observable<MarkTransactionRefundedResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarkTransactionRefundedResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Can Do Transaction By Phone Number
     */
    appTransaction_CanDoTransaction(model: CanDoTransactionRequestModel): Observable<CanDoTransactionResponseModel> {
        let url_ = this.baseUrl + "/api/v1/AppTransaction/valid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppTransaction_CanDoTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppTransaction_CanDoTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CanDoTransactionResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CanDoTransactionResponseModel>;
        }));
    }

    protected processAppTransaction_CanDoTransaction(response: HttpResponseBase): Observable<CanDoTransactionResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CanDoTransactionResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AtmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get Atms
     * @param countryId (optional) 
     * @param regionId (optional) 
     * @param isEnabled (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    atm_GetAtms(countryId: number | null | undefined, regionId: number | null | undefined, isEnabled: boolean | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetAtmsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm?";
        if (countryId !== undefined && countryId !== null)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (regionId !== undefined && regionId !== null)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (isEnabled !== undefined && isEnabled !== null)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_GetAtms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_GetAtms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmsResponseModel>;
        }));
    }

    protected processAtm_GetAtms(response: HttpResponseBase): Observable<GetAtmsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Atm
     */
    atm_CreateAtm(model: CreateAtmRequestModel): Observable<CreateAtmResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_CreateAtm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_CreateAtm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAtmResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAtmResponseModel>;
        }));
    }

    protected processAtm_CreateAtm(response: HttpResponseBase): Observable<CreateAtmResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAtmResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get health (online status and component status) of all ATMs visible to the caller
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    atm_GetAtmHealths(isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetAtmHealthsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/health?";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_GetAtmHealths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_GetAtmHealths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmHealthsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmHealthsResponseModel>;
        }));
    }

    protected processAtm_GetAtmHealths(response: HttpResponseBase): Observable<GetAtmHealthsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmHealthsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get health of an ATM
     */
    atm_GetAtmHealth(id: string): Observable<GetAtmHealthByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/{id}/health";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_GetAtmHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_GetAtmHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmHealthByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmHealthByIdResponseModel>;
        }));
    }

    protected processAtm_GetAtmHealth(response: HttpResponseBase): Observable<GetAtmHealthByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmHealthByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Ping the ATM and request its component status now
     */
    atm_CheckAtmHealth(id: string): Observable<GetAtmHealthByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/{id}/health/check";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_CheckAtmHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_CheckAtmHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmHealthByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmHealthByIdResponseModel>;
        }));
    }

    protected processAtm_CheckAtmHealth(response: HttpResponseBase): Observable<GetAtmHealthByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmHealthByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Atm Profile
     */
    atm_GetAtmProfile(): Observable<GetAtmProfileResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_GetAtmProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_GetAtmProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmProfileResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmProfileResponseModel>;
        }));
    }

    protected processAtm_GetAtmProfile(response: HttpResponseBase): Observable<GetAtmProfileResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmProfileResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Atm Detail By Id
     */
    atm_GetAtmDetailById(id: string): Observable<GetAtmDetailByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_GetAtmDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_GetAtmDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmDetailByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmDetailByIdResponseModel>;
        }));
    }

    protected processAtm_GetAtmDetailById(response: HttpResponseBase): Observable<GetAtmDetailByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmDetailByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Atm
     */
    atm_UpdateAtm(id: string, model: UpdateAtmRequestModel): Observable<UpdateAtmResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_UpdateAtm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_UpdateAtm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAtmResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAtmResponseModel>;
        }));
    }

    protected processAtm_UpdateAtm(response: HttpResponseBase): Observable<UpdateAtmResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAtmResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Atm By id
     */
    atm_DeleteAtm(id: string): Observable<DeleteAtmResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_DeleteAtm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_DeleteAtm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteAtmResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteAtmResponseModel>;
        }));
    }

    protected processAtm_DeleteAtm(response: HttpResponseBase): Observable<DeleteAtmResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteAtmResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Atms Drop Down
     * @param countryId (optional) 
     * @param regionId (optional) 
     * @param isEnabled (optional) 
     */
    atm_GetAtmDropDown(countryId: number | null | undefined, regionId: number | null | undefined, isEnabled: boolean | null | undefined): Observable<GetAtmsDropDownResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/dropDown?";
        if (countryId !== undefined && countryId !== null)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (regionId !== undefined && regionId !== null)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (isEnabled !== undefined && isEnabled !== null)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_GetAtmDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_GetAtmDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmsDropDownResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmsDropDownResponseModel>;
        }));
    }

    protected processAtm_GetAtmDropDown(response: HttpResponseBase): Observable<GetAtmsDropDownResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmsDropDownResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Public ATM Drop Down
     */
    atm_GetPublicAtmDropDown(): Observable<GetAtmsPublicDropDownResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/public/dropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_GetPublicAtmDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_GetPublicAtmDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmsPublicDropDownResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmsPublicDropDownResponseModel>;
        }));
    }

    protected processAtm_GetPublicAtmDropDown(response: HttpResponseBase): Observable<GetAtmsPublicDropDownResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmsPublicDropDownResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Atm Status
     */
    atm_UpdateAtmEnable(id: string, model: UpdateAtmEnableRequestModel): Observable<UpdateAtmEnableResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_UpdateAtmEnable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_UpdateAtmEnable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAtmEnableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAtmEnableResponseModel>;
        }));
    }

    protected processAtm_UpdateAtmEnable(response: HttpResponseBase): Observable<UpdateAtmEnableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAtmEnableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update ATM Setting
     */
    atm_UpdateAtmSetting(id: string, model: UpdateAtmSettingRequestModel): Observable<UpdateAtmSettingResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/{id}/setting";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_UpdateAtmSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_UpdateAtmSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAtmSettingResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAtmSettingResponseModel>;
        }));
    }

    protected processAtm_UpdateAtmSetting(response: HttpResponseBase): Observable<UpdateAtmSettingResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAtmSettingResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Atm Assigned Banks
     */
    atm_GetAtmBanks(id: string): Observable<GetAtmBanksResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/{id}/banks";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_GetAtmBanks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_GetAtmBanks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmBanksResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmBanksResponseModel>;
        }));
    }

    protected processAtm_GetAtmBanks(response: HttpResponseBase): Observable<GetAtmBanksResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmBanksResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assign a Bank to an Atm
     */
    atm_AssignAtmBank(id: string, model: AssignAtmBankRequestModel): Observable<AssignAtmBankResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/{id}/banks";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_AssignAtmBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_AssignAtmBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignAtmBankResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignAtmBankResponseModel>;
        }));
    }

    protected processAtm_AssignAtmBank(response: HttpResponseBase): Observable<AssignAtmBankResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignAtmBankResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove a Bank from an Atm
     */
    atm_RemoveAtmBank(id: string, bankCode: string): Observable<RemoveAtmBankResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/{id}/banks/{bankCode}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (bankCode === undefined || bankCode === null)
            throw new globalThis.Error("The parameter 'bankCode' must be defined.");
        url_ = url_.replace("{bankCode}", encodeURIComponent("" + bankCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_RemoveAtmBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_RemoveAtmBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveAtmBankResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveAtmBankResponseModel>;
        }));
    }

    protected processAtm_RemoveAtmBank(response: HttpResponseBase): Observable<RemoveAtmBankResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoveAtmBankResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Enable/Disable a Bank assigned to an Atm
     */
    atm_UpdateAtmBank(id: string, bankCode: string, model: UpdateAtmBankRequestModel): Observable<UpdateAtmBankResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/{id}/banks/{bankCode}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (bankCode === undefined || bankCode === null)
            throw new globalThis.Error("The parameter 'bankCode' must be defined.");
        url_ = url_.replace("{bankCode}", encodeURIComponent("" + bankCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_UpdateAtmBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_UpdateAtmBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAtmBankResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAtmBankResponseModel>;
        }));
    }

    protected processAtm_UpdateAtmBank(response: HttpResponseBase): Observable<UpdateAtmBankResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAtmBankResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update ATM Currency
     */
    atm_UpdateAtmCurrency(id: string, model: UpdateAtmCurrencyRequestModel): Observable<UpdateAtmCurrencyResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/{id}/currency";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_UpdateAtmCurrency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_UpdateAtmCurrency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAtmCurrencyResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAtmCurrencyResponseModel>;
        }));
    }

    protected processAtm_UpdateAtmCurrency(response: HttpResponseBase): Observable<UpdateAtmCurrencyResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAtmCurrencyResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Atm with Model
     */
    atm_GetAtmsWithDenomination(model: GetAtmsWithDenominationRequestModel): Observable<GetAtmsWithDenominationResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Atm/available";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAtm_GetAtmsWithDenomination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAtm_GetAtmsWithDenomination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmsWithDenominationResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmsWithDenominationResponseModel>;
        }));
    }

    protected processAtm_GetAtmsWithDenomination(response: HttpResponseBase): Observable<GetAtmsWithDenominationResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmsWithDenominationResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BanksClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    banks_RefreshCache(): Observable<RefreshBankCacheResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Banks/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBanks_RefreshCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBanks_RefreshCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshBankCacheResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshBankCacheResponseModel>;
        }));
    }

    protected processBanks_RefreshCache(response: HttpResponseBase): Observable<RefreshBankCacheResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshBankCacheResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    banks_GetBanks(): Observable<GetBanksResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Banks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBanks_GetBanks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBanks_GetBanks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBanksResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBanksResponseModel>;
        }));
    }

    protected processBanks_GetBanks(response: HttpResponseBase): Observable<GetBanksResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBanksResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CommissionConfigClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    commissionConfig_GetCommissionRates(): Observable<GetCommissionRatesResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CommissionConfig/rates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommissionConfig_GetCommissionRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommissionConfig_GetCommissionRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCommissionRatesResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCommissionRatesResponseModel>;
        }));
    }

    protected processCommissionConfig_GetCommissionRates(response: HttpResponseBase): Observable<GetCommissionRatesResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommissionRatesResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commissionConfig_CreateCommissionRate(model: CreateCommissionRateRequestModel): Observable<CreateCommissionRateResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CommissionConfig/rates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommissionConfig_CreateCommissionRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommissionConfig_CreateCommissionRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateCommissionRateResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateCommissionRateResponseModel>;
        }));
    }

    protected processCommissionConfig_CreateCommissionRate(response: HttpResponseBase): Observable<CreateCommissionRateResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCommissionRateResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commissionConfig_DeleteCommissionRate(id: number): Observable<DeleteCommissionRateResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CommissionConfig/rates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommissionConfig_DeleteCommissionRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommissionConfig_DeleteCommissionRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteCommissionRateResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteCommissionRateResponseModel>;
        }));
    }

    protected processCommissionConfig_DeleteCommissionRate(response: HttpResponseBase): Observable<DeleteCommissionRateResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteCommissionRateResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commissionConfig_UpdateCommissionRate(id: number, model: UpdateCommissionRateRequestModel): Observable<UpdateCommissionRateResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CommissionConfig/rates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommissionConfig_UpdateCommissionRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommissionConfig_UpdateCommissionRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCommissionRateResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCommissionRateResponseModel>;
        }));
    }

    protected processCommissionConfig_UpdateCommissionRate(response: HttpResponseBase): Observable<UpdateCommissionRateResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCommissionRateResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commissionConfig_GetProfitShareConfigs(): Observable<GetProfitShareConfigsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CommissionConfig/profit-share";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommissionConfig_GetProfitShareConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommissionConfig_GetProfitShareConfigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfitShareConfigsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfitShareConfigsResponseModel>;
        }));
    }

    protected processCommissionConfig_GetProfitShareConfigs(response: HttpResponseBase): Observable<GetProfitShareConfigsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfitShareConfigsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commissionConfig_GetWithdrawalMinimums(): Observable<GetWithdrawalMinimumsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CommissionConfig/withdrawal-minimums";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommissionConfig_GetWithdrawalMinimums(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommissionConfig_GetWithdrawalMinimums(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWithdrawalMinimumsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWithdrawalMinimumsResponseModel>;
        }));
    }

    protected processCommissionConfig_GetWithdrawalMinimums(response: HttpResponseBase): Observable<GetWithdrawalMinimumsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWithdrawalMinimumsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commissionConfig_UpsertWithdrawalMinimum(model: UpsertWithdrawalMinimumRequestModel): Observable<UpsertWithdrawalMinimumResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CommissionConfig/withdrawal-minimums";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommissionConfig_UpsertWithdrawalMinimum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommissionConfig_UpsertWithdrawalMinimum(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertWithdrawalMinimumResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertWithdrawalMinimumResponseModel>;
        }));
    }

    protected processCommissionConfig_UpsertWithdrawalMinimum(response: HttpResponseBase): Observable<UpsertWithdrawalMinimumResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertWithdrawalMinimumResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commissionConfig_UpdateProfitShareConfig(id: number, model: UpdateProfitShareConfigRequestModel): Observable<UpdateProfitShareConfigResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CommissionConfig/profit-share/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommissionConfig_UpdateProfitShareConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommissionConfig_UpdateProfitShareConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateProfitShareConfigResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateProfitShareConfigResponseModel>;
        }));
    }

    protected processCommissionConfig_UpdateProfitShareConfig(response: HttpResponseBase): Observable<UpdateProfitShareConfigResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateProfitShareConfigResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commissionConfig_CreateTierRate(model: CreateTierCommissionRateRequestModel): Observable<CreateTierCommissionRateResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CommissionConfig/tier-rates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommissionConfig_CreateTierRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommissionConfig_CreateTierRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTierCommissionRateResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTierCommissionRateResponseModel>;
        }));
    }

    protected processCommissionConfig_CreateTierRate(response: HttpResponseBase): Observable<CreateTierCommissionRateResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTierCommissionRateResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commissionConfig_UpdateTierRate(id: number, model: UpdateTierCommissionRateRequestModel): Observable<UpdateTierCommissionRateResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CommissionConfig/tier-rates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommissionConfig_UpdateTierRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommissionConfig_UpdateTierRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTierCommissionRateResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTierCommissionRateResponseModel>;
        }));
    }

    protected processCommissionConfig_UpdateTierRate(response: HttpResponseBase): Observable<UpdateTierCommissionRateResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTierCommissionRateResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commissionConfig_DeleteTierRate(id: number): Observable<DeleteTierCommissionRateResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CommissionConfig/tier-rates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommissionConfig_DeleteTierRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommissionConfig_DeleteTierRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteTierCommissionRateResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteTierCommissionRateResponseModel>;
        }));
    }

    protected processCommissionConfig_DeleteTierRate(response: HttpResponseBase): Observable<DeleteTierCommissionRateResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteTierCommissionRateResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CountryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get Countries
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    country_GetCountries(isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetCountriesResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Country?";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountry_GetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountry_GetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCountriesResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCountriesResponseModel>;
        }));
    }

    protected processCountry_GetCountries(response: HttpResponseBase): Observable<GetCountriesResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCountriesResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Country
     */
    country_CreateCountry(model: CreateCountryRequestModel): Observable<CreateCountryResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Country";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountry_CreateCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountry_CreateCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateCountryResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateCountryResponseModel>;
        }));
    }

    protected processCountry_CreateCountry(response: HttpResponseBase): Observable<CreateCountryResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCountryResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Countries Drop Down
     */
    country_GetCountryDropDown(): Observable<GetCountriesDropDownResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Country/dropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountry_GetCountryDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountry_GetCountryDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCountriesDropDownResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCountriesDropDownResponseModel>;
        }));
    }

    protected processCountry_GetCountryDropDown(response: HttpResponseBase): Observable<GetCountriesDropDownResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCountriesDropDownResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Country
     */
    country_UpdateCountry(id: number, model: UpdateCountryRequestModel): Observable<UpdateCountryResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Country/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountry_UpdateCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountry_UpdateCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCountryResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCountryResponseModel>;
        }));
    }

    protected processCountry_UpdateCountry(response: HttpResponseBase): Observable<UpdateCountryResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCountryResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Country By id
     */
    country_DeleteCountry(id: number): Observable<DeleteCountryResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Country/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountry_DeleteCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountry_DeleteCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteCountryResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteCountryResponseModel>;
        }));
    }

    protected processCountry_DeleteCountry(response: HttpResponseBase): Observable<DeleteCountryResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteCountryResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CryptoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get Crypto Tokens
     * @param chain (optional) 
     * @param isEnabled (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    crypto_GetCryptoTokens(chain: string | null | undefined, isEnabled: boolean | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetCryptoTokensResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/tokens?";
        if (chain !== undefined && chain !== null)
            url_ += "Chain=" + encodeURIComponent("" + chain) + "&";
        if (isEnabled !== undefined && isEnabled !== null)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_GetCryptoTokens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_GetCryptoTokens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCryptoTokensResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCryptoTokensResponseModel>;
        }));
    }

    protected processCrypto_GetCryptoTokens(response: HttpResponseBase): Observable<GetCryptoTokensResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCryptoTokensResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Transactions
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sessionId (optional) 
     * @param atmId (optional) 
     * @param phoneNumber (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @param isRedeemed (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    crypto_GetCryptoTransactions(startDate: string | null | undefined, endDate: string | null | undefined, sessionId: string | null | undefined, atmId: string | null | undefined, phoneNumber: string | null | undefined, status: string | null | undefined, type: number | null | undefined, isRedeemed: boolean | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetCryptoTransactionsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/transactions?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (isRedeemed !== undefined && isRedeemed !== null)
            url_ += "IsRedeemed=" + encodeURIComponent("" + isRedeemed) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_GetCryptoTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_GetCryptoTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCryptoTransactionsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCryptoTransactionsResponseModel>;
        }));
    }

    protected processCrypto_GetCryptoTransactions(response: HttpResponseBase): Observable<GetCryptoTransactionsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCryptoTransactionsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Public Crypto Transactions
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sessionId (optional) 
     * @param atmId (optional) 
     * @param phoneNumber (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @param isRedeemed (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    crypto_GetPublicCryptoTransactions(startDate: string | null | undefined, endDate: string | null | undefined, sessionId: string | null | undefined, atmId: string | null | undefined, phoneNumber: string | null | undefined, status: string | null | undefined, type: number | null | undefined, isRedeemed: boolean | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetPublicCryptoTransactionsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/public/transactions?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (isRedeemed !== undefined && isRedeemed !== null)
            url_ += "IsRedeemed=" + encodeURIComponent("" + isRedeemed) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_GetPublicCryptoTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_GetPublicCryptoTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPublicCryptoTransactionsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPublicCryptoTransactionsResponseModel>;
        }));
    }

    protected processCrypto_GetPublicCryptoTransactions(response: HttpResponseBase): Observable<GetPublicCryptoTransactionsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicCryptoTransactionsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Public Crypto Transaction Detail By Id
     */
    crypto_GetPublicCryptoTransactionDetailById(id: number): Observable<GetPublicCryptoTransactionDetailByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/public/transactions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_GetPublicCryptoTransactionDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_GetPublicCryptoTransactionDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPublicCryptoTransactionDetailByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPublicCryptoTransactionDetailByIdResponseModel>;
        }));
    }

    protected processCrypto_GetPublicCryptoTransactionDetailById(response: HttpResponseBase): Observable<GetPublicCryptoTransactionDetailByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicCryptoTransactionDetailByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Transactions
     */
    crypto_GetCryptoTransactionDetailById(id: number): Observable<GetCryptoTransactionDetailByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/transactions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_GetCryptoTransactionDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_GetCryptoTransactionDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCryptoTransactionDetailByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCryptoTransactionDetailByIdResponseModel>;
        }));
    }

    protected processCrypto_GetCryptoTransactionDetailById(response: HttpResponseBase): Observable<GetCryptoTransactionDetailByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCryptoTransactionDetailByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Refresh BlockChain Networks
     */
    crypto_RefreshBlockChainNetworks(): Observable<RefreshBlockChainNetworksResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_RefreshBlockChainNetworks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_RefreshBlockChainNetworks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshBlockChainNetworksResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshBlockChainNetworksResponseModel>;
        }));
    }

    protected processCrypto_RefreshBlockChainNetworks(response: HttpResponseBase): Observable<RefreshBlockChainNetworksResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshBlockChainNetworksResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Crypto Networks
     * @param isEnabled (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    crypto_GetCryptoNetworks(isEnabled: boolean | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetCryptoNetworksResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/networks?";
        if (isEnabled !== undefined && isEnabled !== null)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_GetCryptoNetworks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_GetCryptoNetworks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCryptoNetworksResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCryptoNetworksResponseModel>;
        }));
    }

    protected processCrypto_GetCryptoNetworks(response: HttpResponseBase): Observable<GetCryptoNetworksResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCryptoNetworksResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Crypto Networks
     * @param isBuy (optional) 
     * @param amount (optional) 
     * @param address (optional) 
     * @param currency (optional) 
     */
    crypto_GetCryptoQuote(isBuy: boolean | undefined, amount: number | undefined, address: string | null | undefined, currency: string | null | undefined): Observable<GetCryptoQuoteResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/quote?";
        if (isBuy === null)
            throw new globalThis.Error("The parameter 'isBuy' cannot be null.");
        else if (isBuy !== undefined)
            url_ += "IsBuy=" + encodeURIComponent("" + isBuy) + "&";
        if (amount === null)
            throw new globalThis.Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "Amount=" + encodeURIComponent("" + amount) + "&";
        if (address !== undefined && address !== null)
            url_ += "Address=" + encodeURIComponent("" + address) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "Currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_GetCryptoQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_GetCryptoQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCryptoQuoteResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCryptoQuoteResponseModel>;
        }));
    }

    protected processCrypto_GetCryptoQuote(response: HttpResponseBase): Observable<GetCryptoQuoteResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCryptoQuoteResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Crypto Quotes
     */
    crypto_CreateCryptoQuote(model: CreateCryptoQuoteRequestModel): Observable<CreateCryptoQuoteResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/quote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_CreateCryptoQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_CreateCryptoQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateCryptoQuoteResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateCryptoQuoteResponseModel>;
        }));
    }

    protected processCrypto_CreateCryptoQuote(response: HttpResponseBase): Observable<CreateCryptoQuoteResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCryptoQuoteResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Crypto Network Enabled
     */
    crypto_UpdateCryptoNetworkEnabled(id: number, model: UpdateCryptoNetworkEnableRequestModel): Observable<UpdateCryptoNetworkEnableResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/network/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_UpdateCryptoNetworkEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_UpdateCryptoNetworkEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCryptoNetworkEnableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCryptoNetworkEnableResponseModel>;
        }));
    }

    protected processCrypto_UpdateCryptoNetworkEnabled(response: HttpResponseBase): Observable<UpdateCryptoNetworkEnableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCryptoNetworkEnableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Crypto Token Enabled
     */
    crypto_UpdateCryptoTokenEnabled(id: number, model: UpdateCryptoTokenEnableRequestModel): Observable<UpdateCryptoTokenEnableResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/token/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_UpdateCryptoTokenEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_UpdateCryptoTokenEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCryptoTokenEnableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCryptoTokenEnableResponseModel>;
        }));
    }

    protected processCrypto_UpdateCryptoTokenEnabled(response: HttpResponseBase): Observable<UpdateCryptoTokenEnableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCryptoTokenEnableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verify Crypto Address
     */
    crypto_VerifyCryptoAddress(model: VerifyCryptoAddressRequestModel): Observable<VerifyCryptoAddressResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_VerifyCryptoAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_VerifyCryptoAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VerifyCryptoAddressResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VerifyCryptoAddressResponseModel>;
        }));
    }

    protected processCrypto_VerifyCryptoAddress(response: HttpResponseBase): Observable<VerifyCryptoAddressResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyCryptoAddressResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Redeem Quote
     */
    crypto_RedeemQuote(id: string): Observable<RedeemCryptoQuoteResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/redeem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_RedeemQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_RedeemQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedeemCryptoQuoteResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedeemCryptoQuoteResponseModel>;
        }));
    }

    protected processCrypto_RedeemQuote(response: HttpResponseBase): Observable<RedeemCryptoQuoteResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedeemCryptoQuoteResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Crypto Quote By Id
     * @param id (optional) 
     * @param sessionId (optional) 
     */
    crypto_GetCryptoQuoteById(id: string | null | undefined, sessionId: string | null | undefined): Observable<GetCryptoQuoteByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Crypto/quote/ById?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrypto_GetCryptoQuoteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrypto_GetCryptoQuoteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCryptoQuoteByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCryptoQuoteByIdResponseModel>;
        }));
    }

    protected processCrypto_GetCryptoQuoteById(response: HttpResponseBase): Observable<GetCryptoQuoteByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCryptoQuoteByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CurrencyAcceptorConfigClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get Currency Acceptor Config
     * @param atmId (optional) 
     */
    currencyAcceptorConfig_CurrencyAcceptorConfig(atmId: string | null | undefined): Observable<GetCurrencyAcceptorConfigsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CurrencyAcceptorConfig?";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrencyAcceptorConfig_CurrencyAcceptorConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrencyAcceptorConfig_CurrencyAcceptorConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrencyAcceptorConfigsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrencyAcceptorConfigsResponseModel>;
        }));
    }

    protected processCurrencyAcceptorConfig_CurrencyAcceptorConfig(response: HttpResponseBase): Observable<GetCurrencyAcceptorConfigsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrencyAcceptorConfigsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Currency Acceptor Config
     */
    currencyAcceptorConfig_UpdateCurrencyAcceptorConfig(model: UpdateCurrencyAcceptorConfigRequestModel): Observable<UpdateCurrencyAcceptorConfigResponseModel> {
        let url_ = this.baseUrl + "/api/v1/CurrencyAcceptorConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrencyAcceptorConfig_UpdateCurrencyAcceptorConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrencyAcceptorConfig_UpdateCurrencyAcceptorConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCurrencyAcceptorConfigResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCurrencyAcceptorConfigResponseModel>;
        }));
    }

    protected processCurrencyAcceptorConfig_UpdateCurrencyAcceptorConfig(response: HttpResponseBase): Observable<UpdateCurrencyAcceptorConfigResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCurrencyAcceptorConfigResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get Dashboard KPI
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param atmId (optional) 
     * @param regionId (optional) 
     */
    dashboard_GetDashboardKpi(startDate: string | null | undefined, endDate: string | null | undefined, atmId: string | null | undefined, regionId: number | null | undefined): Observable<GetDashboardKpiResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/kpi?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (regionId !== undefined && regionId !== null)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetDashboardKpi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetDashboardKpi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardKpiResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardKpiResponseModel>;
        }));
    }

    protected processDashboard_GetDashboardKpi(response: HttpResponseBase): Observable<GetDashboardKpiResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardKpiResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Dashboard Public Kpi
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param atmId (optional) 
     * @param type (optional) 
     * @param operatorType (optional) 
     */
    dashboard_GetDashboardPublicKpi(startDate: string | null | undefined, endDate: string | null | undefined, atmId: string | null | undefined, type: number | null | undefined, operatorType: number | null | undefined): Observable<GetDashboardPublicKpiResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/public/kpi?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (operatorType !== undefined && operatorType !== null)
            url_ += "OperatorType=" + encodeURIComponent("" + operatorType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetDashboardPublicKpi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetDashboardPublicKpi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardPublicKpiResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardPublicKpiResponseModel>;
        }));
    }

    protected processDashboard_GetDashboardPublicKpi(response: HttpResponseBase): Observable<GetDashboardPublicKpiResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardPublicKpiResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DenominationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get Denominations
     */
    denomination_GetDenominationByAtm(): Observable<GetDenominationRecordsByAtmResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Denomination/atm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDenomination_GetDenominationByAtm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDenomination_GetDenominationByAtm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDenominationRecordsByAtmResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDenominationRecordsByAtmResponseModel>;
        }));
    }

    protected processDenomination_GetDenominationByAtm(response: HttpResponseBase): Observable<GetDenominationRecordsByAtmResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDenominationRecordsByAtmResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Denomination By AtmId
     */
    denomination_GetDenominationByAtmId(id: string): Observable<GetDenominationRecordsByAtmResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Denomination/atm/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDenomination_GetDenominationByAtmId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDenomination_GetDenominationByAtmId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDenominationRecordsByAtmResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDenominationRecordsByAtmResponseModel>;
        }));
    }

    protected processDenomination_GetDenominationByAtmId(response: HttpResponseBase): Observable<GetDenominationRecordsByAtmResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDenominationRecordsByAtmResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Denomination Changes
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sessionId (optional) 
     * @param atmId (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    denomination_GetDenominationChangesByAtm(startDate: string | null | undefined, endDate: string | null | undefined, sessionId: string | null | undefined, atmId: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetDenominationRecordChangesResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Denomination/changes?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDenomination_GetDenominationChangesByAtm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDenomination_GetDenominationChangesByAtm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDenominationRecordChangesResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDenominationRecordChangesResponseModel>;
        }));
    }

    protected processDenomination_GetDenominationChangesByAtm(response: HttpResponseBase): Observable<GetDenominationRecordChangesResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDenominationRecordChangesResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save Denominations
     */
    denomination_SaveDenominations(model: SaveDenominationRecordsRequestModel): Observable<SaveDenominationRecordsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Denomination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDenomination_SaveDenominations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDenomination_SaveDenominations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveDenominationRecordsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveDenominationRecordsResponseModel>;
        }));
    }

    protected processDenomination_SaveDenominations(response: HttpResponseBase): Observable<SaveDenominationRecordsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveDenominationRecordsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ImageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Create Image
     */
    image_CreateImage(model: CreateAppSessionImageRequestModel): Observable<CreateAppSessionImageResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImage_CreateImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImage_CreateImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAppSessionImageResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAppSessionImageResponseModel>;
        }));
    }

    protected processImage_CreateImage(response: HttpResponseBase): Observable<CreateAppSessionImageResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAppSessionImageResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Images
     * @param atmId (optional) 
     * @param sessionId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    image_GetImages(atmId: string | null | undefined, sessionId: string | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetAppSessionImagesResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Image?";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImage_GetImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImage_GetImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAppSessionImagesResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAppSessionImagesResponseModel>;
        }));
    }

    protected processImage_GetImages(response: HttpResponseBase): Observable<GetAppSessionImagesResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppSessionImagesResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InvestorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    investors_GetInvestors(isEnabled: boolean | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetInvestorsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors?";
        if (isEnabled !== undefined && isEnabled !== null)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_GetInvestors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_GetInvestors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInvestorsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInvestorsResponseModel>;
        }));
    }

    protected processInvestors_GetInvestors(response: HttpResponseBase): Observable<GetInvestorsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInvestorsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_CreateInvestor(model: CreateInvestorRequestModel): Observable<CreateInvestorResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_CreateInvestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_CreateInvestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateInvestorResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateInvestorResponseModel>;
        }));
    }

    protected processInvestors_CreateInvestor(response: HttpResponseBase): Observable<CreateInvestorResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateInvestorResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_GetInvestorById(id: string): Observable<GetInvestorByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_GetInvestorById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_GetInvestorById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInvestorByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInvestorByIdResponseModel>;
        }));
    }

    protected processInvestors_GetInvestorById(response: HttpResponseBase): Observable<GetInvestorByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInvestorByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_UpdateInvestor(id: string, model: UpdateInvestorRequestModel): Observable<UpdateInvestorResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_UpdateInvestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_UpdateInvestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateInvestorResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateInvestorResponseModel>;
        }));
    }

    protected processInvestors_UpdateInvestor(response: HttpResponseBase): Observable<UpdateInvestorResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateInvestorResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_GetInvestorAtms(investorId: string): Observable<GetInvestorAtmsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/{investorId}/atms";
        if (investorId === undefined || investorId === null)
            throw new globalThis.Error("The parameter 'investorId' must be defined.");
        url_ = url_.replace("{investorId}", encodeURIComponent("" + investorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_GetInvestorAtms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_GetInvestorAtms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInvestorAtmsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInvestorAtmsResponseModel>;
        }));
    }

    protected processInvestors_GetInvestorAtms(response: HttpResponseBase): Observable<GetInvestorAtmsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInvestorAtmsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_AssignToAtm(model: AssignInvestorToAtmRequestModel): Observable<AssignInvestorToAtmResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/atm-assignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_AssignToAtm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_AssignToAtm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignInvestorToAtmResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignInvestorToAtmResponseModel>;
        }));
    }

    protected processInvestors_AssignToAtm(response: HttpResponseBase): Observable<AssignInvestorToAtmResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignInvestorToAtmResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_RemoveFromAtm(investorId: string, atmId: string): Observable<RemoveInvestorFromAtmResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/atm-assignments/{investorId}/atm/{atmId}";
        if (investorId === undefined || investorId === null)
            throw new globalThis.Error("The parameter 'investorId' must be defined.");
        url_ = url_.replace("{investorId}", encodeURIComponent("" + investorId));
        if (atmId === undefined || atmId === null)
            throw new globalThis.Error("The parameter 'atmId' must be defined.");
        url_ = url_.replace("{atmId}", encodeURIComponent("" + atmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_RemoveFromAtm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_RemoveFromAtm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveInvestorFromAtmResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveInvestorFromAtmResponseModel>;
        }));
    }

    protected processInvestors_RemoveFromAtm(response: HttpResponseBase): Observable<RemoveInvestorFromAtmResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoveInvestorFromAtmResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_GetDashboard(): Observable<GetInvestorDashboardResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_GetDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_GetDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInvestorDashboardResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInvestorDashboardResponseModel>;
        }));
    }

    protected processInvestors_GetDashboard(response: HttpResponseBase): Observable<GetInvestorDashboardResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInvestorDashboardResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_GetTransactions(dateFrom: string | null | undefined, dateTo: string | null | undefined, atmId: string | null | undefined, investorId: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetInvestorTransactionsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/transactions?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (investorId !== undefined && investorId !== null)
            url_ += "InvestorId=" + encodeURIComponent("" + investorId) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_GetTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_GetTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInvestorTransactionsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInvestorTransactionsResponseModel>;
        }));
    }

    protected processInvestors_GetTransactions(response: HttpResponseBase): Observable<GetInvestorTransactionsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInvestorTransactionsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_GetMyAtms(): Observable<GetMyInvestorAtmsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/my-atms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_GetMyAtms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_GetMyAtms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMyInvestorAtmsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMyInvestorAtmsResponseModel>;
        }));
    }

    protected processInvestors_GetMyAtms(response: HttpResponseBase): Observable<GetMyInvestorAtmsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyInvestorAtmsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_UpdateProfile(model: UpdateInvestorProfileRequestModel): Observable<UpdateInvestorProfileResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_UpdateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_UpdateProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateInvestorProfileResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateInvestorProfileResponseModel>;
        }));
    }

    protected processInvestors_UpdateProfile(response: HttpResponseBase): Observable<UpdateInvestorProfileResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateInvestorProfileResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_CreateWithdrawalRequest(model: CreateWithdrawalRequestModel): Observable<CreateWithdrawalResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/withdrawal-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_CreateWithdrawalRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_CreateWithdrawalRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWithdrawalResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWithdrawalResponseModel>;
        }));
    }

    protected processInvestors_CreateWithdrawalRequest(response: HttpResponseBase): Observable<CreateWithdrawalResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWithdrawalResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_GetMyWithdrawalRequests(status: number | null | undefined, requestedById: string | null | undefined, dateFrom: string | null | undefined, dateTo: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetWithdrawalRequestsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/withdrawal-requests?";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (requestedById !== undefined && requestedById !== null)
            url_ += "RequestedById=" + encodeURIComponent("" + requestedById) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_GetMyWithdrawalRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_GetMyWithdrawalRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWithdrawalRequestsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWithdrawalRequestsResponseModel>;
        }));
    }

    protected processInvestors_GetMyWithdrawalRequests(response: HttpResponseBase): Observable<GetWithdrawalRequestsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWithdrawalRequestsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_CancelWithdrawalRequest(id: number): Observable<CancelWithdrawalResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/withdrawal-requests/{id}/cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_CancelWithdrawalRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_CancelWithdrawalRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelWithdrawalResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelWithdrawalResponseModel>;
        }));
    }

    protected processInvestors_CancelWithdrawalRequest(response: HttpResponseBase): Observable<CancelWithdrawalResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelWithdrawalResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    investors_GetAtmInvestors(atmId: string): Observable<GetAtmInvestorsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Investors/investors/{atmId}";
        if (atmId === undefined || atmId === null)
            throw new globalThis.Error("The parameter 'atmId' must be defined.");
        url_ = url_.replace("{atmId}", encodeURIComponent("" + atmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvestors_GetAtmInvestors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvestors_GetAtmInvestors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmInvestorsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmInvestorsResponseModel>;
        }));
    }

    protected processInvestors_GetAtmInvestors(response: HttpResponseBase): Observable<GetAtmInvestorsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmInvestorsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class IpWhitelistClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Allowlist entries, whether it is enforced, and the caller's IP
     */
    ipWhitelist_Get(): Observable<GetIpWhitelistResponseModel> {
        let url_ = this.baseUrl + "/api/v1/IpWhitelist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIpWhitelist_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIpWhitelist_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIpWhitelistResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIpWhitelistResponseModel>;
        }));
    }

    protected processIpWhitelist_Get(response: HttpResponseBase): Observable<GetIpWhitelistResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIpWhitelistResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add an IP address or CIDR range
     */
    ipWhitelist_Create(model: CreateIpWhitelistEntryRequestModel): Observable<IpWhitelistEntryResponseModel> {
        let url_ = this.baseUrl + "/api/v1/IpWhitelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIpWhitelist_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIpWhitelist_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IpWhitelistEntryResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IpWhitelistEntryResponseModel>;
        }));
    }

    protected processIpWhitelist_Create(response: HttpResponseBase): Observable<IpWhitelistEntryResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IpWhitelistEntryResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Turn enforcement on or off (refused when it would block the caller)
     */
    ipWhitelist_UpdateSettings(model: UpdateIpWhitelistSettingsRequestModel): Observable<GetIpWhitelistResponseModel> {
        let url_ = this.baseUrl + "/api/v1/IpWhitelist/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIpWhitelist_UpdateSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIpWhitelist_UpdateSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIpWhitelistResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIpWhitelistResponseModel>;
        }));
    }

    protected processIpWhitelist_UpdateSettings(response: HttpResponseBase): Observable<GetIpWhitelistResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIpWhitelistResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an entry
     */
    ipWhitelist_Update(id: number, model: UpdateIpWhitelistEntryRequestModel): Observable<IpWhitelistEntryResponseModel> {
        let url_ = this.baseUrl + "/api/v1/IpWhitelist/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIpWhitelist_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIpWhitelist_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IpWhitelistEntryResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IpWhitelistEntryResponseModel>;
        }));
    }

    protected processIpWhitelist_Update(response: HttpResponseBase): Observable<IpWhitelistEntryResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IpWhitelistEntryResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete an entry
     */
    ipWhitelist_Delete(id: number): Observable<DeleteIpWhitelistEntryResponseModel> {
        let url_ = this.baseUrl + "/api/v1/IpWhitelist/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIpWhitelist_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIpWhitelist_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteIpWhitelistEntryResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteIpWhitelistEntryResponseModel>;
        }));
    }

    protected processIpWhitelist_Delete(response: HttpResponseBase): Observable<DeleteIpWhitelistEntryResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteIpWhitelistEntryResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class KycClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Create Kyc
     */
    kyc_CreateKyc(model: CreateAppSessionKycRequestModel): Observable<CreateAppSessionKycResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Kyc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKyc_CreateKyc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKyc_CreateKyc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAppSessionKycResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAppSessionKycResponseModel>;
        }));
    }

    protected processKyc_CreateKyc(response: HttpResponseBase): Observable<CreateAppSessionKycResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAppSessionKycResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Kycs
     * @param sessionId (optional) 
     * @param atmId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    kyc_GetKyc(sessionId: string | null | undefined, atmId: string | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetAppSessionKycsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Kyc?";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKyc_GetKyc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKyc_GetKyc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAppSessionKycsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAppSessionKycsResponseModel>;
        }));
    }

    protected processKyc_GetKyc(response: HttpResponseBase): Observable<GetAppSessionKycsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppSessionKycsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class M2UClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Login to M2U (generates and caches access token)
     */
    m2U_Login(model: M2ULoginRequestModel): Observable<M2ULoginResponseModel> {
        let url_ = this.baseUrl + "/api/v1/M2U/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processM2U_Login(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processM2U_Login(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<M2ULoginResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<M2ULoginResponseModel>;
        }));
    }

    protected processM2U_Login(response: HttpResponseBase): Observable<M2ULoginResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = M2ULoginResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get teller data
     */
    m2U_GetTellerData(): Observable<GetM2UTellerDataResponseModel> {
        let url_ = this.baseUrl + "/api/v1/M2U/teller";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processM2U_GetTellerData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processM2U_GetTellerData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetM2UTellerDataResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetM2UTellerDataResponseModel>;
        }));
    }

    protected processM2U_GetTellerData(response: HttpResponseBase): Observable<GetM2UTellerDataResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetM2UTellerDataResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get transfer confirmation (fees breakdown before proceeding)
     * @param amount (optional) 
     * @param targetType (optional) 
     * @param targetCurrency (optional) 
     * @param sourceWallet (optional) 
     * @param countryCode (optional) 
     */
    m2U_GetTransferConfirmation(amount: string | null | undefined, targetType: string | null | undefined, targetCurrency: string | null | undefined, sourceWallet: string | null | undefined, countryCode: string | null | undefined): Observable<GetM2UTransferConfirmationResponseModel> {
        let url_ = this.baseUrl + "/api/v1/M2U/transfer/confirmation?";
        if (amount !== undefined && amount !== null)
            url_ += "Amount=" + encodeURIComponent("" + amount) + "&";
        if (targetType !== undefined && targetType !== null)
            url_ += "TargetType=" + encodeURIComponent("" + targetType) + "&";
        if (targetCurrency !== undefined && targetCurrency !== null)
            url_ += "TargetCurrency=" + encodeURIComponent("" + targetCurrency) + "&";
        if (sourceWallet !== undefined && sourceWallet !== null)
            url_ += "SourceWallet=" + encodeURIComponent("" + sourceWallet) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processM2U_GetTransferConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processM2U_GetTransferConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetM2UTransferConfirmationResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetM2UTransferConfirmationResponseModel>;
        }));
    }

    protected processM2U_GetTransferConfirmation(response: HttpResponseBase): Observable<GetM2UTransferConfirmationResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetM2UTransferConfirmationResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add money to a customer wallet
     */
    m2U_AddMoney(model: M2UAddMoneyRequestModel): Observable<M2UAddMoneyResponseModel> {
        let url_ = this.baseUrl + "/api/v1/M2U/wallet/add-money";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processM2U_AddMoney(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processM2U_AddMoney(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<M2UAddMoneyResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<M2UAddMoneyResponseModel>;
        }));
    }

    protected processM2U_AddMoney(response: HttpResponseBase): Observable<M2UAddMoneyResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = M2UAddMoneyResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Find a cash user by phone number
     */
    m2U_FindCashUser(phoneNumber: string): Observable<FindM2UCashUserResponseModel> {
        let url_ = this.baseUrl + "/api/v1/M2U/user/find/{phoneNumber}";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new globalThis.Error("The parameter 'phoneNumber' must be defined.");
        url_ = url_.replace("{phoneNumber}", encodeURIComponent("" + phoneNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processM2U_FindCashUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processM2U_FindCashUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FindM2UCashUserResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FindM2UCashUserResponseModel>;
        }));
    }

    protected processM2U_FindCashUser(response: HttpResponseBase): Observable<FindM2UCashUserResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FindM2UCashUserResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Locate a user by PID
     */
    m2U_LocateUser(pid: string): Observable<LocateM2UUserResponseModel> {
        let url_ = this.baseUrl + "/api/v1/M2U/user/{pid}";
        if (pid === undefined || pid === null)
            throw new globalThis.Error("The parameter 'pid' must be defined.");
        url_ = url_.replace("{pid}", encodeURIComponent("" + pid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processM2U_LocateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processM2U_LocateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocateM2UUserResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocateM2UUserResponseModel>;
        }));
    }

    protected processM2U_LocateUser(response: HttpResponseBase): Observable<LocateM2UUserResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocateM2UUserResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send cash to a customer
     */
    m2U_SendCash(model: M2USendCashRequestModel): Observable<M2USendCashResponseModel> {
        let url_ = this.baseUrl + "/api/v1/M2U/cash/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processM2U_SendCash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processM2U_SendCash(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<M2USendCashResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<M2USendCashResponseModel>;
        }));
    }

    protected processM2U_SendCash(response: HttpResponseBase): Observable<M2USendCashResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = M2USendCashResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get cash transfer status by voucher number and security code
     * @param voucherNumber (optional) 
     * @param securityCode (optional) 
     */
    m2U_GetCashTransferStatus(voucherNumber: string | null | undefined, securityCode: string | null | undefined): Observable<GetM2UCashTransferStatusResponseModel> {
        let url_ = this.baseUrl + "/api/v1/M2U/cash/status?";
        if (voucherNumber !== undefined && voucherNumber !== null)
            url_ += "VoucherNumber=" + encodeURIComponent("" + voucherNumber) + "&";
        if (securityCode !== undefined && securityCode !== null)
            url_ += "SecurityCode=" + encodeURIComponent("" + securityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processM2U_GetCashTransferStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processM2U_GetCashTransferStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetM2UCashTransferStatusResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetM2UCashTransferStatusResponseModel>;
        }));
    }

    protected processM2U_GetCashTransferStatus(response: HttpResponseBase): Observable<GetM2UCashTransferStatusResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetM2UCashTransferStatusResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pay cash to a customer who has received a cash transfer
     */
    m2U_PayCash(model: M2UPayCashRequestModel): Observable<M2UPayCashResponseModel> {
        let url_ = this.baseUrl + "/api/v1/M2U/cash/pay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processM2U_PayCash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processM2U_PayCash(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<M2UPayCashResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<M2UPayCashResponseModel>;
        }));
    }

    protected processM2U_PayCash(response: HttpResponseBase): Observable<M2UPayCashResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = M2UPayCashResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel a pending cash transfer
     */
    m2U_CancelCash(model: M2UCancelCashRequestModel): Observable<M2UCancelCashResponseModel> {
        let url_ = this.baseUrl + "/api/v1/M2U/cash/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processM2U_CancelCash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processM2U_CancelCash(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<M2UCancelCashResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<M2UCancelCashResponseModel>;
        }));
    }

    protected processM2U_CancelCash(response: HttpResponseBase): Observable<M2UCancelCashResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = M2UCancelCashResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Modify a pending cash transfer
     */
    m2U_ModifyCash(model: M2UModifyCashRequestModel): Observable<M2UModifyCashResponseModel> {
        let url_ = this.baseUrl + "/api/v1/M2U/cash/modify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processM2U_ModifyCash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processM2U_ModifyCash(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<M2UModifyCashResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<M2UModifyCashResponseModel>;
        }));
    }

    protected processM2U_ModifyCash(response: HttpResponseBase): Observable<M2UModifyCashResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = M2UModifyCashResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MojoPayClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Initiate a MojoPay collection payment (customer pays via mobile money)
     */
    mojoPay_InitPayment(model: MojoPayInitPaymentRequestModel): Observable<MojoPayInitPaymentResponseModel> {
        let url_ = this.baseUrl + "/api/v1/MojoPay/payment/init";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMojoPay_InitPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMojoPay_InitPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MojoPayInitPaymentResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MojoPayInitPaymentResponseModel>;
        }));
    }

    protected processMojoPay_InitPayment(response: HttpResponseBase): Observable<MojoPayInitPaymentResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MojoPayInitPaymentResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query collection transaction status from MojoPay
     */
    mojoPay_GetTransactionStatus(orderId: string): Observable<MojoPayGetTransactionStatusResponseModel> {
        let url_ = this.baseUrl + "/api/v1/MojoPay/payment/status/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMojoPay_GetTransactionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMojoPay_GetTransactionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MojoPayGetTransactionStatusResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MojoPayGetTransactionStatusResponseModel>;
        }));
    }

    protected processMojoPay_GetTransactionStatus(response: HttpResponseBase): Observable<MojoPayGetTransactionStatusResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MojoPayGetTransactionStatusResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Callback endpoint for MojoPay payment notifications
     */
    mojoPay_Callback(payload: MojoPayCallbackDto): Observable<MojoPayHandleCallbackResponseModel> {
        let url_ = this.baseUrl + "/api/v1/MojoPay/callback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMojoPay_Callback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMojoPay_Callback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MojoPayHandleCallbackResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MojoPayHandleCallbackResponseModel>;
        }));
    }

    protected processMojoPay_Callback(response: HttpResponseBase): Observable<MojoPayHandleCallbackResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MojoPayHandleCallbackResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Initiate a MoMo disbursement (cashout to mobile money wallet)
     */
    mojoPay_DisburseMomo(model: MojoPayDisburseMomoRequestModel): Observable<MojoPayDisburseMomoResponseModel> {
        let url_ = this.baseUrl + "/api/v1/MojoPay/disburse/momo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMojoPay_DisburseMomo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMojoPay_DisburseMomo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MojoPayDisburseMomoResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MojoPayDisburseMomoResponseModel>;
        }));
    }

    protected processMojoPay_DisburseMomo(response: HttpResponseBase): Observable<MojoPayDisburseMomoResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MojoPayDisburseMomoResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Initiate a bank transfer disbursement
     */
    mojoPay_DisburseBank(model: MojoPayDisburseBankRequestModel): Observable<MojoPayDisburseBankResponseModel> {
        let url_ = this.baseUrl + "/api/v1/MojoPay/disburse/bank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMojoPay_DisburseBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMojoPay_DisburseBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MojoPayDisburseBankResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MojoPayDisburseBankResponseModel>;
        }));
    }

    protected processMojoPay_DisburseBank(response: HttpResponseBase): Observable<MojoPayDisburseBankResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MojoPayDisburseBankResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query disbursement transaction status from MojoPay
     */
    mojoPay_GetDisbursementStatus(orderId: string): Observable<MojoPayGetDisbursementStatusResponseModel> {
        let url_ = this.baseUrl + "/api/v1/MojoPay/disburse/status/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMojoPay_GetDisbursementStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMojoPay_GetDisbursementStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MojoPayGetDisbursementStatusResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MojoPayGetDisbursementStatusResponseModel>;
        }));
    }

    protected processMojoPay_GetDisbursementStatus(response: HttpResponseBase): Observable<MojoPayGetDisbursementStatusResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MojoPayGetDisbursementStatusResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Callback endpoint for MojoPay disbursement/cashout notifications
     */
    mojoPay_DisbursementCallback(payload: MojoPayDisbursementCallbackDto): Observable<MojoPayHandleDisbursementCallbackResponseModel> {
        let url_ = this.baseUrl + "/api/v1/MojoPay/callback/disbursement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMojoPay_DisbursementCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMojoPay_DisbursementCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MojoPayHandleDisbursementCallbackResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MojoPayHandleDisbursementCallbackResponseModel>;
        }));
    }

    protected processMojoPay_DisbursementCallback(response: HttpResponseBase): Observable<MojoPayHandleDisbursementCallbackResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MojoPayHandleDisbursementCallbackResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the list of supported banks for Ghana
     */
    mojoPay_GetBankList(countryCode: string): Observable<MojoPayGetBankListResponseModel> {
        let url_ = this.baseUrl + "/api/v1/MojoPay/banks/{countryCode}";
        if (countryCode === undefined || countryCode === null)
            throw new globalThis.Error("The parameter 'countryCode' must be defined.");
        url_ = url_.replace("{countryCode}", encodeURIComponent("" + countryCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMojoPay_GetBankList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMojoPay_GetBankList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MojoPayGetBankListResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MojoPayGetBankListResponseModel>;
        }));
    }

    protected processMojoPay_GetBankList(response: HttpResponseBase): Observable<MojoPayGetBankListResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MojoPayGetBankListResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check the MojoPay merchant account balance
     */
    mojoPay_CheckBalance(currency: string): Observable<MojoPayCheckBalanceResponseModel> {
        let url_ = this.baseUrl + "/api/v1/MojoPay/balance/{currency}";
        if (currency === undefined || currency === null)
            throw new globalThis.Error("The parameter 'currency' must be defined.");
        url_ = url_.replace("{currency}", encodeURIComponent("" + currency));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMojoPay_CheckBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMojoPay_CheckBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MojoPayCheckBalanceResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MojoPayCheckBalanceResponseModel>;
        }));
    }

    protected processMojoPay_CheckBalance(response: HttpResponseBase): Observable<MojoPayCheckBalanceResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MojoPayCheckBalanceResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Look up a bank account holder name (KYC)
     */
    mojoPay_BankKyc(model: MojoPayBankKycRequestModel): Observable<MojoPayKycResponseModel> {
        let url_ = this.baseUrl + "/api/v1/MojoPay/kyc/bank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMojoPay_BankKyc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMojoPay_BankKyc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MojoPayKycResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MojoPayKycResponseModel>;
        }));
    }

    protected processMojoPay_BankKyc(response: HttpResponseBase): Observable<MojoPayKycResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MojoPayKycResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Look up a mobile money account holder name (KYC)
     */
    mojoPay_MomoKyc(model: MojoPayMomoKycRequestModel): Observable<MojoPayKycResponseModel> {
        let url_ = this.baseUrl + "/api/v1/MojoPay/kyc/momo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMojoPay_MomoKyc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMojoPay_MomoKyc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MojoPayKycResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MojoPayKycResponseModel>;
        }));
    }

    protected processMojoPay_MomoKyc(response: HttpResponseBase): Observable<MojoPayKycResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MojoPayKycResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MtnClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Generate Token
     */
    mtn_GenerateToken(model: GenerateTokenRequestModel): Observable<GenerateTokenResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Mtn/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMtn_GenerateToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMtn_GenerateToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateTokenResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateTokenResponseModel>;
        }));
    }

    protected processMtn_GenerateToken(response: HttpResponseBase): Observable<GenerateTokenResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateTokenResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Mtn Balance
     */
    mtn_GetBalance(): Observable<GetMtnBalanceResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Mtn/balance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMtn_GetBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMtn_GetBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMtnBalanceResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMtnBalanceResponseModel>;
        }));
    }

    protected processMtn_GetBalance(response: HttpResponseBase): Observable<GetMtnBalanceResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMtnBalanceResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Withdraw Request
     */
    mtn_CreateWithdrawRequest(model: CreateWithdrawRequestRequestModel): Observable<CreateWithdrawRequestResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Mtn/withdraw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMtn_CreateWithdrawRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMtn_CreateWithdrawRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWithdrawRequestResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWithdrawRequestResponseModel>;
        }));
    }

    protected processMtn_CreateWithdrawRequest(response: HttpResponseBase): Observable<CreateWithdrawRequestResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWithdrawRequestResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Mtn UserInfo
     */
    mtn_GetUserInfo(phoneNumber: string): Observable<GetMtnUserInfoResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Mtn/user/{phoneNumber}";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new globalThis.Error("The parameter 'phoneNumber' must be defined.");
        url_ = url_.replace("{phoneNumber}", encodeURIComponent("" + phoneNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMtn_GetUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMtn_GetUserInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMtnUserInfoResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMtnUserInfoResponseModel>;
        }));
    }

    protected processMtn_GetUserInfo(response: HttpResponseBase): Observable<GetMtnUserInfoResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMtnUserInfoResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Mtn Transaction Info
     */
    mtn_GetTransactionInfo(transactionId: string): Observable<GetMtnTransactionResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Mtn/transaction/{transactionId}";
        if (transactionId === undefined || transactionId === null)
            throw new globalThis.Error("The parameter 'transactionId' must be defined.");
        url_ = url_.replace("{transactionId}", encodeURIComponent("" + transactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMtn_GetTransactionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMtn_GetTransactionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMtnTransactionResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMtnTransactionResponseModel>;
        }));
    }

    protected processMtn_GetTransactionInfo(response: HttpResponseBase): Observable<GetMtnTransactionResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMtnTransactionResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Transfer Request
     */
    mtn_CreateTransferRequest(model: CreateTransferRequestRequestModel): Observable<CreateTransferRequestResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Mtn/transfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMtn_CreateTransferRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMtn_CreateTransferRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTransferRequestResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTransferRequestResponseModel>;
        }));
    }

    protected processMtn_CreateTransferRequest(response: HttpResponseBase): Observable<CreateTransferRequestResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTransferRequestResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Process Web Hook
     */
    mtn_ProcessWebHook(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Mtn/webhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMtn_ProcessWebHook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMtn_ProcessWebHook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMtn_ProcessWebHook(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PartnersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    partners_GetPartners(isEnabled: boolean | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetPartnersResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners?";
        if (isEnabled !== undefined && isEnabled !== null)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_GetPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_GetPartners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPartnersResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPartnersResponseModel>;
        }));
    }

    protected processPartners_GetPartners(response: HttpResponseBase): Observable<GetPartnersResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPartnersResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_CreatePartner(model: CreatePartnerRequestModel): Observable<CreatePartnerResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_CreatePartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_CreatePartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePartnerResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePartnerResponseModel>;
        }));
    }

    protected processPartners_CreatePartner(response: HttpResponseBase): Observable<CreatePartnerResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePartnerResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_GetPartnerById(id: string): Observable<GetPartnerByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_GetPartnerById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_GetPartnerById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPartnerByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPartnerByIdResponseModel>;
        }));
    }

    protected processPartners_GetPartnerById(response: HttpResponseBase): Observable<GetPartnerByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPartnerByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_UpdatePartner(id: string, model: UpdatePartnerRequestModel): Observable<UpdatePartnerResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_UpdatePartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_UpdatePartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePartnerResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePartnerResponseModel>;
        }));
    }

    protected processPartners_UpdatePartner(response: HttpResponseBase): Observable<UpdatePartnerResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePartnerResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_GetPartnerAtms(partnerId: string): Observable<GetPartnerAtmsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/{partnerId}/atms";
        if (partnerId === undefined || partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_GetPartnerAtms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_GetPartnerAtms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPartnerAtmsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPartnerAtmsResponseModel>;
        }));
    }

    protected processPartners_GetPartnerAtms(response: HttpResponseBase): Observable<GetPartnerAtmsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPartnerAtmsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_GetAtmPartners(atmId: string): Observable<GetAtmPartnersResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/atms/{atmId}/partners";
        if (atmId === undefined || atmId === null)
            throw new globalThis.Error("The parameter 'atmId' must be defined.");
        url_ = url_.replace("{atmId}", encodeURIComponent("" + atmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_GetAtmPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_GetAtmPartners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmPartnersResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmPartnersResponseModel>;
        }));
    }

    protected processPartners_GetAtmPartners(response: HttpResponseBase): Observable<GetAtmPartnersResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmPartnersResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_AssignToAtm(model: AssignPartnerToAtmRequestModel): Observable<AssignPartnerToAtmResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/atm-assignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_AssignToAtm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_AssignToAtm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignPartnerToAtmResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignPartnerToAtmResponseModel>;
        }));
    }

    protected processPartners_AssignToAtm(response: HttpResponseBase): Observable<AssignPartnerToAtmResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignPartnerToAtmResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_RemoveFromAtm(atmId: string, partnerId: string): Observable<RemovePartnerFromAtmResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/atm-assignments/{atmId}/{partnerId}";
        if (atmId === undefined || atmId === null)
            throw new globalThis.Error("The parameter 'atmId' must be defined.");
        url_ = url_.replace("{atmId}", encodeURIComponent("" + atmId));
        if (partnerId === undefined || partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_RemoveFromAtm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_RemoveFromAtm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemovePartnerFromAtmResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemovePartnerFromAtmResponseModel>;
        }));
    }

    protected processPartners_RemoveFromAtm(response: HttpResponseBase): Observable<RemovePartnerFromAtmResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemovePartnerFromAtmResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_GetShares(atmId: string): Observable<GetAtmProfitSharesResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/atm-assignments/{atmId}/shares";
        if (atmId === undefined || atmId === null)
            throw new globalThis.Error("The parameter 'atmId' must be defined.");
        url_ = url_.replace("{atmId}", encodeURIComponent("" + atmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_GetShares(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_GetShares(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmProfitSharesResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmProfitSharesResponseModel>;
        }));
    }

    protected processPartners_GetShares(response: HttpResponseBase): Observable<GetAtmProfitSharesResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmProfitSharesResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_SetShares(model: SetAtmProfitSharesRequestModel): Observable<SetAtmProfitSharesResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/atm-assignments/shares";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_SetShares(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_SetShares(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetAtmProfitSharesResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetAtmProfitSharesResponseModel>;
        }));
    }

    protected processPartners_SetShares(response: HttpResponseBase): Observable<SetAtmProfitSharesResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetAtmProfitSharesResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_GetPartnerAtmServices(partnerId: string, atmId: string): Observable<GetPartnerAtmServicesResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/{partnerId}/atm-assignments/{atmId}/services";
        if (partnerId === undefined || partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        if (atmId === undefined || atmId === null)
            throw new globalThis.Error("The parameter 'atmId' must be defined.");
        url_ = url_.replace("{atmId}", encodeURIComponent("" + atmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_GetPartnerAtmServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_GetPartnerAtmServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPartnerAtmServicesResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPartnerAtmServicesResponseModel>;
        }));
    }

    protected processPartners_GetPartnerAtmServices(response: HttpResponseBase): Observable<GetPartnerAtmServicesResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPartnerAtmServicesResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_AssignService(model: AssignPartnerAtmServiceRequestModel): Observable<AssignPartnerAtmServiceResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/atm-assignments/services";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_AssignService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_AssignService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignPartnerAtmServiceResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignPartnerAtmServiceResponseModel>;
        }));
    }

    protected processPartners_AssignService(response: HttpResponseBase): Observable<AssignPartnerAtmServiceResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignPartnerAtmServiceResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_RemoveService(partnerId: string, atmId: string, serviceType: AtmFunctionType): Observable<RemovePartnerAtmServiceResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/{partnerId}/atm-assignments/{atmId}/services/{serviceType}";
        if (partnerId === undefined || partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        if (atmId === undefined || atmId === null)
            throw new globalThis.Error("The parameter 'atmId' must be defined.");
        url_ = url_.replace("{atmId}", encodeURIComponent("" + atmId));
        if (serviceType === undefined || serviceType === null)
            throw new globalThis.Error("The parameter 'serviceType' must be defined.");
        url_ = url_.replace("{serviceType}", encodeURIComponent("" + serviceType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_RemoveService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_RemoveService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemovePartnerAtmServiceResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemovePartnerAtmServiceResponseModel>;
        }));
    }

    protected processPartners_RemoveService(response: HttpResponseBase): Observable<RemovePartnerAtmServiceResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemovePartnerAtmServiceResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_GetDashboard(): Observable<GetPartnerDashboardResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_GetDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_GetDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPartnerDashboardResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPartnerDashboardResponseModel>;
        }));
    }

    protected processPartners_GetDashboard(response: HttpResponseBase): Observable<GetPartnerDashboardResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPartnerDashboardResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_GetMyAtms(): Observable<GetPartnerAtmsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/my-atms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_GetMyAtms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_GetMyAtms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPartnerAtmsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPartnerAtmsResponseModel>;
        }));
    }

    protected processPartners_GetMyAtms(response: HttpResponseBase): Observable<GetPartnerAtmsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPartnerAtmsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_GetTransactions(dateFrom: string | null | undefined, dateTo: string | null | undefined, atmId: string | null | undefined, partnerId: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetPartnerTransactionsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/transactions?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (partnerId !== undefined && partnerId !== null)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_GetTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_GetTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPartnerTransactionsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPartnerTransactionsResponseModel>;
        }));
    }

    protected processPartners_GetTransactions(response: HttpResponseBase): Observable<GetPartnerTransactionsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPartnerTransactionsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_UpdateProfile(model: UpdatePartnerProfileRequestModel): Observable<UpdatePartnerProfileResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_UpdateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_UpdateProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePartnerProfileResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePartnerProfileResponseModel>;
        }));
    }

    protected processPartners_UpdateProfile(response: HttpResponseBase): Observable<UpdatePartnerProfileResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePartnerProfileResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_CreateWithdrawalRequest(model: CreateWithdrawalRequestModel): Observable<CreateWithdrawalResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/withdrawal-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_CreateWithdrawalRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_CreateWithdrawalRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWithdrawalResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWithdrawalResponseModel>;
        }));
    }

    protected processPartners_CreateWithdrawalRequest(response: HttpResponseBase): Observable<CreateWithdrawalResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWithdrawalResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_GetMyWithdrawalRequests(status: number | null | undefined, requestedById: string | null | undefined, dateFrom: string | null | undefined, dateTo: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetWithdrawalRequestsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/withdrawal-requests?";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (requestedById !== undefined && requestedById !== null)
            url_ += "RequestedById=" + encodeURIComponent("" + requestedById) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_GetMyWithdrawalRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_GetMyWithdrawalRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWithdrawalRequestsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWithdrawalRequestsResponseModel>;
        }));
    }

    protected processPartners_GetMyWithdrawalRequests(response: HttpResponseBase): Observable<GetWithdrawalRequestsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWithdrawalRequestsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partners_CancelWithdrawalRequest(id: number): Observable<CancelWithdrawalResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Partners/withdrawal-requests/{id}/cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners_CancelWithdrawalRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners_CancelWithdrawalRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelWithdrawalResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelWithdrawalResponseModel>;
        }));
    }

    protected processPartners_CancelWithdrawalRequest(response: HttpResponseBase): Observable<CancelWithdrawalResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelWithdrawalResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PartnerStaffClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    partnerStaff_GetAll(partnerId: string | null | undefined, isEnabled: boolean | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetPartnerStaffsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/PartnerStaff?";
        if (partnerId !== undefined && partnerId !== null)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (isEnabled !== undefined && isEnabled !== null)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerStaff_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerStaff_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPartnerStaffsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPartnerStaffsResponseModel>;
        }));
    }

    protected processPartnerStaff_GetAll(response: HttpResponseBase): Observable<GetPartnerStaffsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPartnerStaffsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partnerStaff_Create(model: CreatePartnerStaffRequestModel): Observable<CreatePartnerStaffResponseModel> {
        let url_ = this.baseUrl + "/api/v1/PartnerStaff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerStaff_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerStaff_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePartnerStaffResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePartnerStaffResponseModel>;
        }));
    }

    protected processPartnerStaff_Create(response: HttpResponseBase): Observable<CreatePartnerStaffResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePartnerStaffResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partnerStaff_GetDropDown(partnerId: string | null | undefined): Observable<GetPartnerStaffsDropDownResponseModel> {
        let url_ = this.baseUrl + "/api/v1/PartnerStaff/dropdown?";
        if (partnerId !== undefined && partnerId !== null)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerStaff_GetDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerStaff_GetDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPartnerStaffsDropDownResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPartnerStaffsDropDownResponseModel>;
        }));
    }

    protected processPartnerStaff_GetDropDown(response: HttpResponseBase): Observable<GetPartnerStaffsDropDownResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPartnerStaffsDropDownResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partnerStaff_Update(id: string, model: UpdatePartnerStaffRequestModel): Observable<UpdatePartnerStaffResponseModel> {
        let url_ = this.baseUrl + "/api/v1/PartnerStaff/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerStaff_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerStaff_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePartnerStaffResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePartnerStaffResponseModel>;
        }));
    }

    protected processPartnerStaff_Update(response: HttpResponseBase): Observable<UpdatePartnerStaffResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePartnerStaffResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partnerStaff_Delete(id: string): Observable<DeletePartnerStaffResponseModel> {
        let url_ = this.baseUrl + "/api/v1/PartnerStaff/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerStaff_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerStaff_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePartnerStaffResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePartnerStaffResponseModel>;
        }));
    }

    protected processPartnerStaff_Delete(response: HttpResponseBase): Observable<DeletePartnerStaffResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePartnerStaffResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partnerStaff_Enable(id: string, model: EnablePartnerStaffRequestModel): Observable<EnablePartnerStaffResponseModel> {
        let url_ = this.baseUrl + "/api/v1/PartnerStaff/{id}/enable";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerStaff_Enable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerStaff_Enable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnablePartnerStaffResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnablePartnerStaffResponseModel>;
        }));
    }

    protected processPartnerStaff_Enable(response: HttpResponseBase): Observable<EnablePartnerStaffResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnablePartnerStaffResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PartnerTicketClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    partnerTicket_GetAll(startDate: string | null | undefined, endDate: string | null | undefined, regionId: number | null | undefined, atmId: string | null | undefined, status: number | null | undefined, staffId: string | null | undefined, countryId: number | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetTicketsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/PartnerTicket?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (regionId !== undefined && regionId !== null)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (countryId !== undefined && countryId !== null)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerTicket_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerTicket_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTicketsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTicketsResponseModel>;
        }));
    }

    protected processPartnerTicket_GetAll(response: HttpResponseBase): Observable<GetTicketsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTicketsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partnerTicket_Create(model: CreatePartnerTicketRequestModel): Observable<CreatePartnerTicketResponseModel> {
        let url_ = this.baseUrl + "/api/v1/PartnerTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerTicket_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerTicket_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePartnerTicketResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePartnerTicketResponseModel>;
        }));
    }

    protected processPartnerTicket_Create(response: HttpResponseBase): Observable<CreatePartnerTicketResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePartnerTicketResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partnerTicket_GetById(id: number): Observable<GetTicketByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/PartnerTicket/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerTicket_GetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerTicket_GetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTicketByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTicketByIdResponseModel>;
        }));
    }

    protected processPartnerTicket_GetById(response: HttpResponseBase): Observable<GetTicketByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTicketByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partnerTicket_Update(id: number, model: UpdatePartnerTicketRequestModel): Observable<UpdatePartnerTicketResponseModel> {
        let url_ = this.baseUrl + "/api/v1/PartnerTicket/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerTicket_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerTicket_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePartnerTicketResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePartnerTicketResponseModel>;
        }));
    }

    protected processPartnerTicket_Update(response: HttpResponseBase): Observable<UpdatePartnerTicketResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePartnerTicketResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    partnerTicket_Delete(id: number): Observable<DeletePartnerTicketResponseModel> {
        let url_ = this.baseUrl + "/api/v1/PartnerTicket/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerTicket_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerTicket_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePartnerTicketResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePartnerTicketResponseModel>;
        }));
    }

    protected processPartnerTicket_Delete(response: HttpResponseBase): Observable<DeletePartnerTicketResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePartnerTicketResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RealTimeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get ATM Realtime
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    realTime_GetAtmRealTime(isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetAtmRealTimeResponseModel> {
        let url_ = this.baseUrl + "/api/v1/RealTime?";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRealTime_GetAtmRealTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRealTime_GetAtmRealTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAtmRealTimeResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAtmRealTimeResponseModel>;
        }));
    }

    protected processRealTime_GetAtmRealTime(response: HttpResponseBase): Observable<GetAtmRealTimeResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAtmRealTimeResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update ATM Realtime
     */
    realTime_UpdateAtmRealTime(model: UpdateAtmRealTimeRequestModel): Observable<UpdateAtmRealTimeResponseModel> {
        let url_ = this.baseUrl + "/api/v1/RealTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRealTime_UpdateAtmRealTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRealTime_UpdateAtmRealTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAtmRealTimeResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAtmRealTimeResponseModel>;
        }));
    }

    protected processRealTime_UpdateAtmRealTime(response: HttpResponseBase): Observable<UpdateAtmRealTimeResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAtmRealTimeResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RegionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get Regions
     * @param countryId (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    region_GetRegions(countryId: number | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetRegionsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Region?";
        if (countryId !== undefined && countryId !== null)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegion_GetRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegion_GetRegions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRegionsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRegionsResponseModel>;
        }));
    }

    protected processRegion_GetRegions(response: HttpResponseBase): Observable<GetRegionsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegionsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Region
     */
    region_CreateRegion(model: CreateRegionRequestModel): Observable<CreateRegionResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Region";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegion_CreateRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegion_CreateRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateRegionResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateRegionResponseModel>;
        }));
    }

    protected processRegion_CreateRegion(response: HttpResponseBase): Observable<CreateRegionResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRegionResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Regions Drop Down
     * @param countryId (optional) 
     */
    region_GetRegionDropDown(countryId: number | undefined): Observable<GetRegionsDropDownResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Region/dropDown?";
        if (countryId === null)
            throw new globalThis.Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegion_GetRegionDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegion_GetRegionDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRegionsDropDownResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRegionsDropDownResponseModel>;
        }));
    }

    protected processRegion_GetRegionDropDown(response: HttpResponseBase): Observable<GetRegionsDropDownResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegionsDropDownResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Region
     */
    region_UpdateRegion(id: number, model: UpdateRegionRequestModel): Observable<UpdateRegionResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Region/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegion_UpdateRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegion_UpdateRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateRegionResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateRegionResponseModel>;
        }));
    }

    protected processRegion_UpdateRegion(response: HttpResponseBase): Observable<UpdateRegionResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateRegionResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Region By id
     */
    region_DeleteRegion(id: number): Observable<DeleteRegionResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Region/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegion_DeleteRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegion_DeleteRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteRegionResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteRegionResponseModel>;
        }));
    }

    protected processRegion_DeleteRegion(response: HttpResponseBase): Observable<DeleteRegionResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteRegionResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SessionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Create Session
     */
    session_CreateSession(): Observable<CreateSessionResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Session";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSession_CreateSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSession_CreateSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSessionResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSessionResponseModel>;
        }));
    }

    protected processSession_CreateSession(response: HttpResponseBase): Observable<CreateSessionResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSessionResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Sessions
     * @param atmId (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    session_GetSessions(atmId: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetAppSessionsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Session?";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSession_GetSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSession_GetSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAppSessionsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAppSessionsResponseModel>;
        }));
    }

    protected processSession_GetSessions(response: HttpResponseBase): Observable<GetAppSessionsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppSessionsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Sessions By Id
     */
    session_GetSessionById(id: string): Observable<GetAppSessionDetailByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Session/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSession_GetSessionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSession_GetSessionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAppSessionDetailByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAppSessionDetailByIdResponseModel>;
        }));
    }

    protected processSession_GetSessionById(response: HttpResponseBase): Observable<GetAppSessionDetailByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppSessionDetailByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SmsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Send Verification Sms
     */
    sms_SendVerificationSms(model: SendVerificationSmsRequestModel): Observable<SendVerificationSmsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Sms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSms_SendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSms_SendVerificationSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendVerificationSmsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendVerificationSmsResponseModel>;
        }));
    }

    protected processSms_SendVerificationSms(response: HttpResponseBase): Observable<SendVerificationSmsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendVerificationSmsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sms_SendVerificationSmsForLogin(model: SendVerificationSmsForLoginRequestModel): Observable<SendVerificationSmsForLoginResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Sms/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSms_SendVerificationSmsForLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSms_SendVerificationSmsForLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendVerificationSmsForLoginResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendVerificationSmsForLoginResponseModel>;
        }));
    }

    protected processSms_SendVerificationSmsForLogin(response: HttpResponseBase): Observable<SendVerificationSmsForLoginResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendVerificationSmsForLoginResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verify Otp
     */
    sms_VerifyOtp(model: VerifyOtpRequestModel): Observable<VerifyOtpResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Sms/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSms_VerifyOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSms_VerifyOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VerifyOtpResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VerifyOtpResponseModel>;
        }));
    }

    protected processSms_VerifyOtp(response: HttpResponseBase): Observable<VerifyOtpResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyOtpResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StaffClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get Staffs
     * @param countryId (optional) 
     * @param regionId (optional) 
     * @param isEnabled (optional) 
     * @param role (optional) 
     * @param partnerId (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    staff_GetStaffs(countryId: number | null | undefined, regionId: number | null | undefined, isEnabled: boolean | null | undefined, role: string | null | undefined, partnerId: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetStaffsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Staff?";
        if (countryId !== undefined && countryId !== null)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (regionId !== undefined && regionId !== null)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (isEnabled !== undefined && isEnabled !== null)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (role !== undefined && role !== null)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (partnerId !== undefined && partnerId !== null)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStaff_GetStaffs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStaff_GetStaffs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStaffsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStaffsResponseModel>;
        }));
    }

    protected processStaff_GetStaffs(response: HttpResponseBase): Observable<GetStaffsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStaffsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Staff
     */
    staff_CreateStaff(model: CreateStaffRequestModel): Observable<CreateStaffResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Staff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStaff_CreateStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStaff_CreateStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateStaffResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateStaffResponseModel>;
        }));
    }

    protected processStaff_CreateStaff(response: HttpResponseBase): Observable<CreateStaffResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateStaffResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Staffs DropDown
     * @param regionId (optional) 
     * @param role (optional) 
     */
    staff_GetStaffsDropDown(regionId: number | null | undefined, role: string | null | undefined): Observable<GetStaffsDropDownResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Staff/dropDown?";
        if (regionId !== undefined && regionId !== null)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (role !== undefined && role !== null)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStaff_GetStaffsDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStaff_GetStaffsDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStaffsDropDownResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStaffsDropDownResponseModel>;
        }));
    }

    protected processStaff_GetStaffsDropDown(response: HttpResponseBase): Observable<GetStaffsDropDownResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStaffsDropDownResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Staff
     */
    staff_UpdateStaff(id: string, model: UpdateStaffRequestModel): Observable<UpdateStaffResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Staff/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStaff_UpdateStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStaff_UpdateStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateStaffResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateStaffResponseModel>;
        }));
    }

    protected processStaff_UpdateStaff(response: HttpResponseBase): Observable<UpdateStaffResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateStaffResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Staff By id
     */
    staff_DeleteStaff(id: string): Observable<DeleteStaffResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Staff/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStaff_DeleteStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStaff_DeleteStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteStaffResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteStaffResponseModel>;
        }));
    }

    protected processStaff_DeleteStaff(response: HttpResponseBase): Observable<DeleteStaffResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteStaffResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Staff Status
     */
    staff_UpdateStaffEnable(id: string, model: UpdateStaffEnableRequestModel): Observable<UpdateStaffEnableResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Staff/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStaff_UpdateStaffEnable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStaff_UpdateStaffEnable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateStaffEnableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateStaffEnableResponseModel>;
        }));
    }

    protected processStaff_UpdateStaffEnable(response: HttpResponseBase): Observable<UpdateStaffEnableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateStaffEnableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TicketCommentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get TicketComments
     * @param ticketId (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    ticketComment_GetTicketComments(ticketId: number | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetTicketCommentsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TicketComment?";
        if (ticketId === null)
            throw new globalThis.Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined)
            url_ += "TicketId=" + encodeURIComponent("" + ticketId) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTicketComment_GetTicketComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTicketComment_GetTicketComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTicketCommentsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTicketCommentsResponseModel>;
        }));
    }

    protected processTicketComment_GetTicketComments(response: HttpResponseBase): Observable<GetTicketCommentsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTicketCommentsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create TicketComment
     */
    ticketComment_CreateTicketComment(model: CreateTicketCommentRequestModel): Observable<CreateTicketCommentResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TicketComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTicketComment_CreateTicketComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTicketComment_CreateTicketComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTicketCommentResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTicketCommentResponseModel>;
        }));
    }

    protected processTicketComment_CreateTicketComment(response: HttpResponseBase): Observable<CreateTicketCommentResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTicketCommentResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update TicketComment
     */
    ticketComment_UpdateTicketComment(id: number, model: UpdateTicketCommentRequestModel): Observable<UpdateTicketCommentResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TicketComment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTicketComment_UpdateTicketComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTicketComment_UpdateTicketComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTicketCommentResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTicketCommentResponseModel>;
        }));
    }

    protected processTicketComment_UpdateTicketComment(response: HttpResponseBase): Observable<UpdateTicketCommentResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTicketCommentResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete TicketComment By id
     */
    ticketComment_DeleteTicketComment(id: number): Observable<DeleteTicketCommentResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TicketComment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTicketComment_DeleteTicketComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTicketComment_DeleteTicketComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteTicketCommentResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteTicketCommentResponseModel>;
        }));
    }

    protected processTicketComment_DeleteTicketComment(response: HttpResponseBase): Observable<DeleteTicketCommentResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteTicketCommentResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TicketClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get Tickets
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param regionId (optional) 
     * @param atmId (optional) 
     * @param status (optional) 
     * @param staffId (optional) 
     * @param countryId (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    ticket_GetTickets(startDate: string | null | undefined, endDate: string | null | undefined, regionId: number | null | undefined, atmId: string | null | undefined, status: number | null | undefined, staffId: string | null | undefined, countryId: number | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetTicketsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Ticket?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (regionId !== undefined && regionId !== null)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (staffId !== undefined && staffId !== null)
            url_ += "StaffId=" + encodeURIComponent("" + staffId) + "&";
        if (countryId !== undefined && countryId !== null)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTicket_GetTickets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTicket_GetTickets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTicketsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTicketsResponseModel>;
        }));
    }

    protected processTicket_GetTickets(response: HttpResponseBase): Observable<GetTicketsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTicketsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Ticket
     */
    ticket_CreateTicket(model: CreateTicketRequestModel): Observable<CreateTicketResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Ticket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTicket_CreateTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTicket_CreateTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTicketResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTicketResponseModel>;
        }));
    }

    protected processTicket_CreateTicket(response: HttpResponseBase): Observable<CreateTicketResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTicketResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ticket By Id
     * @param id Id of Ticket Resource
     */
    ticket_GetTicketById(id: number): Observable<GetTicketByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Ticket/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTicket_GetTicketById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTicket_GetTicketById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTicketByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTicketByIdResponseModel>;
        }));
    }

    protected processTicket_GetTicketById(response: HttpResponseBase): Observable<GetTicketByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTicketByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Ticket
     */
    ticket_UpdateTicket(id: number, model: UpdateTicketRequestModel): Observable<UpdateTicketResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Ticket/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTicket_UpdateTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTicket_UpdateTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTicketResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTicketResponseModel>;
        }));
    }

    protected processTicket_UpdateTicket(response: HttpResponseBase): Observable<UpdateTicketResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTicketResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Ticket By id
     */
    ticket_DeleteTicket(id: number): Observable<DeleteTicketResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Ticket/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTicket_DeleteTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTicket_DeleteTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteTicketResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteTicketResponseModel>;
        }));
    }

    protected processTicket_DeleteTicket(response: HttpResponseBase): Observable<DeleteTicketResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteTicketResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resolve Ticket By Id
     */
    ticket_ResolveTicket(id: number): Observable<ResolveTicketResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Ticket/resolve/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTicket_ResolveTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTicket_ResolveTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResolveTicketResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResolveTicketResponseModel>;
        }));
    }

    protected processTicket_ResolveTicket(response: HttpResponseBase): Observable<ResolveTicketResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResolveTicketResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TransactionCommissionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    transactionCommission_GetAll(dateFrom: string | null | undefined, dateTo: string | null | undefined, atmId: string | null | undefined, appTransactionId: number | null | undefined, partyRole: number | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetTransactionCommissionsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TransactionCommission?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (appTransactionId !== undefined && appTransactionId !== null)
            url_ += "AppTransactionId=" + encodeURIComponent("" + appTransactionId) + "&";
        if (partyRole !== undefined && partyRole !== null)
            url_ += "PartyRole=" + encodeURIComponent("" + partyRole) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionCommission_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionCommission_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTransactionCommissionsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTransactionCommissionsResponseModel>;
        }));
    }

    protected processTransactionCommission_GetAll(response: HttpResponseBase): Observable<GetTransactionCommissionsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionCommissionsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * One line per transaction with each party's share
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param atmId (optional) 
     * @param operator (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    transactionCommission_GetSummary(dateFrom: string | null | undefined, dateTo: string | null | undefined, atmId: string | null | undefined, operator: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetTransactionCommissionSummaryResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TransactionCommission/summary?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (atmId !== undefined && atmId !== null)
            url_ += "AtmId=" + encodeURIComponent("" + atmId) + "&";
        if (operator !== undefined && operator !== null)
            url_ += "Operator=" + encodeURIComponent("" + operator) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionCommission_GetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionCommission_GetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTransactionCommissionSummaryResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTransactionCommissionSummaryResponseModel>;
        }));
    }

    protected processTransactionCommission_GetSummary(response: HttpResponseBase): Observable<GetTransactionCommissionSummaryResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionCommissionSummaryResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionCommission_GetByAppTransactionId(appTransactionId: number): Observable<GetTransactionCommissionsByAppTransactionIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TransactionCommission/by-transaction/{appTransactionId}";
        if (appTransactionId === undefined || appTransactionId === null)
            throw new globalThis.Error("The parameter 'appTransactionId' must be defined.");
        url_ = url_.replace("{appTransactionId}", encodeURIComponent("" + appTransactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionCommission_GetByAppTransactionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionCommission_GetByAppTransactionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTransactionCommissionsByAppTransactionIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTransactionCommissionsByAppTransactionIdResponseModel>;
        }));
    }

    protected processTransactionCommission_GetByAppTransactionId(response: HttpResponseBase): Observable<GetTransactionCommissionsByAppTransactionIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionCommissionsByAppTransactionIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TwoFactorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Send a login code (step 2 of login) after /connect/token answered "Two factor required"
     */
    twoFactor_SendCode(model: SendTwoFactorCodeRequestModel): Observable<SendTwoFactorCodeResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TwoFactor/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTwoFactor_SendCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTwoFactor_SendCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendTwoFactorCodeResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendTwoFactorCodeResponseModel>;
        }));
    }

    protected processTwoFactor_SendCode(response: HttpResponseBase): Observable<SendTwoFactorCodeResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendTwoFactorCodeResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Two factor status of the current user
     */
    twoFactor_GetStatus(): Observable<TwoFactorStatusResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TwoFactor/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTwoFactor_GetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTwoFactor_GetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoFactorStatusResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoFactorStatusResponseModel>;
        }));
    }

    protected processTwoFactor_GetStatus(response: HttpResponseBase): Observable<TwoFactorStatusResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoFactorStatusResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Turn two factor on or off for the current user
     */
    twoFactor_SetOwn(model: SetTwoFactorRequestModel): Observable<TwoFactorStatusResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TwoFactor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTwoFactor_SetOwn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTwoFactor_SetOwn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoFactorStatusResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoFactorStatusResponseModel>;
        }));
    }

    protected processTwoFactor_SetOwn(response: HttpResponseBase): Observable<TwoFactorStatusResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoFactorStatusResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Whether 2FA is required for Administrator, Partner and Supervisor accounts
     */
    twoFactor_GetRequirement(): Observable<TwoFactorRequirementResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TwoFactor/requirement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTwoFactor_GetRequirement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTwoFactor_GetRequirement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoFactorRequirementResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoFactorRequirementResponseModel>;
        }));
    }

    protected processTwoFactor_GetRequirement(response: HttpResponseBase): Observable<TwoFactorRequirementResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoFactorRequirementResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Switch the 2FA requirement for Administrator, Partner and Supervisor accounts
     */
    twoFactor_SetRequirement(model: SetTwoFactorRequirementRequestModel): Observable<TwoFactorRequirementResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TwoFactor/requirement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTwoFactor_SetRequirement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTwoFactor_SetRequirement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoFactorRequirementResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoFactorRequirementResponseModel>;
        }));
    }

    protected processTwoFactor_SetRequirement(response: HttpResponseBase): Observable<TwoFactorRequirementResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoFactorRequirementResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Two factor status of a user (Admin: anyone; Partner: its staff)
     */
    twoFactor_GetForUser(userId: string): Observable<TwoFactorStatusResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TwoFactor/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTwoFactor_GetForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTwoFactor_GetForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoFactorStatusResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoFactorStatusResponseModel>;
        }));
    }

    protected processTwoFactor_GetForUser(response: HttpResponseBase): Observable<TwoFactorStatusResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoFactorStatusResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Turn two factor on or off for a user (Admin: anyone; Partner: its staff)
     */
    twoFactor_SetForUser(userId: string, model: SetTwoFactorRequestModel): Observable<TwoFactorStatusResponseModel> {
        let url_ = this.baseUrl + "/api/v1/TwoFactor/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTwoFactor_SetForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTwoFactor_SetForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoFactorStatusResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoFactorStatusResponseModel>;
        }));
    }

    protected processTwoFactor_SetForUser(response: HttpResponseBase): Observable<TwoFactorStatusResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoFactorStatusResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Change Current Password
     */
    user_ChangeCurrentPassword(model: ChangeCurrentPasswordRequestModel): Observable<ChangeCurrentPasswordResponseModel> {
        let url_ = this.baseUrl + "/api/v1/User/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_ChangeCurrentPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_ChangeCurrentPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeCurrentPasswordResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeCurrentPasswordResponseModel>;
        }));
    }

    protected processUser_ChangeCurrentPassword(response: HttpResponseBase): Observable<ChangeCurrentPasswordResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeCurrentPasswordResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Is Active User
     */
    user_GetIsActive(): Observable<GetIsActiveResponseModel> {
        let url_ = this.baseUrl + "/api/v1/User/isActive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_GetIsActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_GetIsActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIsActiveResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIsActiveResponseModel>;
        }));
    }

    protected processUser_GetIsActive(response: HttpResponseBase): Observable<GetIsActiveResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIsActiveResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    user_UpdateFcmId(model: UpdateFcmIdRequestModel): Observable<UpdateFcmIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/User/fcm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_UpdateFcmId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_UpdateFcmId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateFcmIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateFcmIdResponseModel>;
        }));
    }

    protected processUser_UpdateFcmId(response: HttpResponseBase): Observable<UpdateFcmIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateFcmIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Notification Setting
     */
    user_UpdateNotificationSetting(model: UpdateNotificationSettingRequestModel): Observable<UpdateNotificationSettingResponseModel> {
        let url_ = this.baseUrl + "/api/v1/User/notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_UpdateNotificationSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_UpdateNotificationSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateNotificationSettingResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateNotificationSettingResponseModel>;
        }));
    }

    protected processUser_UpdateNotificationSetting(response: HttpResponseBase): Observable<UpdateNotificationSettingResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateNotificationSettingResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Password By Id of user
     */
    user_UpdatePasswordById(id: string, model: UpdatePasswordByIdRequestModel): Observable<UpdatePasswordByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/User/password/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_UpdatePasswordById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_UpdatePasswordById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePasswordByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePasswordByIdResponseModel>;
        }));
    }

    protected processUser_UpdatePasswordById(response: HttpResponseBase): Observable<UpdatePasswordByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePasswordByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WithdrawalRequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Admin — all withdrawal requests; Partner — requests from investors on its ATMs
     * @param status (optional) 
     * @param requestedById (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    withdrawalRequests_GetAll(status: number | null | undefined, requestedById: string | null | undefined, dateFrom: string | null | undefined, dateTo: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetWithdrawalRequestsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/WithdrawalRequests?";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (requestedById !== undefined && requestedById !== null)
            url_ += "RequestedById=" + encodeURIComponent("" + requestedById) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawalRequests_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawalRequests_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWithdrawalRequestsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWithdrawalRequestsResponseModel>;
        }));
    }

    protected processWithdrawalRequests_GetAll(response: HttpResponseBase): Observable<GetWithdrawalRequestsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWithdrawalRequestsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approve a withdrawal request
     */
    withdrawalRequests_Approve(id: number, model: ApproveWithdrawalRequestModel): Observable<ApproveWithdrawalResponseModel> {
        let url_ = this.baseUrl + "/api/v1/WithdrawalRequests/{id}/approve";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawalRequests_Approve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawalRequests_Approve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApproveWithdrawalResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApproveWithdrawalResponseModel>;
        }));
    }

    protected processWithdrawalRequests_Approve(response: HttpResponseBase): Observable<ApproveWithdrawalResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveWithdrawalResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reject a withdrawal request
     */
    withdrawalRequests_Reject(id: number, model: RejectWithdrawalRequestModel): Observable<RejectWithdrawalResponseModel> {
        let url_ = this.baseUrl + "/api/v1/WithdrawalRequests/{id}/reject";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawalRequests_Reject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawalRequests_Reject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RejectWithdrawalResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RejectWithdrawalResponseModel>;
        }));
    }

    protected processWithdrawalRequests_Reject(response: HttpResponseBase): Observable<RejectWithdrawalResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RejectWithdrawalResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class CreateAppLogResponseModel implements ICreateAppLogResponseModel {

    constructor(data?: ICreateAppLogResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateAppLogResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppLogResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICreateAppLogResponseModel {
}

export class CreateAppLogRequestModel implements ICreateAppLogRequestModel {
    atmId?: string | undefined;
    sessionId?: string | undefined;
    logType?: LogType;
    message?: string | undefined;
    data?: string | undefined;
    isCreateTicket?: boolean;
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICreateAppLogRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atmId = _data["atmId"];
            this.sessionId = _data["sessionId"];
            this.logType = _data["logType"];
            this.message = _data["message"];
            this.data = _data["data"];
            this.isCreateTicket = _data["isCreateTicket"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateAppLogRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppLogRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmId"] = this.atmId;
        data["sessionId"] = this.sessionId;
        data["logType"] = this.logType;
        data["message"] = this.message;
        data["data"] = this.data;
        data["isCreateTicket"] = this.isCreateTicket;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateAppLogRequestModel {
    atmId?: string | undefined;
    sessionId?: string | undefined;
    logType?: LogType;
    message?: string | undefined;
    data?: string | undefined;
    isCreateTicket?: boolean;
    title?: string | undefined;
    description?: string | undefined;
}

export enum LogType {
    Start = 0,
    Error = 1,
    Cancel = 2,
    Back = 3,
    SelectLanguage = 4,
    Next = 5,
    MtnMoney = 6,
    Orange = 7,
    Crypto = 8,
    IdCard = 9,
    Passport = 10,
    DrivingLicense = 11,
    CaptureImage = 12,
    Deposit = 13,
    Withdraw = 14,
    SubmitPhoneNumber = 15,
    SubmitOtp = 16,
    ResendOtp = 17,
    NoteInserted = 18,
    NoteReturned = 19,
    NoteAccepted = 20,
    MtnTransfer = 21,
    MtnWithdraw = 22,
    DeviceError = 23,
    WithdrawCancel = 24,
    CryptoBuy = 25,
    CryptoSell = 26,
    CryptoError = 27,
    MojoPay = 28,
}

export class GetAppLogsResponseModel implements IGetAppLogsResponseModel {
    data?: AppLogDto[] | undefined;
    count?: number;

    constructor(data?: IGetAppLogsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AppLogDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAppLogsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppLogsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetAppLogsResponseModel {
    data?: AppLogDto[] | undefined;
    count?: number;
}

export class AppLogDto implements IAppLogDto {
    id?: number;
    atmId?: string | undefined;
    atm?: string | undefined;
    sessionId?: string | undefined;
    type?: number;
    message?: string | undefined;
    data?: string | undefined;
    createdDate?: string;

    constructor(data?: IAppLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.atmId = _data["atmId"];
            this.atm = _data["atm"];
            this.sessionId = _data["sessionId"];
            this.type = _data["type"];
            this.message = _data["message"];
            this.data = _data["data"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): AppLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["atmId"] = this.atmId;
        data["atm"] = this.atm;
        data["sessionId"] = this.sessionId;
        data["type"] = this.type;
        data["message"] = this.message;
        data["data"] = this.data;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IAppLogDto {
    id?: number;
    atmId?: string | undefined;
    atm?: string | undefined;
    sessionId?: string | undefined;
    type?: number;
    message?: string | undefined;
    data?: string | undefined;
    createdDate?: string;
}

export class GetAppNotificationsResponseModel implements IGetAppNotificationsResponseModel {
    data?: AppNotificationDto[] | undefined;
    count?: number;

    constructor(data?: IGetAppNotificationsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AppNotificationDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAppNotificationsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppNotificationsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetAppNotificationsResponseModel {
    data?: AppNotificationDto[] | undefined;
    count?: number;
}

export class AppNotificationDto implements IAppNotificationDto {
    id?: number;
    title?: string | undefined;
    message?: string | undefined;
    data?: string | undefined;
    type?: number;
    createdDate?: string;

    constructor(data?: IAppNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.data = _data["data"];
            this.type = _data["type"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): AppNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["message"] = this.message;
        data["data"] = this.data;
        data["type"] = this.type;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IAppNotificationDto {
    id?: number;
    title?: string | undefined;
    message?: string | undefined;
    data?: string | undefined;
    type?: number;
    createdDate?: string;
}

export class GetAppNotificationUnReadCountResponseModel implements IGetAppNotificationUnReadCountResponseModel {
    data?: number;

    constructor(data?: IGetAppNotificationUnReadCountResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GetAppNotificationUnReadCountResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppNotificationUnReadCountResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface IGetAppNotificationUnReadCountResponseModel {
    data?: number;
}

export class ReadAllUnReadNotificationResponseModel implements IReadAllUnReadNotificationResponseModel {

    constructor(data?: IReadAllUnReadNotificationResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ReadAllUnReadNotificationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReadAllUnReadNotificationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IReadAllUnReadNotificationResponseModel {
}

export class ReadNotificationResponseModel implements IReadNotificationResponseModel {

    constructor(data?: IReadNotificationResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ReadNotificationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReadNotificationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IReadNotificationResponseModel {
}

export class GetAppTransactionsResponseModel implements IGetAppTransactionsResponseModel {
    data?: AppTransactionDto[] | undefined;
    count?: number;

    constructor(data?: IGetAppTransactionsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AppTransactionDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAppTransactionsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppTransactionsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetAppTransactionsResponseModel {
    data?: AppTransactionDto[] | undefined;
    count?: number;
}

export class AppTransactionDto implements IAppTransactionDto {
    sessionId?: string | undefined;
    atmId?: string | undefined;
    atm?: string | undefined;
    phoneNumber?: string | undefined;
    amount?: number;
    type?: number;
    operatorType?: number;
    network?: string | undefined;
    bankCode?: string | undefined;
    bankName?: string | undefined;
    accountNumber?: string | undefined;
    transactionId?: string | undefined;
    externalTransactionId?: string | undefined;
    status?: string | undefined;
    id?: number;
    txHash?: string | undefined;
    createdDate?: string;
    avgPrice?: string | undefined;
    totalLocal?: string | undefined;
    totalUsd?: string | undefined;
    currency?: string | undefined;
    operatorName?: string | undefined;
    isBank?: boolean;
    receiverAddress?: string | undefined;

    constructor(data?: IAppTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.atmId = _data["atmId"];
            this.atm = _data["atm"];
            this.phoneNumber = _data["phoneNumber"];
            this.amount = _data["amount"];
            this.type = _data["type"];
            this.operatorType = _data["operatorType"];
            this.network = _data["network"];
            this.bankCode = _data["bankCode"];
            this.bankName = _data["bankName"];
            this.accountNumber = _data["accountNumber"];
            this.transactionId = _data["transactionId"];
            this.externalTransactionId = _data["externalTransactionId"];
            this.status = _data["status"];
            this.id = _data["id"];
            this.txHash = _data["txHash"];
            this.createdDate = _data["createdDate"];
            this.avgPrice = _data["avgPrice"];
            this.totalLocal = _data["totalLocal"];
            this.totalUsd = _data["totalUsd"];
            this.currency = _data["currency"];
            this.operatorName = _data["operatorName"];
            this.isBank = _data["isBank"];
            this.receiverAddress = _data["receiverAddress"];
        }
    }

    static fromJS(data: any): AppTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["atmId"] = this.atmId;
        data["atm"] = this.atm;
        data["phoneNumber"] = this.phoneNumber;
        data["amount"] = this.amount;
        data["type"] = this.type;
        data["operatorType"] = this.operatorType;
        data["network"] = this.network;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["accountNumber"] = this.accountNumber;
        data["transactionId"] = this.transactionId;
        data["externalTransactionId"] = this.externalTransactionId;
        data["status"] = this.status;
        data["id"] = this.id;
        data["txHash"] = this.txHash;
        data["createdDate"] = this.createdDate;
        data["avgPrice"] = this.avgPrice;
        data["totalLocal"] = this.totalLocal;
        data["totalUsd"] = this.totalUsd;
        data["currency"] = this.currency;
        data["operatorName"] = this.operatorName;
        data["isBank"] = this.isBank;
        data["receiverAddress"] = this.receiverAddress;
        return data;
    }
}

export interface IAppTransactionDto {
    sessionId?: string | undefined;
    atmId?: string | undefined;
    atm?: string | undefined;
    phoneNumber?: string | undefined;
    amount?: number;
    type?: number;
    operatorType?: number;
    network?: string | undefined;
    bankCode?: string | undefined;
    bankName?: string | undefined;
    accountNumber?: string | undefined;
    transactionId?: string | undefined;
    externalTransactionId?: string | undefined;
    status?: string | undefined;
    id?: number;
    txHash?: string | undefined;
    createdDate?: string;
    avgPrice?: string | undefined;
    totalLocal?: string | undefined;
    totalUsd?: string | undefined;
    currency?: string | undefined;
    operatorName?: string | undefined;
    isBank?: boolean;
    receiverAddress?: string | undefined;
}

export class GetPublicAppTransactionsResponseModel implements IGetPublicAppTransactionsResponseModel {
    data?: AppTransactionDto[] | undefined;
    count?: number;

    constructor(data?: IGetPublicAppTransactionsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AppTransactionDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetPublicAppTransactionsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicAppTransactionsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetPublicAppTransactionsResponseModel {
    data?: AppTransactionDto[] | undefined;
    count?: number;
}

export class GetPublicAppTransactionByIdResponseModel implements IGetPublicAppTransactionByIdResponseModel {
    data?: AppTransactionDto | undefined;

    constructor(data?: IGetPublicAppTransactionByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AppTransactionDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetPublicAppTransactionByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicAppTransactionByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetPublicAppTransactionByIdResponseModel {
    data?: AppTransactionDto | undefined;
}

export class GetAppTransactionByIdResponseModel implements IGetAppTransactionByIdResponseModel {
    data?: AppTransactionDto | undefined;

    constructor(data?: IGetAppTransactionByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AppTransactionDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetAppTransactionByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppTransactionByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetAppTransactionByIdResponseModel {
    data?: AppTransactionDto | undefined;
}

export class MarkTransactionRefundedResponseModel implements IMarkTransactionRefundedResponseModel {

    constructor(data?: IMarkTransactionRefundedResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MarkTransactionRefundedResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkTransactionRefundedResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMarkTransactionRefundedResponseModel {
}

export class MarkTransactionRefundedRequestModel implements IMarkTransactionRefundedRequestModel {
    reason?: string | undefined;
    reference?: string | undefined;

    constructor(data?: IMarkTransactionRefundedRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): MarkTransactionRefundedRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkTransactionRefundedRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IMarkTransactionRefundedRequestModel {
    reason?: string | undefined;
    reference?: string | undefined;
}

export class ReportAtmRefundRequestModel implements IReportAtmRefundRequestModel {
    transactionId?: string | undefined;
    reference?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IReportAtmRefundRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.reference = _data["reference"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ReportAtmRefundRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportAtmRefundRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["reference"] = this.reference;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IReportAtmRefundRequestModel {
    transactionId?: string | undefined;
    reference?: string | undefined;
    reason?: string | undefined;
}

export class CanDoTransactionResponseModel implements ICanDoTransactionResponseModel {
    data?: boolean;

    constructor(data?: ICanDoTransactionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CanDoTransactionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CanDoTransactionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface ICanDoTransactionResponseModel {
    data?: boolean;
}

export class CanDoTransactionRequestModel implements ICanDoTransactionRequestModel {
    phoneNumber?: string | undefined;

    constructor(data?: ICanDoTransactionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CanDoTransactionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CanDoTransactionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICanDoTransactionRequestModel {
    phoneNumber?: string | undefined;
}

export class GetAtmsResponseModel implements IGetAtmsResponseModel {
    data?: AtmDto[] | undefined;
    count?: number;

    constructor(data?: IGetAtmsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AtmDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAtmsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetAtmsResponseModel {
    data?: AtmDto[] | undefined;
    count?: number;
}

export class AtmDto implements IAtmDto {
    countryId?: number;
    country?: string | undefined;
    region?: string | undefined;
    regionId?: number;
    name?: string | undefined;
    ipAddress?: string | undefined;
    address?: string | undefined;
    userName?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;
    id?: string | undefined;
    manager?: string | undefined;
    managerId?: string | undefined;
    companySharePct?: number;
    currency?: AtmCurrencyType;
    isOnline?: boolean;
    lastSeenAt?: string | undefined;
    healthStatus?: number;
    healthCheckedAt?: string | undefined;

    constructor(data?: IAtmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.region = _data["region"];
            this.regionId = _data["regionId"];
            this.name = _data["name"];
            this.ipAddress = _data["ipAddress"];
            this.address = _data["address"];
            this.userName = _data["userName"];
            this.isEnabled = _data["isEnabled"];
            this.createdDate = _data["createdDate"];
            this.id = _data["id"];
            this.manager = _data["manager"];
            this.managerId = _data["managerId"];
            this.companySharePct = _data["companySharePct"];
            this.currency = _data["currency"];
            this.isOnline = _data["isOnline"];
            this.lastSeenAt = _data["lastSeenAt"];
            this.healthStatus = _data["healthStatus"];
            this.healthCheckedAt = _data["healthCheckedAt"];
        }
    }

    static fromJS(data: any): AtmDto {
        data = typeof data === 'object' ? data : {};
        let result = new AtmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["region"] = this.region;
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["ipAddress"] = this.ipAddress;
        data["address"] = this.address;
        data["userName"] = this.userName;
        data["isEnabled"] = this.isEnabled;
        data["createdDate"] = this.createdDate;
        data["id"] = this.id;
        data["manager"] = this.manager;
        data["managerId"] = this.managerId;
        data["companySharePct"] = this.companySharePct;
        data["currency"] = this.currency;
        data["isOnline"] = this.isOnline;
        data["lastSeenAt"] = this.lastSeenAt;
        data["healthStatus"] = this.healthStatus;
        data["healthCheckedAt"] = this.healthCheckedAt;
        return data;
    }
}

export interface IAtmDto {
    countryId?: number;
    country?: string | undefined;
    region?: string | undefined;
    regionId?: number;
    name?: string | undefined;
    ipAddress?: string | undefined;
    address?: string | undefined;
    userName?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;
    id?: string | undefined;
    manager?: string | undefined;
    managerId?: string | undefined;
    companySharePct?: number;
    currency?: AtmCurrencyType;
    isOnline?: boolean;
    lastSeenAt?: string | undefined;
    healthStatus?: number;
    healthCheckedAt?: string | undefined;
}

export enum AtmCurrencyType {
    XAF = 0,
    GHS = 1,
    USD = 2,
}

export class GetAtmHealthsResponseModel implements IGetAtmHealthsResponseModel {
    data?: AtmHealthDto[] | undefined;
    count?: number;

    constructor(data?: IGetAtmHealthsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AtmHealthDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAtmHealthsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmHealthsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetAtmHealthsResponseModel {
    data?: AtmHealthDto[] | undefined;
    count?: number;
}

export class AtmHealthDto implements IAtmHealthDto {
    atmId?: string | undefined;
    name?: string | undefined;
    ipAddress?: string | undefined;
    isOnline?: boolean;
    isConnected?: boolean;
    pingSucceeded?: boolean;
    pingLatencyMs?: number | undefined;
    lastSeenAt?: string | undefined;
    healthStatus?: number;
    cashStatus?: number;
    healthCheckedAt?: string | undefined;
    components?: AtmComponentStatusDto[] | undefined;

    constructor(data?: IAtmHealthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atmId = _data["atmId"];
            this.name = _data["name"];
            this.ipAddress = _data["ipAddress"];
            this.isOnline = _data["isOnline"];
            this.isConnected = _data["isConnected"];
            this.pingSucceeded = _data["pingSucceeded"];
            this.pingLatencyMs = _data["pingLatencyMs"];
            this.lastSeenAt = _data["lastSeenAt"];
            this.healthStatus = _data["healthStatus"];
            this.cashStatus = _data["cashStatus"];
            this.healthCheckedAt = _data["healthCheckedAt"];
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(AtmComponentStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AtmHealthDto {
        data = typeof data === 'object' ? data : {};
        let result = new AtmHealthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmId"] = this.atmId;
        data["name"] = this.name;
        data["ipAddress"] = this.ipAddress;
        data["isOnline"] = this.isOnline;
        data["isConnected"] = this.isConnected;
        data["pingSucceeded"] = this.pingSucceeded;
        data["pingLatencyMs"] = this.pingLatencyMs;
        data["lastSeenAt"] = this.lastSeenAt;
        data["healthStatus"] = this.healthStatus;
        data["cashStatus"] = this.cashStatus;
        data["healthCheckedAt"] = this.healthCheckedAt;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAtmHealthDto {
    atmId?: string | undefined;
    name?: string | undefined;
    ipAddress?: string | undefined;
    isOnline?: boolean;
    isConnected?: boolean;
    pingSucceeded?: boolean;
    pingLatencyMs?: number | undefined;
    lastSeenAt?: string | undefined;
    healthStatus?: number;
    cashStatus?: number;
    healthCheckedAt?: string | undefined;
    components?: AtmComponentStatusDto[] | undefined;
}

export class AtmComponentStatusDto implements IAtmComponentStatusDto {
    component?: string | undefined;
    status?: number;
    detail?: string | undefined;
    updatedAt?: string;

    constructor(data?: IAtmComponentStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.component = _data["component"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.updatedAt = _data["updatedAt"];
        }
    }

    static fromJS(data: any): AtmComponentStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AtmComponentStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["component"] = this.component;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["updatedAt"] = this.updatedAt;
        return data;
    }
}

export interface IAtmComponentStatusDto {
    component?: string | undefined;
    status?: number;
    detail?: string | undefined;
    updatedAt?: string;
}

export class GetAtmHealthByIdResponseModel implements IGetAtmHealthByIdResponseModel {
    data?: AtmHealthDto | undefined;

    constructor(data?: IGetAtmHealthByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AtmHealthDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetAtmHealthByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmHealthByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetAtmHealthByIdResponseModel {
    data?: AtmHealthDto | undefined;
}

export class GetAtmProfileResponseModel implements IGetAtmProfileResponseModel {
    data?: AtmProfileDto | undefined;

    constructor(data?: IGetAtmProfileResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AtmProfileDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetAtmProfileResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmProfileResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetAtmProfileResponseModel {
    data?: AtmProfileDto | undefined;
}

export class AtmProfileDto implements IAtmProfileDto {
    currency?: AtmCurrencyType;
    isEnabled?: boolean;
    depositEnabled?: boolean;
    withdrawEnabled?: boolean;
    mtnEnabled?: boolean;
    m2UEnabled?: boolean;
    mojoPayEnabled?: boolean;
    orangeEnabled?: boolean;
    cryptoEnabled?: boolean;
    vodafoneEnabled?: boolean;
    airtelTigoEnabled?: boolean;
    mtnGhanaEnabled?: boolean;
    bankEnabled?: boolean;
    allowedCurrencies?: number[] | undefined;
    allowedNotes?: number[] | undefined;

    constructor(data?: IAtmProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.isEnabled = _data["isEnabled"];
            this.depositEnabled = _data["depositEnabled"];
            this.withdrawEnabled = _data["withdrawEnabled"];
            this.mtnEnabled = _data["mtnEnabled"];
            this.m2UEnabled = _data["m2UEnabled"];
            this.mojoPayEnabled = _data["mojoPayEnabled"];
            this.orangeEnabled = _data["orangeEnabled"];
            this.cryptoEnabled = _data["cryptoEnabled"];
            this.vodafoneEnabled = _data["vodafoneEnabled"];
            this.airtelTigoEnabled = _data["airtelTigoEnabled"];
            this.mtnGhanaEnabled = _data["mtnGhanaEnabled"];
            this.bankEnabled = _data["bankEnabled"];
            if (Array.isArray(_data["allowedCurrencies"])) {
                this.allowedCurrencies = [] as any;
                for (let item of _data["allowedCurrencies"])
                    this.allowedCurrencies!.push(item);
            }
            if (Array.isArray(_data["allowedNotes"])) {
                this.allowedNotes = [] as any;
                for (let item of _data["allowedNotes"])
                    this.allowedNotes!.push(item);
            }
        }
    }

    static fromJS(data: any): AtmProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new AtmProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["isEnabled"] = this.isEnabled;
        data["depositEnabled"] = this.depositEnabled;
        data["withdrawEnabled"] = this.withdrawEnabled;
        data["mtnEnabled"] = this.mtnEnabled;
        data["m2UEnabled"] = this.m2UEnabled;
        data["mojoPayEnabled"] = this.mojoPayEnabled;
        data["orangeEnabled"] = this.orangeEnabled;
        data["cryptoEnabled"] = this.cryptoEnabled;
        data["vodafoneEnabled"] = this.vodafoneEnabled;
        data["airtelTigoEnabled"] = this.airtelTigoEnabled;
        data["mtnGhanaEnabled"] = this.mtnGhanaEnabled;
        data["bankEnabled"] = this.bankEnabled;
        if (Array.isArray(this.allowedCurrencies)) {
            data["allowedCurrencies"] = [];
            for (let item of this.allowedCurrencies)
                data["allowedCurrencies"].push(item);
        }
        if (Array.isArray(this.allowedNotes)) {
            data["allowedNotes"] = [];
            for (let item of this.allowedNotes)
                data["allowedNotes"].push(item);
        }
        return data;
    }
}

export interface IAtmProfileDto {
    currency?: AtmCurrencyType;
    isEnabled?: boolean;
    depositEnabled?: boolean;
    withdrawEnabled?: boolean;
    mtnEnabled?: boolean;
    m2UEnabled?: boolean;
    mojoPayEnabled?: boolean;
    orangeEnabled?: boolean;
    cryptoEnabled?: boolean;
    vodafoneEnabled?: boolean;
    airtelTigoEnabled?: boolean;
    mtnGhanaEnabled?: boolean;
    bankEnabled?: boolean;
    allowedCurrencies?: number[] | undefined;
    allowedNotes?: number[] | undefined;
}

export class GetAtmDetailByIdResponseModel implements IGetAtmDetailByIdResponseModel {
    data?: AtmDetailDto | undefined;

    constructor(data?: IGetAtmDetailByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AtmDetailDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetAtmDetailByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmDetailByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetAtmDetailByIdResponseModel {
    data?: AtmDetailDto | undefined;
}

export class AtmDetailDto extends AtmDto implements IAtmDetailDto {
    mtnEnabled?: boolean;
    m2UEnabled?: boolean;
    mojoPayEnabled?: boolean;
    orangeEnabled?: boolean;
    cryptoEnabled?: boolean;
    vodafoneEnabled?: boolean;
    airtelTigoEnabled?: boolean;
    mtnGhanaEnabled?: boolean;
    bankEnabled?: boolean;
    withdrawEnabled?: boolean;
    depositEnabled?: boolean;

    constructor(data?: IAtmDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mtnEnabled = _data["mtnEnabled"];
            this.m2UEnabled = _data["m2UEnabled"];
            this.mojoPayEnabled = _data["mojoPayEnabled"];
            this.orangeEnabled = _data["orangeEnabled"];
            this.cryptoEnabled = _data["cryptoEnabled"];
            this.vodafoneEnabled = _data["vodafoneEnabled"];
            this.airtelTigoEnabled = _data["airtelTigoEnabled"];
            this.mtnGhanaEnabled = _data["mtnGhanaEnabled"];
            this.bankEnabled = _data["bankEnabled"];
            this.withdrawEnabled = _data["withdrawEnabled"];
            this.depositEnabled = _data["depositEnabled"];
        }
    }

    static override fromJS(data: any): AtmDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AtmDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mtnEnabled"] = this.mtnEnabled;
        data["m2UEnabled"] = this.m2UEnabled;
        data["mojoPayEnabled"] = this.mojoPayEnabled;
        data["orangeEnabled"] = this.orangeEnabled;
        data["cryptoEnabled"] = this.cryptoEnabled;
        data["vodafoneEnabled"] = this.vodafoneEnabled;
        data["airtelTigoEnabled"] = this.airtelTigoEnabled;
        data["mtnGhanaEnabled"] = this.mtnGhanaEnabled;
        data["bankEnabled"] = this.bankEnabled;
        data["withdrawEnabled"] = this.withdrawEnabled;
        data["depositEnabled"] = this.depositEnabled;
        super.toJSON(data);
        return data;
    }
}

export interface IAtmDetailDto extends IAtmDto {
    mtnEnabled?: boolean;
    m2UEnabled?: boolean;
    mojoPayEnabled?: boolean;
    orangeEnabled?: boolean;
    cryptoEnabled?: boolean;
    vodafoneEnabled?: boolean;
    airtelTigoEnabled?: boolean;
    mtnGhanaEnabled?: boolean;
    bankEnabled?: boolean;
    withdrawEnabled?: boolean;
    depositEnabled?: boolean;
}

export class GetAtmsDropDownResponseModel implements IGetAtmsDropDownResponseModel {
    data?: AtmDropDownDto[] | undefined;

    constructor(data?: IGetAtmsDropDownResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AtmDropDownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAtmsDropDownResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmsDropDownResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAtmsDropDownResponseModel {
    data?: AtmDropDownDto[] | undefined;
}

export class AtmDropDownDto implements IAtmDropDownDto {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IAtmDropDownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AtmDropDownDto {
        data = typeof data === 'object' ? data : {};
        let result = new AtmDropDownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAtmDropDownDto {
    id?: string | undefined;
    name?: string | undefined;
}

export class GetAtmsPublicDropDownResponseModel implements IGetAtmsPublicDropDownResponseModel {
    data?: AtmDropDownDto[] | undefined;

    constructor(data?: IGetAtmsPublicDropDownResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AtmDropDownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAtmsPublicDropDownResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmsPublicDropDownResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAtmsPublicDropDownResponseModel {
    data?: AtmDropDownDto[] | undefined;
}

export class CreateAtmResponseModel implements ICreateAtmResponseModel {
    data?: AtmDto | undefined;

    constructor(data?: ICreateAtmResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AtmDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateAtmResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAtmResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateAtmResponseModel {
    data?: AtmDto | undefined;
}

export class CreateAtmRequestModel implements ICreateAtmRequestModel {
    regionId?: number;
    managerId?: string | undefined;
    name?: string | undefined;
    ipAddress?: string | undefined;
    address?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    countryId?: number;
    currency?: AtmCurrencyType;
    partnerId?: string | undefined;

    constructor(data?: ICreateAtmRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.managerId = _data["managerId"];
            this.name = _data["name"];
            this.ipAddress = _data["ipAddress"];
            this.address = _data["address"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.countryId = _data["countryId"];
            this.currency = _data["currency"];
            this.partnerId = _data["partnerId"];
        }
    }

    static fromJS(data: any): CreateAtmRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAtmRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["managerId"] = this.managerId;
        data["name"] = this.name;
        data["ipAddress"] = this.ipAddress;
        data["address"] = this.address;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["countryId"] = this.countryId;
        data["currency"] = this.currency;
        data["partnerId"] = this.partnerId;
        return data;
    }
}

export interface ICreateAtmRequestModel {
    regionId?: number;
    managerId?: string | undefined;
    name?: string | undefined;
    ipAddress?: string | undefined;
    address?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    countryId?: number;
    currency?: AtmCurrencyType;
    partnerId?: string | undefined;
}

export class UpdateAtmResponseModel implements IUpdateAtmResponseModel {
    data?: AtmDto | undefined;

    constructor(data?: IUpdateAtmResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AtmDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateAtmResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAtmResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateAtmResponseModel {
    data?: AtmDto | undefined;
}

export class UpdateAtmRequestModel implements IUpdateAtmRequestModel {
    regionId?: number;
    name?: string | undefined;
    ipAddress?: string | undefined;
    address?: string | undefined;
    userName?: string | undefined;
    id?: string | undefined;
    managerId?: string | undefined;
    countryId?: number;
    currency?: AtmCurrencyType;

    constructor(data?: IUpdateAtmRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.name = _data["name"];
            this.ipAddress = _data["ipAddress"];
            this.address = _data["address"];
            this.userName = _data["userName"];
            this.id = _data["id"];
            this.managerId = _data["managerId"];
            this.countryId = _data["countryId"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): UpdateAtmRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAtmRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["ipAddress"] = this.ipAddress;
        data["address"] = this.address;
        data["userName"] = this.userName;
        data["id"] = this.id;
        data["managerId"] = this.managerId;
        data["countryId"] = this.countryId;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IUpdateAtmRequestModel {
    regionId?: number;
    name?: string | undefined;
    ipAddress?: string | undefined;
    address?: string | undefined;
    userName?: string | undefined;
    id?: string | undefined;
    managerId?: string | undefined;
    countryId?: number;
    currency?: AtmCurrencyType;
}

export class UpdateAtmEnableResponseModel implements IUpdateAtmEnableResponseModel {

    constructor(data?: IUpdateAtmEnableResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateAtmEnableResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAtmEnableResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateAtmEnableResponseModel {
}

export class UpdateAtmEnableRequestModel implements IUpdateAtmEnableRequestModel {
    id?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IUpdateAtmEnableRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdateAtmEnableRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAtmEnableRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpdateAtmEnableRequestModel {
    id?: string | undefined;
    isEnabled?: boolean;
}

export class UpdateAtmSettingResponseModel implements IUpdateAtmSettingResponseModel {

    constructor(data?: IUpdateAtmSettingResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateAtmSettingResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAtmSettingResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateAtmSettingResponseModel {
}

export class UpdateAtmSettingRequestModel implements IUpdateAtmSettingRequestModel {
    id?: string | undefined;
    type?: AtmFunctionType;
    isEnabled?: boolean;

    constructor(data?: IUpdateAtmSettingRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdateAtmSettingRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAtmSettingRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpdateAtmSettingRequestModel {
    id?: string | undefined;
    type?: AtmFunctionType;
    isEnabled?: boolean;
}

export enum AtmFunctionType {
    Mtn = 0,
    Orange = 1,
    Crypto = 2,
    Deposit = 3,
    Withdraw = 4,
    M2U = 5,
    MojoPay = 6,
    Vodafone = 7,
    AirtelTigo = 8,
    MtnGhana = 9,
    Bank = 10,
}

export class GetAtmBanksResponseModel implements IGetAtmBanksResponseModel {
    data?: AtmBankDto[] | undefined;

    constructor(data?: IGetAtmBanksResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AtmBankDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAtmBanksResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmBanksResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAtmBanksResponseModel {
    data?: AtmBankDto[] | undefined;
}

export class AtmBankDto implements IAtmBankDto {
    bankCode?: string | undefined;
    bankName?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IAtmBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankCode = _data["bankCode"];
            this.bankName = _data["bankName"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): AtmBankDto {
        data = typeof data === 'object' ? data : {};
        let result = new AtmBankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IAtmBankDto {
    bankCode?: string | undefined;
    bankName?: string | undefined;
    isEnabled?: boolean;
}

export class AssignAtmBankResponseModel implements IAssignAtmBankResponseModel {

    constructor(data?: IAssignAtmBankResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AssignAtmBankResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignAtmBankResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAssignAtmBankResponseModel {
}

export class AssignAtmBankRequestModel implements IAssignAtmBankRequestModel {
    atmId?: string | undefined;
    bankCode?: string | undefined;

    constructor(data?: IAssignAtmBankRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atmId = _data["atmId"];
            this.bankCode = _data["bankCode"];
        }
    }

    static fromJS(data: any): AssignAtmBankRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignAtmBankRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmId"] = this.atmId;
        data["bankCode"] = this.bankCode;
        return data;
    }
}

export interface IAssignAtmBankRequestModel {
    atmId?: string | undefined;
    bankCode?: string | undefined;
}

export class RemoveAtmBankResponseModel implements IRemoveAtmBankResponseModel {

    constructor(data?: IRemoveAtmBankResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RemoveAtmBankResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveAtmBankResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRemoveAtmBankResponseModel {
}

export class UpdateAtmBankResponseModel implements IUpdateAtmBankResponseModel {

    constructor(data?: IUpdateAtmBankResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateAtmBankResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAtmBankResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateAtmBankResponseModel {
}

export class UpdateAtmBankRequestModel implements IUpdateAtmBankRequestModel {
    atmId?: string | undefined;
    bankCode?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IUpdateAtmBankRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atmId = _data["atmId"];
            this.bankCode = _data["bankCode"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdateAtmBankRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAtmBankRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmId"] = this.atmId;
        data["bankCode"] = this.bankCode;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpdateAtmBankRequestModel {
    atmId?: string | undefined;
    bankCode?: string | undefined;
    isEnabled?: boolean;
}

export class UpdateAtmCurrencyResponseModel implements IUpdateAtmCurrencyResponseModel {

    constructor(data?: IUpdateAtmCurrencyResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateAtmCurrencyResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAtmCurrencyResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateAtmCurrencyResponseModel {
}

export class UpdateAtmCurrencyRequestModel implements IUpdateAtmCurrencyRequestModel {
    id?: string | undefined;
    currency?: AtmCurrencyType;

    constructor(data?: IUpdateAtmCurrencyRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): UpdateAtmCurrencyRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAtmCurrencyRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IUpdateAtmCurrencyRequestModel {
    id?: string | undefined;
    currency?: AtmCurrencyType;
}

export class DeleteAtmResponseModel implements IDeleteAtmResponseModel {

    constructor(data?: IDeleteAtmResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteAtmResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAtmResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteAtmResponseModel {
}

export class GetAtmsWithDenominationResponseModel implements IGetAtmsWithDenominationResponseModel {
    data?: AtmDto[] | undefined;

    constructor(data?: IGetAtmsWithDenominationResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AtmDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAtmsWithDenominationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmsWithDenominationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAtmsWithDenominationResponseModel {
    data?: AtmDto[] | undefined;
}

export class GetAtmsWithDenominationRequestModel implements IGetAtmsWithDenominationRequestModel {
    amount?: number;

    constructor(data?: IGetAtmsWithDenominationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): GetAtmsWithDenominationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmsWithDenominationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        return data;
    }
}

export interface IGetAtmsWithDenominationRequestModel {
    amount?: number;
}

export class RefreshBankCacheResponseModel implements IRefreshBankCacheResponseModel {
    count?: number;

    constructor(data?: IRefreshBankCacheResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): RefreshBankCacheResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshBankCacheResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data;
    }
}

export interface IRefreshBankCacheResponseModel {
    count?: number;
}

export class GetBanksResponseModel implements IGetBanksResponseModel {
    banks?: BankItem[] | undefined;

    constructor(data?: IGetBanksResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["banks"])) {
                this.banks = [] as any;
                for (let item of _data["banks"])
                    this.banks!.push(BankItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBanksResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetBanksResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.banks)) {
            data["banks"] = [];
            for (let item of this.banks)
                data["banks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetBanksResponseModel {
    banks?: BankItem[] | undefined;
}

export class BankItem implements IBankItem {
    bankCode?: string | undefined;
    bankName?: string | undefined;
    country?: string | undefined;

    constructor(data?: IBankItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankCode = _data["bankCode"];
            this.bankName = _data["bankName"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): BankItem {
        data = typeof data === 'object' ? data : {};
        let result = new BankItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["country"] = this.country;
        return data;
    }
}

export interface IBankItem {
    bankCode?: string | undefined;
    bankName?: string | undefined;
    country?: string | undefined;
}

export class GetCommissionRatesResponseModel implements IGetCommissionRatesResponseModel {
    rates?: CommissionRateDto[] | undefined;
    tierRates?: TierCommissionRateDto[] | undefined;

    constructor(data?: IGetCommissionRatesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rates"])) {
                this.rates = [] as any;
                for (let item of _data["rates"])
                    this.rates!.push(CommissionRateDto.fromJS(item));
            }
            if (Array.isArray(_data["tierRates"])) {
                this.tierRates = [] as any;
                for (let item of _data["tierRates"])
                    this.tierRates!.push(TierCommissionRateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCommissionRatesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommissionRatesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rates)) {
            data["rates"] = [];
            for (let item of this.rates)
                data["rates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tierRates)) {
            data["tierRates"] = [];
            for (let item of this.tierRates)
                data["tierRates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCommissionRatesResponseModel {
    rates?: CommissionRateDto[] | undefined;
    tierRates?: TierCommissionRateDto[] | undefined;
}

export class CommissionRateDto implements ICommissionRateDto {
    id?: number;
    operatorType?: number;
    txnType?: string | undefined;
    network?: string | undefined;
    bankCode?: string | undefined;
    bankName?: string | undefined;
    operatorName?: string | undefined;
    ratePct?: number;
    rateType?: number;
    currency?: string | undefined;
    effectiveFrom?: string;

    constructor(data?: ICommissionRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operatorType = _data["operatorType"];
            this.txnType = _data["txnType"];
            this.network = _data["network"];
            this.bankCode = _data["bankCode"];
            this.bankName = _data["bankName"];
            this.operatorName = _data["operatorName"];
            this.ratePct = _data["ratePct"];
            this.rateType = _data["rateType"];
            this.currency = _data["currency"];
            this.effectiveFrom = _data["effectiveFrom"];
        }
    }

    static fromJS(data: any): CommissionRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operatorType"] = this.operatorType;
        data["txnType"] = this.txnType;
        data["network"] = this.network;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["operatorName"] = this.operatorName;
        data["ratePct"] = this.ratePct;
        data["rateType"] = this.rateType;
        data["currency"] = this.currency;
        data["effectiveFrom"] = this.effectiveFrom;
        return data;
    }
}

export interface ICommissionRateDto {
    id?: number;
    operatorType?: number;
    txnType?: string | undefined;
    network?: string | undefined;
    bankCode?: string | undefined;
    bankName?: string | undefined;
    operatorName?: string | undefined;
    ratePct?: number;
    rateType?: number;
    currency?: string | undefined;
    effectiveFrom?: string;
}

export class TierCommissionRateDto implements ITierCommissionRateDto {
    id?: number;
    operatorType?: number;
    network?: string | undefined;
    bankCode?: string | undefined;
    bankName?: string | undefined;
    operatorName?: string | undefined;
    minAmount?: number;
    maxAmount?: number | undefined;
    rateType?: number;
    flatAmount?: number | undefined;
    ratePct?: number | undefined;

    constructor(data?: ITierCommissionRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operatorType = _data["operatorType"];
            this.network = _data["network"];
            this.bankCode = _data["bankCode"];
            this.bankName = _data["bankName"];
            this.operatorName = _data["operatorName"];
            this.minAmount = _data["minAmount"];
            this.maxAmount = _data["maxAmount"];
            this.rateType = _data["rateType"];
            this.flatAmount = _data["flatAmount"];
            this.ratePct = _data["ratePct"];
        }
    }

    static fromJS(data: any): TierCommissionRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TierCommissionRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operatorType"] = this.operatorType;
        data["network"] = this.network;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["operatorName"] = this.operatorName;
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        data["rateType"] = this.rateType;
        data["flatAmount"] = this.flatAmount;
        data["ratePct"] = this.ratePct;
        return data;
    }
}

export interface ITierCommissionRateDto {
    id?: number;
    operatorType?: number;
    network?: string | undefined;
    bankCode?: string | undefined;
    bankName?: string | undefined;
    operatorName?: string | undefined;
    minAmount?: number;
    maxAmount?: number | undefined;
    rateType?: number;
    flatAmount?: number | undefined;
    ratePct?: number | undefined;
}

export class CreateCommissionRateResponseModel implements ICreateCommissionRateResponseModel {
    data?: CommissionRateDto | undefined;

    constructor(data?: ICreateCommissionRateResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CommissionRateDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateCommissionRateResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommissionRateResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateCommissionRateResponseModel {
    data?: CommissionRateDto | undefined;
}

export class CreateCommissionRateRequestModel implements ICreateCommissionRateRequestModel {
    operatorType?: number;
    txnType?: string | undefined;
    network?: string | undefined;
    bankCode?: string | undefined;
    ratePct?: number;
    rateType?: number;
    currency?: string | undefined;

    constructor(data?: ICreateCommissionRateRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatorType = _data["operatorType"];
            this.txnType = _data["txnType"];
            this.network = _data["network"];
            this.bankCode = _data["bankCode"];
            this.ratePct = _data["ratePct"];
            this.rateType = _data["rateType"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): CreateCommissionRateRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommissionRateRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatorType"] = this.operatorType;
        data["txnType"] = this.txnType;
        data["network"] = this.network;
        data["bankCode"] = this.bankCode;
        data["ratePct"] = this.ratePct;
        data["rateType"] = this.rateType;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ICreateCommissionRateRequestModel {
    operatorType?: number;
    txnType?: string | undefined;
    network?: string | undefined;
    bankCode?: string | undefined;
    ratePct?: number;
    rateType?: number;
    currency?: string | undefined;
}

export class DeleteCommissionRateResponseModel implements IDeleteCommissionRateResponseModel {

    constructor(data?: IDeleteCommissionRateResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteCommissionRateResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCommissionRateResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteCommissionRateResponseModel {
}

export class GetProfitShareConfigsResponseModel implements IGetProfitShareConfigsResponseModel {
    data?: ProfitShareConfigDto[] | undefined;

    constructor(data?: IGetProfitShareConfigsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProfitShareConfigDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProfitShareConfigsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfitShareConfigsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProfitShareConfigsResponseModel {
    data?: ProfitShareConfigDto[] | undefined;
}

export class ProfitShareConfigDto implements IProfitShareConfigDto {
    id?: number;
    partyRole?: number;
    sharePct?: number;

    constructor(data?: IProfitShareConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partyRole = _data["partyRole"];
            this.sharePct = _data["sharePct"];
        }
    }

    static fromJS(data: any): ProfitShareConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfitShareConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partyRole"] = this.partyRole;
        data["sharePct"] = this.sharePct;
        return data;
    }
}

export interface IProfitShareConfigDto {
    id?: number;
    partyRole?: number;
    sharePct?: number;
}

export class GetWithdrawalMinimumsResponseModel implements IGetWithdrawalMinimumsResponseModel {
    data?: WithdrawalMinimumDto[] | undefined;

    constructor(data?: IGetWithdrawalMinimumsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WithdrawalMinimumDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWithdrawalMinimumsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetWithdrawalMinimumsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetWithdrawalMinimumsResponseModel {
    data?: WithdrawalMinimumDto[] | undefined;
}

export class WithdrawalMinimumDto implements IWithdrawalMinimumDto {
    id?: number;
    currency?: string | undefined;
    minAmount?: number;

    constructor(data?: IWithdrawalMinimumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.currency = _data["currency"];
            this.minAmount = _data["minAmount"];
        }
    }

    static fromJS(data: any): WithdrawalMinimumDto {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawalMinimumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currency"] = this.currency;
        data["minAmount"] = this.minAmount;
        return data;
    }
}

export interface IWithdrawalMinimumDto {
    id?: number;
    currency?: string | undefined;
    minAmount?: number;
}

export class UpdateCommissionRateResponseModel implements IUpdateCommissionRateResponseModel {

    constructor(data?: IUpdateCommissionRateResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateCommissionRateResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommissionRateResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateCommissionRateResponseModel {
}

export class UpdateCommissionRateRequestModel implements IUpdateCommissionRateRequestModel {
    id?: number;
    ratePct?: number;

    constructor(data?: IUpdateCommissionRateRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ratePct = _data["ratePct"];
        }
    }

    static fromJS(data: any): UpdateCommissionRateRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommissionRateRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ratePct"] = this.ratePct;
        return data;
    }
}

export interface IUpdateCommissionRateRequestModel {
    id?: number;
    ratePct?: number;
}

export class UpdateProfitShareConfigResponseModel implements IUpdateProfitShareConfigResponseModel {

    constructor(data?: IUpdateProfitShareConfigResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateProfitShareConfigResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfitShareConfigResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateProfitShareConfigResponseModel {
}

export class UpdateProfitShareConfigRequestModel implements IUpdateProfitShareConfigRequestModel {
    id?: number;
    sharePct?: number;

    constructor(data?: IUpdateProfitShareConfigRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sharePct = _data["sharePct"];
        }
    }

    static fromJS(data: any): UpdateProfitShareConfigRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfitShareConfigRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sharePct"] = this.sharePct;
        return data;
    }
}

export interface IUpdateProfitShareConfigRequestModel {
    id?: number;
    sharePct?: number;
}

export class UpsertWithdrawalMinimumResponseModel implements IUpsertWithdrawalMinimumResponseModel {

    constructor(data?: IUpsertWithdrawalMinimumResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpsertWithdrawalMinimumResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertWithdrawalMinimumResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpsertWithdrawalMinimumResponseModel {
}

export class UpsertWithdrawalMinimumRequestModel implements IUpsertWithdrawalMinimumRequestModel {
    currency?: string | undefined;
    minAmount?: number;

    constructor(data?: IUpsertWithdrawalMinimumRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.minAmount = _data["minAmount"];
        }
    }

    static fromJS(data: any): UpsertWithdrawalMinimumRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertWithdrawalMinimumRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["minAmount"] = this.minAmount;
        return data;
    }
}

export interface IUpsertWithdrawalMinimumRequestModel {
    currency?: string | undefined;
    minAmount?: number;
}

export class CreateTierCommissionRateResponseModel implements ICreateTierCommissionRateResponseModel {
    data?: TierCommissionRateDto | undefined;

    constructor(data?: ICreateTierCommissionRateResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TierCommissionRateDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateTierCommissionRateResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTierCommissionRateResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateTierCommissionRateResponseModel {
    data?: TierCommissionRateDto | undefined;
}

export class CreateTierCommissionRateRequestModel implements ICreateTierCommissionRateRequestModel {
    operatorType?: number;
    network?: string | undefined;
    bankCode?: string | undefined;
    minAmount?: number;
    maxAmount?: number | undefined;
    rateType?: number;
    flatAmount?: number | undefined;
    ratePct?: number | undefined;

    constructor(data?: ICreateTierCommissionRateRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatorType = _data["operatorType"];
            this.network = _data["network"];
            this.bankCode = _data["bankCode"];
            this.minAmount = _data["minAmount"];
            this.maxAmount = _data["maxAmount"];
            this.rateType = _data["rateType"];
            this.flatAmount = _data["flatAmount"];
            this.ratePct = _data["ratePct"];
        }
    }

    static fromJS(data: any): CreateTierCommissionRateRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTierCommissionRateRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatorType"] = this.operatorType;
        data["network"] = this.network;
        data["bankCode"] = this.bankCode;
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        data["rateType"] = this.rateType;
        data["flatAmount"] = this.flatAmount;
        data["ratePct"] = this.ratePct;
        return data;
    }
}

export interface ICreateTierCommissionRateRequestModel {
    operatorType?: number;
    network?: string | undefined;
    bankCode?: string | undefined;
    minAmount?: number;
    maxAmount?: number | undefined;
    rateType?: number;
    flatAmount?: number | undefined;
    ratePct?: number | undefined;
}

export class UpdateTierCommissionRateResponseModel implements IUpdateTierCommissionRateResponseModel {

    constructor(data?: IUpdateTierCommissionRateResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateTierCommissionRateResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTierCommissionRateResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateTierCommissionRateResponseModel {
}

export class UpdateTierCommissionRateRequestModel implements IUpdateTierCommissionRateRequestModel {
    id?: number;
    minAmount?: number;
    maxAmount?: number | undefined;
    flatAmount?: number | undefined;
    ratePct?: number | undefined;

    constructor(data?: IUpdateTierCommissionRateRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.minAmount = _data["minAmount"];
            this.maxAmount = _data["maxAmount"];
            this.flatAmount = _data["flatAmount"];
            this.ratePct = _data["ratePct"];
        }
    }

    static fromJS(data: any): UpdateTierCommissionRateRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTierCommissionRateRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        data["flatAmount"] = this.flatAmount;
        data["ratePct"] = this.ratePct;
        return data;
    }
}

export interface IUpdateTierCommissionRateRequestModel {
    id?: number;
    minAmount?: number;
    maxAmount?: number | undefined;
    flatAmount?: number | undefined;
    ratePct?: number | undefined;
}

export class DeleteTierCommissionRateResponseModel implements IDeleteTierCommissionRateResponseModel {

    constructor(data?: IDeleteTierCommissionRateResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteTierCommissionRateResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTierCommissionRateResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteTierCommissionRateResponseModel {
}

export class GetCountriesResponseModel implements IGetCountriesResponseModel {
    data?: CountryDto[] | undefined;
    count?: number;

    constructor(data?: IGetCountriesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CountryDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetCountriesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCountriesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetCountriesResponseModel {
    data?: CountryDto[] | undefined;
    count?: number;
}

export class CountryDto implements ICountryDto {
    id?: number;
    name?: string | undefined;
    countryId?: number;
    countryName?: string | undefined;
    createdDate?: string;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface ICountryDto {
    id?: number;
    name?: string | undefined;
    countryId?: number;
    countryName?: string | undefined;
    createdDate?: string;
}

export class GetCountriesDropDownResponseModel implements IGetCountriesDropDownResponseModel {
    data?: CountryDropDownDto[] | undefined;

    constructor(data?: IGetCountriesDropDownResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CountryDropDownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCountriesDropDownResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCountriesDropDownResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCountriesDropDownResponseModel {
    data?: CountryDropDownDto[] | undefined;
}

export class CountryDropDownDto implements ICountryDropDownDto {
    name?: string | undefined;
    id?: number;

    constructor(data?: ICountryDropDownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CountryDropDownDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDropDownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICountryDropDownDto {
    name?: string | undefined;
    id?: number;
}

export class CreateCountryResponseModel implements ICreateCountryResponseModel {
    data?: CountryDto | undefined;

    constructor(data?: ICreateCountryResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CountryDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateCountryResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateCountryResponseModel {
    data?: CountryDto | undefined;
}

export class CreateCountryRequestModel implements ICreateCountryRequestModel {
    name?: string | undefined;

    constructor(data?: ICreateCountryRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCountryRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateCountryRequestModel {
    name?: string | undefined;
}

export class UpdateCountryResponseModel implements IUpdateCountryResponseModel {
    data?: CountryDto | undefined;

    constructor(data?: IUpdateCountryResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CountryDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateCountryResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCountryResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateCountryResponseModel {
    data?: CountryDto | undefined;
}

export class UpdateCountryRequestModel implements IUpdateCountryRequestModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: IUpdateCountryRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateCountryRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCountryRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateCountryRequestModel {
    id?: number;
    name?: string | undefined;
}

export class DeleteCountryResponseModel implements IDeleteCountryResponseModel {

    constructor(data?: IDeleteCountryResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteCountryResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCountryResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteCountryResponseModel {
}

export class GetCryptoTokensResponseModel implements IGetCryptoTokensResponseModel {
    data?: CryptoTokenDto[] | undefined;
    count?: number;

    constructor(data?: IGetCryptoTokensResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CryptoTokenDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetCryptoTokensResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCryptoTokensResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetCryptoTokensResponseModel {
    data?: CryptoTokenDto[] | undefined;
    count?: number;
}

export class CryptoTokenDto implements ICryptoTokenDto {
    id?: number;
    address?: string | undefined;
    symbol?: string | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    chain?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;

    constructor(data?: ICryptoTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.symbol = _data["symbol"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.chain = _data["chain"];
            this.isEnabled = _data["isEnabled"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): CryptoTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new CryptoTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["symbol"] = this.symbol;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["chain"] = this.chain;
        data["isEnabled"] = this.isEnabled;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface ICryptoTokenDto {
    id?: number;
    address?: string | undefined;
    symbol?: string | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    chain?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;
}

export class GetCryptoTransactionsResponseModel implements IGetCryptoTransactionsResponseModel {
    data?: CryptoTransactionDto[] | undefined;
    count?: number;

    constructor(data?: IGetCryptoTransactionsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CryptoTransactionDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetCryptoTransactionsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCryptoTransactionsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetCryptoTransactionsResponseModel {
    data?: CryptoTransactionDto[] | undefined;
    count?: number;
}

export class CryptoTransactionDto implements ICryptoTransactionDto {
    id?: number;
    atm?: string | undefined;
    phoneNumber?: string | undefined;
    status?: string | undefined;
    symbol?: string | undefined;
    redeemedDate?: string | undefined;
    createdDate?: string;
    gasFee?: number;
    amountIn?: number;
    type?: number;
    amountOut?: number;
    isRedeemed?: boolean;
    avgPrice?: string | undefined;
    totalLocal?: string | undefined;
    totalUsd?: string | undefined;
    receiverAddress?: string | undefined;
    currency?: string | undefined;

    constructor(data?: ICryptoTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.atm = _data["atm"];
            this.phoneNumber = _data["phoneNumber"];
            this.status = _data["status"];
            this.symbol = _data["symbol"];
            this.redeemedDate = _data["redeemedDate"];
            this.createdDate = _data["createdDate"];
            this.gasFee = _data["gasFee"];
            this.amountIn = _data["amountIn"];
            this.type = _data["type"];
            this.amountOut = _data["amountOut"];
            this.isRedeemed = _data["isRedeemed"];
            this.avgPrice = _data["avgPrice"];
            this.totalLocal = _data["totalLocal"];
            this.totalUsd = _data["totalUsd"];
            this.receiverAddress = _data["receiverAddress"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): CryptoTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CryptoTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["atm"] = this.atm;
        data["phoneNumber"] = this.phoneNumber;
        data["status"] = this.status;
        data["symbol"] = this.symbol;
        data["redeemedDate"] = this.redeemedDate;
        data["createdDate"] = this.createdDate;
        data["gasFee"] = this.gasFee;
        data["amountIn"] = this.amountIn;
        data["type"] = this.type;
        data["amountOut"] = this.amountOut;
        data["isRedeemed"] = this.isRedeemed;
        data["avgPrice"] = this.avgPrice;
        data["totalLocal"] = this.totalLocal;
        data["totalUsd"] = this.totalUsd;
        data["receiverAddress"] = this.receiverAddress;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ICryptoTransactionDto {
    id?: number;
    atm?: string | undefined;
    phoneNumber?: string | undefined;
    status?: string | undefined;
    symbol?: string | undefined;
    redeemedDate?: string | undefined;
    createdDate?: string;
    gasFee?: number;
    amountIn?: number;
    type?: number;
    amountOut?: number;
    isRedeemed?: boolean;
    avgPrice?: string | undefined;
    totalLocal?: string | undefined;
    totalUsd?: string | undefined;
    receiverAddress?: string | undefined;
    currency?: string | undefined;
}

export class GetPublicCryptoTransactionsResponseModel implements IGetPublicCryptoTransactionsResponseModel {
    data?: CryptoTransactionDto[] | undefined;
    count?: number;

    constructor(data?: IGetPublicCryptoTransactionsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CryptoTransactionDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetPublicCryptoTransactionsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicCryptoTransactionsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetPublicCryptoTransactionsResponseModel {
    data?: CryptoTransactionDto[] | undefined;
    count?: number;
}

export class GetPublicCryptoTransactionDetailByIdResponseModel implements IGetPublicCryptoTransactionDetailByIdResponseModel {
    data?: CryptoTransactionDetailDto | undefined;

    constructor(data?: IGetPublicCryptoTransactionDetailByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CryptoTransactionDetailDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetPublicCryptoTransactionDetailByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicCryptoTransactionDetailByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetPublicCryptoTransactionDetailByIdResponseModel {
    data?: CryptoTransactionDetailDto | undefined;
}

export class CryptoTransactionDetailDto implements ICryptoTransactionDetailDto {
    sessionId?: string | undefined;
    atmId?: string | undefined;
    atm?: string | undefined;
    phoneNumber?: string | undefined;
    amount?: number;
    type?: number;
    operatorType?: number;
    transactionId?: string | undefined;
    externalTransactionId?: string | undefined;
    status?: string | undefined;
    id?: number;
    address?: string | undefined;
    userAddress?: string | undefined;
    symbol?: string | undefined;
    name?: string | undefined;
    amountIn?: number;
    amountOut?: number;
    currency?: string | undefined;
    transactionHash?: string | undefined;
    gasFee?: number;
    isRedeemed?: boolean;
    avgPrice?: string | undefined;
    totalLocal?: string | undefined;
    totalUsd?: string | undefined;
    redeemedDate?: string | undefined;
    createdDate?: string;
    receiverAddress?: string | undefined;

    constructor(data?: ICryptoTransactionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.atmId = _data["atmId"];
            this.atm = _data["atm"];
            this.phoneNumber = _data["phoneNumber"];
            this.amount = _data["amount"];
            this.type = _data["type"];
            this.operatorType = _data["operatorType"];
            this.transactionId = _data["transactionId"];
            this.externalTransactionId = _data["externalTransactionId"];
            this.status = _data["status"];
            this.id = _data["id"];
            this.address = _data["address"];
            this.userAddress = _data["userAddress"];
            this.symbol = _data["symbol"];
            this.name = _data["name"];
            this.amountIn = _data["amountIn"];
            this.amountOut = _data["amountOut"];
            this.currency = _data["currency"];
            this.transactionHash = _data["transactionHash"];
            this.gasFee = _data["gasFee"];
            this.isRedeemed = _data["isRedeemed"];
            this.avgPrice = _data["avgPrice"];
            this.totalLocal = _data["totalLocal"];
            this.totalUsd = _data["totalUsd"];
            this.redeemedDate = _data["redeemedDate"];
            this.createdDate = _data["createdDate"];
            this.receiverAddress = _data["receiverAddress"];
        }
    }

    static fromJS(data: any): CryptoTransactionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CryptoTransactionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["atmId"] = this.atmId;
        data["atm"] = this.atm;
        data["phoneNumber"] = this.phoneNumber;
        data["amount"] = this.amount;
        data["type"] = this.type;
        data["operatorType"] = this.operatorType;
        data["transactionId"] = this.transactionId;
        data["externalTransactionId"] = this.externalTransactionId;
        data["status"] = this.status;
        data["id"] = this.id;
        data["address"] = this.address;
        data["userAddress"] = this.userAddress;
        data["symbol"] = this.symbol;
        data["name"] = this.name;
        data["amountIn"] = this.amountIn;
        data["amountOut"] = this.amountOut;
        data["currency"] = this.currency;
        data["transactionHash"] = this.transactionHash;
        data["gasFee"] = this.gasFee;
        data["isRedeemed"] = this.isRedeemed;
        data["avgPrice"] = this.avgPrice;
        data["totalLocal"] = this.totalLocal;
        data["totalUsd"] = this.totalUsd;
        data["redeemedDate"] = this.redeemedDate;
        data["createdDate"] = this.createdDate;
        data["receiverAddress"] = this.receiverAddress;
        return data;
    }
}

export interface ICryptoTransactionDetailDto {
    sessionId?: string | undefined;
    atmId?: string | undefined;
    atm?: string | undefined;
    phoneNumber?: string | undefined;
    amount?: number;
    type?: number;
    operatorType?: number;
    transactionId?: string | undefined;
    externalTransactionId?: string | undefined;
    status?: string | undefined;
    id?: number;
    address?: string | undefined;
    userAddress?: string | undefined;
    symbol?: string | undefined;
    name?: string | undefined;
    amountIn?: number;
    amountOut?: number;
    currency?: string | undefined;
    transactionHash?: string | undefined;
    gasFee?: number;
    isRedeemed?: boolean;
    avgPrice?: string | undefined;
    totalLocal?: string | undefined;
    totalUsd?: string | undefined;
    redeemedDate?: string | undefined;
    createdDate?: string;
    receiverAddress?: string | undefined;
}

export class GetCryptoTransactionDetailByIdResponseModel implements IGetCryptoTransactionDetailByIdResponseModel {
    data?: CryptoTransactionDetailDto | undefined;

    constructor(data?: IGetCryptoTransactionDetailByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CryptoTransactionDetailDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCryptoTransactionDetailByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCryptoTransactionDetailByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCryptoTransactionDetailByIdResponseModel {
    data?: CryptoTransactionDetailDto | undefined;
}

export class RefreshBlockChainNetworksResponseModel implements IRefreshBlockChainNetworksResponseModel {

    constructor(data?: IRefreshBlockChainNetworksResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RefreshBlockChainNetworksResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshBlockChainNetworksResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRefreshBlockChainNetworksResponseModel {
}

export class GetCryptoNetworksResponseModel implements IGetCryptoNetworksResponseModel {
    data?: CryptoNetworkDto[] | undefined;
    count?: number;

    constructor(data?: IGetCryptoNetworksResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CryptoNetworkDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetCryptoNetworksResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCryptoNetworksResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetCryptoNetworksResponseModel {
    data?: CryptoNetworkDto[] | undefined;
    count?: number;
}

export class CryptoNetworkDto implements ICryptoNetworkDto {
    id?: number;
    symbol?: string | undefined;
    icon?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;

    constructor(data?: ICryptoNetworkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.symbol = _data["symbol"];
            this.icon = _data["icon"];
            this.isEnabled = _data["isEnabled"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): CryptoNetworkDto {
        data = typeof data === 'object' ? data : {};
        let result = new CryptoNetworkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["symbol"] = this.symbol;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface ICryptoNetworkDto {
    id?: number;
    symbol?: string | undefined;
    icon?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;
}

export class GetCryptoQuoteResponseModel implements IGetCryptoQuoteResponseModel {
    quote?: number;
    gasFee?: number;
    market?: string | undefined;
    avgPrice?: number;
    slippage?: string | undefined;
    paymentMethod?: string | undefined;
    totalLocal?: string | undefined;
    totalUsd?: string | undefined;
    exchangeRate?: string | undefined;

    constructor(data?: IGetCryptoQuoteResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quote = _data["quote"];
            this.gasFee = _data["gasFee"];
            this.market = _data["market"];
            this.avgPrice = _data["avgPrice"];
            this.slippage = _data["slippage"];
            this.paymentMethod = _data["paymentMethod"];
            this.totalLocal = _data["totalLocal"];
            this.totalUsd = _data["totalUsd"];
            this.exchangeRate = _data["exchangeRate"];
        }
    }

    static fromJS(data: any): GetCryptoQuoteResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCryptoQuoteResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quote"] = this.quote;
        data["gasFee"] = this.gasFee;
        data["market"] = this.market;
        data["avgPrice"] = this.avgPrice;
        data["slippage"] = this.slippage;
        data["paymentMethod"] = this.paymentMethod;
        data["totalLocal"] = this.totalLocal;
        data["totalUsd"] = this.totalUsd;
        data["exchangeRate"] = this.exchangeRate;
        return data;
    }
}

export interface IGetCryptoQuoteResponseModel {
    quote?: number;
    gasFee?: number;
    market?: string | undefined;
    avgPrice?: number;
    slippage?: string | undefined;
    paymentMethod?: string | undefined;
    totalLocal?: string | undefined;
    totalUsd?: string | undefined;
    exchangeRate?: string | undefined;
}

export class UpdateCryptoNetworkEnableResponseModel implements IUpdateCryptoNetworkEnableResponseModel {

    constructor(data?: IUpdateCryptoNetworkEnableResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateCryptoNetworkEnableResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCryptoNetworkEnableResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateCryptoNetworkEnableResponseModel {
}

export class UpdateCryptoNetworkEnableRequestModel implements IUpdateCryptoNetworkEnableRequestModel {
    id?: number;
    isEnabled?: boolean;

    constructor(data?: IUpdateCryptoNetworkEnableRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdateCryptoNetworkEnableRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCryptoNetworkEnableRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpdateCryptoNetworkEnableRequestModel {
    id?: number;
    isEnabled?: boolean;
}

export class UpdateCryptoTokenEnableResponseModel implements IUpdateCryptoTokenEnableResponseModel {

    constructor(data?: IUpdateCryptoTokenEnableResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateCryptoTokenEnableResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCryptoTokenEnableResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateCryptoTokenEnableResponseModel {
}

export class UpdateCryptoTokenEnableRequestModel implements IUpdateCryptoTokenEnableRequestModel {
    id?: number;
    isEnabled?: boolean;

    constructor(data?: IUpdateCryptoTokenEnableRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdateCryptoTokenEnableRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCryptoTokenEnableRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpdateCryptoTokenEnableRequestModel {
    id?: number;
    isEnabled?: boolean;
}

export class CreateCryptoQuoteResponseModel implements ICreateCryptoQuoteResponseModel {
    data?: AppTransactionDto | undefined;

    constructor(data?: ICreateCryptoQuoteResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AppTransactionDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateCryptoQuoteResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCryptoQuoteResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateCryptoQuoteResponseModel {
    data?: AppTransactionDto | undefined;
}

export class CreateCryptoQuoteRequestModel implements ICreateCryptoQuoteRequestModel {
    sessionId?: string | undefined;
    amountIn?: number;
    amountOut?: number;
    avgPrice?: number;
    address?: string | undefined;
    userAddress?: string | undefined;
    isBuy?: boolean;
    phoneNumber?: string | undefined;
    totalLocal?: string | undefined;
    totalUsd?: string | undefined;
    currency?: string | undefined;

    constructor(data?: ICreateCryptoQuoteRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.amountIn = _data["amountIn"];
            this.amountOut = _data["amountOut"];
            this.avgPrice = _data["avgPrice"];
            this.address = _data["address"];
            this.userAddress = _data["userAddress"];
            this.isBuy = _data["isBuy"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalLocal = _data["totalLocal"];
            this.totalUsd = _data["totalUsd"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): CreateCryptoQuoteRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCryptoQuoteRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["amountIn"] = this.amountIn;
        data["amountOut"] = this.amountOut;
        data["avgPrice"] = this.avgPrice;
        data["address"] = this.address;
        data["userAddress"] = this.userAddress;
        data["isBuy"] = this.isBuy;
        data["phoneNumber"] = this.phoneNumber;
        data["totalLocal"] = this.totalLocal;
        data["totalUsd"] = this.totalUsd;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ICreateCryptoQuoteRequestModel {
    sessionId?: string | undefined;
    amountIn?: number;
    amountOut?: number;
    avgPrice?: number;
    address?: string | undefined;
    userAddress?: string | undefined;
    isBuy?: boolean;
    phoneNumber?: string | undefined;
    totalLocal?: string | undefined;
    totalUsd?: string | undefined;
    currency?: string | undefined;
}

export class VerifyCryptoAddressResponseModel implements IVerifyCryptoAddressResponseModel {
    data?: boolean;

    constructor(data?: IVerifyCryptoAddressResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): VerifyCryptoAddressResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyCryptoAddressResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface IVerifyCryptoAddressResponseModel {
    data?: boolean;
}

export class VerifyCryptoAddressRequestModel implements IVerifyCryptoAddressRequestModel {
    address?: string | undefined;
    chain?: string | undefined;

    constructor(data?: IVerifyCryptoAddressRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.chain = _data["chain"];
        }
    }

    static fromJS(data: any): VerifyCryptoAddressRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyCryptoAddressRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["chain"] = this.chain;
        return data;
    }
}

export interface IVerifyCryptoAddressRequestModel {
    address?: string | undefined;
    chain?: string | undefined;
}

export class RedeemCryptoQuoteResponseModel implements IRedeemCryptoQuoteResponseModel {

    constructor(data?: IRedeemCryptoQuoteResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RedeemCryptoQuoteResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RedeemCryptoQuoteResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRedeemCryptoQuoteResponseModel {
}

export class GetCryptoQuoteByIdResponseModel implements IGetCryptoQuoteByIdResponseModel {
    data?: CryptoTransactionDetailDto | undefined;

    constructor(data?: IGetCryptoQuoteByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CryptoTransactionDetailDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCryptoQuoteByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCryptoQuoteByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCryptoQuoteByIdResponseModel {
    data?: CryptoTransactionDetailDto | undefined;
}

export class GetCurrencyAcceptorConfigsResponseModel implements IGetCurrencyAcceptorConfigsResponseModel {
    data?: CurrencyAcceptorConfigDto[] | undefined;

    constructor(data?: IGetCurrencyAcceptorConfigsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CurrencyAcceptorConfigDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCurrencyAcceptorConfigsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrencyAcceptorConfigsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCurrencyAcceptorConfigsResponseModel {
    data?: CurrencyAcceptorConfigDto[] | undefined;
}

export class CurrencyAcceptorConfigDto implements ICurrencyAcceptorConfigDto {
    noteType?: number;
    isEnabled?: boolean;
    denomination?: number;
    currency?: string | undefined;
    label?: string | undefined;

    constructor(data?: ICurrencyAcceptorConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteType = _data["noteType"];
            this.isEnabled = _data["isEnabled"];
            this.denomination = _data["denomination"];
            this.currency = _data["currency"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): CurrencyAcceptorConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyAcceptorConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteType"] = this.noteType;
        data["isEnabled"] = this.isEnabled;
        data["denomination"] = this.denomination;
        data["currency"] = this.currency;
        data["label"] = this.label;
        return data;
    }
}

export interface ICurrencyAcceptorConfigDto {
    noteType?: number;
    isEnabled?: boolean;
    denomination?: number;
    currency?: string | undefined;
    label?: string | undefined;
}

export class UpdateCurrencyAcceptorConfigResponseModel implements IUpdateCurrencyAcceptorConfigResponseModel {

    constructor(data?: IUpdateCurrencyAcceptorConfigResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateCurrencyAcceptorConfigResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCurrencyAcceptorConfigResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateCurrencyAcceptorConfigResponseModel {
}

export class UpdateCurrencyAcceptorConfigRequestModel implements IUpdateCurrencyAcceptorConfigRequestModel {
    atmId?: string | undefined;
    type?: CurrencyNoteType;
    isEnabled?: boolean;

    constructor(data?: IUpdateCurrencyAcceptorConfigRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atmId = _data["atmId"];
            this.type = _data["type"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdateCurrencyAcceptorConfigRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCurrencyAcceptorConfigRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmId"] = this.atmId;
        data["type"] = this.type;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpdateCurrencyAcceptorConfigRequestModel {
    atmId?: string | undefined;
    type?: CurrencyNoteType;
    isEnabled?: boolean;
}

export enum CurrencyNoteType {
    Currency500 = 0,
    Currency1000 = 1,
    Currency2000 = 2,
    Currency5000 = 3,
    Currency10000 = 4,
    Ghs10 = 5,
    Ghs20 = 6,
    Ghs50 = 7,
    Ghs100 = 8,
}

export class GetDashboardKpiResponseModel implements IGetDashboardKpiResponseModel {
    totalWithdraw?: number;
    totalErrors?: number;
    totalDeposit?: number;
    totalTickets?: number;
    dailyDeposits?: DateCountModel[] | undefined;
    dailyWithdraws?: DateCountModel[] | undefined;

    constructor(data?: IGetDashboardKpiResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalWithdraw = _data["totalWithdraw"];
            this.totalErrors = _data["totalErrors"];
            this.totalDeposit = _data["totalDeposit"];
            this.totalTickets = _data["totalTickets"];
            if (Array.isArray(_data["dailyDeposits"])) {
                this.dailyDeposits = [] as any;
                for (let item of _data["dailyDeposits"])
                    this.dailyDeposits!.push(DateCountModel.fromJS(item));
            }
            if (Array.isArray(_data["dailyWithdraws"])) {
                this.dailyWithdraws = [] as any;
                for (let item of _data["dailyWithdraws"])
                    this.dailyWithdraws!.push(DateCountModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDashboardKpiResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardKpiResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWithdraw"] = this.totalWithdraw;
        data["totalErrors"] = this.totalErrors;
        data["totalDeposit"] = this.totalDeposit;
        data["totalTickets"] = this.totalTickets;
        if (Array.isArray(this.dailyDeposits)) {
            data["dailyDeposits"] = [];
            for (let item of this.dailyDeposits)
                data["dailyDeposits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dailyWithdraws)) {
            data["dailyWithdraws"] = [];
            for (let item of this.dailyWithdraws)
                data["dailyWithdraws"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDashboardKpiResponseModel {
    totalWithdraw?: number;
    totalErrors?: number;
    totalDeposit?: number;
    totalTickets?: number;
    dailyDeposits?: DateCountModel[] | undefined;
    dailyWithdraws?: DateCountModel[] | undefined;
}

export class DateCountModel implements IDateCountModel {
    date?: string | undefined;
    count?: number;

    constructor(data?: IDateCountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): DateCountModel {
        data = typeof data === 'object' ? data : {};
        let result = new DateCountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["count"] = this.count;
        return data;
    }
}

export interface IDateCountModel {
    date?: string | undefined;
    count?: number;
}

export class GetDashboardPublicKpiResponseModel implements IGetDashboardPublicKpiResponseModel {
    totalWithdraw?: number;
    totalErrors?: number;
    totalDeposit?: number;
    totalTickets?: number;
    dailyDeposits?: DateCountModel[] | undefined;
    dailyWithdraws?: DateCountModel[] | undefined;

    constructor(data?: IGetDashboardPublicKpiResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalWithdraw = _data["totalWithdraw"];
            this.totalErrors = _data["totalErrors"];
            this.totalDeposit = _data["totalDeposit"];
            this.totalTickets = _data["totalTickets"];
            if (Array.isArray(_data["dailyDeposits"])) {
                this.dailyDeposits = [] as any;
                for (let item of _data["dailyDeposits"])
                    this.dailyDeposits!.push(DateCountModel.fromJS(item));
            }
            if (Array.isArray(_data["dailyWithdraws"])) {
                this.dailyWithdraws = [] as any;
                for (let item of _data["dailyWithdraws"])
                    this.dailyWithdraws!.push(DateCountModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDashboardPublicKpiResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardPublicKpiResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWithdraw"] = this.totalWithdraw;
        data["totalErrors"] = this.totalErrors;
        data["totalDeposit"] = this.totalDeposit;
        data["totalTickets"] = this.totalTickets;
        if (Array.isArray(this.dailyDeposits)) {
            data["dailyDeposits"] = [];
            for (let item of this.dailyDeposits)
                data["dailyDeposits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dailyWithdraws)) {
            data["dailyWithdraws"] = [];
            for (let item of this.dailyWithdraws)
                data["dailyWithdraws"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDashboardPublicKpiResponseModel {
    totalWithdraw?: number;
    totalErrors?: number;
    totalDeposit?: number;
    totalTickets?: number;
    dailyDeposits?: DateCountModel[] | undefined;
    dailyWithdraws?: DateCountModel[] | undefined;
}

export class GetDenominationRecordsByAtmResponseModel implements IGetDenominationRecordsByAtmResponseModel {
    data?: DenominationRecordDto[] | undefined;

    constructor(data?: IGetDenominationRecordsByAtmResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DenominationRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDenominationRecordsByAtmResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDenominationRecordsByAtmResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDenominationRecordsByAtmResponseModel {
    data?: DenominationRecordDto[] | undefined;
}

export class DenominationRecordDto implements IDenominationRecordDto {
    cassetteNo?: string | undefined;
    denomination?: number;
    count?: number;
    lowCount?: number;
    stopCount?: number;

    constructor(data?: IDenominationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cassetteNo = _data["cassetteNo"];
            this.denomination = _data["denomination"];
            this.count = _data["count"];
            this.lowCount = _data["lowCount"];
            this.stopCount = _data["stopCount"];
        }
    }

    static fromJS(data: any): DenominationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new DenominationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cassetteNo"] = this.cassetteNo;
        data["denomination"] = this.denomination;
        data["count"] = this.count;
        data["lowCount"] = this.lowCount;
        data["stopCount"] = this.stopCount;
        return data;
    }
}

export interface IDenominationRecordDto {
    cassetteNo?: string | undefined;
    denomination?: number;
    count?: number;
    lowCount?: number;
    stopCount?: number;
}

export class GetDenominationRecordChangesResponseModel implements IGetDenominationRecordChangesResponseModel {
    data?: DenominationRecordChangeDto[] | undefined;
    count?: number;

    constructor(data?: IGetDenominationRecordChangesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DenominationRecordChangeDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetDenominationRecordChangesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDenominationRecordChangesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetDenominationRecordChangesResponseModel {
    data?: DenominationRecordChangeDto[] | undefined;
    count?: number;
}

export class DenominationRecordChangeDto implements IDenominationRecordChangeDto {
    sessionId?: string | undefined;
    atmId?: string | undefined;
    atm?: string | undefined;
    cassetteNo?: string | undefined;
    denomination?: number;
    previousCount?: number;
    newCount?: number;
    createdById?: string | undefined;
    changeType?: number | undefined;
    changeTypeName?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: string;

    constructor(data?: IDenominationRecordChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.atmId = _data["atmId"];
            this.atm = _data["atm"];
            this.cassetteNo = _data["cassetteNo"];
            this.denomination = _data["denomination"];
            this.previousCount = _data["previousCount"];
            this.newCount = _data["newCount"];
            this.createdById = _data["createdById"];
            this.changeType = _data["changeType"];
            this.changeTypeName = _data["changeTypeName"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): DenominationRecordChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DenominationRecordChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["atmId"] = this.atmId;
        data["atm"] = this.atm;
        data["cassetteNo"] = this.cassetteNo;
        data["denomination"] = this.denomination;
        data["previousCount"] = this.previousCount;
        data["newCount"] = this.newCount;
        data["createdById"] = this.createdById;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IDenominationRecordChangeDto {
    sessionId?: string | undefined;
    atmId?: string | undefined;
    atm?: string | undefined;
    cassetteNo?: string | undefined;
    denomination?: number;
    previousCount?: number;
    newCount?: number;
    createdById?: string | undefined;
    changeType?: number | undefined;
    changeTypeName?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: string;
}

export class SaveDenominationRecordsResponseModel implements ISaveDenominationRecordsResponseModel {

    constructor(data?: ISaveDenominationRecordsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SaveDenominationRecordsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDenominationRecordsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISaveDenominationRecordsResponseModel {
}

export class SaveDenominationRecordsRequestModel implements ISaveDenominationRecordsRequestModel {
    id?: string | undefined;
    sessionId?: string | undefined;
    records?: DenominationRecordDto[] | undefined;

    constructor(data?: ISaveDenominationRecordsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sessionId = _data["sessionId"];
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(DenominationRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveDenominationRecordsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDenominationRecordsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sessionId"] = this.sessionId;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveDenominationRecordsRequestModel {
    id?: string | undefined;
    sessionId?: string | undefined;
    records?: DenominationRecordDto[] | undefined;
}

export class CreateAppSessionImageResponseModel implements ICreateAppSessionImageResponseModel {

    constructor(data?: ICreateAppSessionImageResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateAppSessionImageResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppSessionImageResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICreateAppSessionImageResponseModel {
}

export class CreateAppSessionImageRequestModel implements ICreateAppSessionImageRequestModel {
    sessionId?: string | undefined;
    image?: string | undefined;

    constructor(data?: ICreateAppSessionImageRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): CreateAppSessionImageRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppSessionImageRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["image"] = this.image;
        return data;
    }
}

export interface ICreateAppSessionImageRequestModel {
    sessionId?: string | undefined;
    image?: string | undefined;
}

export class GetAppSessionImagesResponseModel implements IGetAppSessionImagesResponseModel {
    data?: AppSessionImageDto[] | undefined;
    count?: number;

    constructor(data?: IGetAppSessionImagesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AppSessionImageDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAppSessionImagesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppSessionImagesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetAppSessionImagesResponseModel {
    data?: AppSessionImageDto[] | undefined;
    count?: number;
}

export class AppSessionImageDto implements IAppSessionImageDto {
    image?: string | undefined;
    atm?: string | undefined;
    atmId?: string | undefined;
    sessionId?: string | undefined;
    createdDate?: string;

    constructor(data?: IAppSessionImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.atm = _data["atm"];
            this.atmId = _data["atmId"];
            this.sessionId = _data["sessionId"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): AppSessionImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSessionImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["atm"] = this.atm;
        data["atmId"] = this.atmId;
        data["sessionId"] = this.sessionId;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IAppSessionImageDto {
    image?: string | undefined;
    atm?: string | undefined;
    atmId?: string | undefined;
    sessionId?: string | undefined;
    createdDate?: string;
}

export class GetInvestorsResponseModel implements IGetInvestorsResponseModel {
    data?: InvestorDto[] | undefined;
    count?: number;

    constructor(data?: IGetInvestorsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InvestorDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetInvestorsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestorsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetInvestorsResponseModel {
    data?: InvestorDto[] | undefined;
    count?: number;
}

export class InvestorDto implements IInvestorDto {
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;

    constructor(data?: IInvestorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.imageUrl = _data["imageUrl"];
            this.isEnabled = _data["isEnabled"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): InvestorDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["imageUrl"] = this.imageUrl;
        data["isEnabled"] = this.isEnabled;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IInvestorDto {
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;
}

export class GetInvestorByIdResponseModel implements IGetInvestorByIdResponseModel {
    data?: InvestorDto | undefined;
    availableBalance?: number;
    balances?: CurrencyBalance[] | undefined;
    atms?: InvestorAtmDto[] | undefined;

    constructor(data?: IGetInvestorByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? InvestorDto.fromJS(_data["data"]) : undefined as any;
            this.availableBalance = _data["availableBalance"];
            if (Array.isArray(_data["balances"])) {
                this.balances = [] as any;
                for (let item of _data["balances"])
                    this.balances!.push(CurrencyBalance.fromJS(item));
            }
            if (Array.isArray(_data["atms"])) {
                this.atms = [] as any;
                for (let item of _data["atms"])
                    this.atms!.push(InvestorAtmDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInvestorByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestorByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["availableBalance"] = this.availableBalance;
        if (Array.isArray(this.balances)) {
            data["balances"] = [];
            for (let item of this.balances)
                data["balances"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.atms)) {
            data["atms"] = [];
            for (let item of this.atms)
                data["atms"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetInvestorByIdResponseModel {
    data?: InvestorDto | undefined;
    availableBalance?: number;
    balances?: CurrencyBalance[] | undefined;
    atms?: InvestorAtmDto[] | undefined;
}

export class CurrencyBalance implements ICurrencyBalance {
    payerId?: string | undefined;
    payerName?: string | undefined;
    currency?: string | undefined;
    totalEarned?: number;
    pendingEarnings?: number;
    totalWithdrawn?: number;
    totalPending?: number;
    availableBalance?: number;

    constructor(data?: ICurrencyBalance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payerId = _data["payerId"];
            this.payerName = _data["payerName"];
            this.currency = _data["currency"];
            this.totalEarned = _data["totalEarned"];
            this.pendingEarnings = _data["pendingEarnings"];
            this.totalWithdrawn = _data["totalWithdrawn"];
            this.totalPending = _data["totalPending"];
            this.availableBalance = _data["availableBalance"];
        }
    }

    static fromJS(data: any): CurrencyBalance {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyBalance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerId"] = this.payerId;
        data["payerName"] = this.payerName;
        data["currency"] = this.currency;
        data["totalEarned"] = this.totalEarned;
        data["pendingEarnings"] = this.pendingEarnings;
        data["totalWithdrawn"] = this.totalWithdrawn;
        data["totalPending"] = this.totalPending;
        data["availableBalance"] = this.availableBalance;
        return data;
    }
}

export interface ICurrencyBalance {
    payerId?: string | undefined;
    payerName?: string | undefined;
    currency?: string | undefined;
    totalEarned?: number;
    pendingEarnings?: number;
    totalWithdrawn?: number;
    totalPending?: number;
    availableBalance?: number;
}

export class InvestorAtmDto implements IInvestorAtmDto {
    atmId?: string | undefined;
    investorId?: string | undefined;
    atmName?: string | undefined;
    sharePct?: number;
    isActive?: boolean;
    createdDate?: string;

    constructor(data?: IInvestorAtmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atmId = _data["atmId"];
            this.investorId = _data["investorId"];
            this.atmName = _data["atmName"];
            this.sharePct = _data["sharePct"];
            this.isActive = _data["isActive"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): InvestorAtmDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorAtmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmId"] = this.atmId;
        data["investorId"] = this.investorId;
        data["atmName"] = this.atmName;
        data["sharePct"] = this.sharePct;
        data["isActive"] = this.isActive;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IInvestorAtmDto {
    atmId?: string | undefined;
    investorId?: string | undefined;
    atmName?: string | undefined;
    sharePct?: number;
    isActive?: boolean;
    createdDate?: string;
}

export class CreateInvestorResponseModel implements ICreateInvestorResponseModel {
    data?: InvestorDto | undefined;

    constructor(data?: ICreateInvestorResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? InvestorDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateInvestorResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvestorResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateInvestorResponseModel {
    data?: InvestorDto | undefined;
}

export class CreateInvestorRequestModel implements ICreateInvestorRequestModel {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: ICreateInvestorRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): CreateInvestorRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvestorRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface ICreateInvestorRequestModel {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
}

export class UpdateInvestorResponseModel implements IUpdateInvestorResponseModel {
    data?: InvestorDto | undefined;

    constructor(data?: IUpdateInvestorResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? InvestorDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateInvestorResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvestorResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateInvestorResponseModel {
    data?: InvestorDto | undefined;
}

export class UpdateInvestorRequestModel implements IUpdateInvestorRequestModel {
    id?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IUpdateInvestorRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdateInvestorRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvestorRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpdateInvestorRequestModel {
    id?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isEnabled?: boolean;
}

export class GetInvestorAtmsResponseModel implements IGetInvestorAtmsResponseModel {
    data?: InvestorAtmDto[] | undefined;

    constructor(data?: IGetInvestorAtmsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InvestorAtmDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInvestorAtmsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestorAtmsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetInvestorAtmsResponseModel {
    data?: InvestorAtmDto[] | undefined;
}

export class AssignInvestorToAtmResponseModel implements IAssignInvestorToAtmResponseModel {

    constructor(data?: IAssignInvestorToAtmResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AssignInvestorToAtmResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignInvestorToAtmResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAssignInvestorToAtmResponseModel {
}

export class AssignInvestorToAtmRequestModel implements IAssignInvestorToAtmRequestModel {
    investorId?: string | undefined;
    atmId?: string | undefined;

    constructor(data?: IAssignInvestorToAtmRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorId = _data["investorId"];
            this.atmId = _data["atmId"];
        }
    }

    static fromJS(data: any): AssignInvestorToAtmRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignInvestorToAtmRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorId"] = this.investorId;
        data["atmId"] = this.atmId;
        return data;
    }
}

export interface IAssignInvestorToAtmRequestModel {
    investorId?: string | undefined;
    atmId?: string | undefined;
}

export class RemoveInvestorFromAtmResponseModel implements IRemoveInvestorFromAtmResponseModel {

    constructor(data?: IRemoveInvestorFromAtmResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RemoveInvestorFromAtmResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveInvestorFromAtmResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRemoveInvestorFromAtmResponseModel {
}

export class GetInvestorDashboardResponseModel implements IGetInvestorDashboardResponseModel {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    balances?: CurrencyBalance[] | undefined;
    assignedAtms?: InvestorAtmDto[] | undefined;

    constructor(data?: IGetInvestorDashboardResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.imageUrl = _data["imageUrl"];
            if (Array.isArray(_data["balances"])) {
                this.balances = [] as any;
                for (let item of _data["balances"])
                    this.balances!.push(CurrencyBalance.fromJS(item));
            }
            if (Array.isArray(_data["assignedAtms"])) {
                this.assignedAtms = [] as any;
                for (let item of _data["assignedAtms"])
                    this.assignedAtms!.push(InvestorAtmDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInvestorDashboardResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestorDashboardResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["imageUrl"] = this.imageUrl;
        if (Array.isArray(this.balances)) {
            data["balances"] = [];
            for (let item of this.balances)
                data["balances"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignedAtms)) {
            data["assignedAtms"] = [];
            for (let item of this.assignedAtms)
                data["assignedAtms"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetInvestorDashboardResponseModel {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    balances?: CurrencyBalance[] | undefined;
    assignedAtms?: InvestorAtmDto[] | undefined;
}

export class GetInvestorTransactionsResponseModel implements IGetInvestorTransactionsResponseModel {
    data?: PartnerTransactionDto[] | undefined;
    count?: number;

    constructor(data?: IGetInvestorTransactionsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PartnerTransactionDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetInvestorTransactionsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestorTransactionsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetInvestorTransactionsResponseModel {
    data?: PartnerTransactionDto[] | undefined;
    count?: number;
}

export class PartnerTransactionDto implements IPartnerTransactionDto {
    id?: number;
    appTransactionId?: number;
    atmId?: string | undefined;
    atmName?: string | undefined;
    operatorType?: number;
    network?: string | undefined;
    bankName?: string | undefined;
    operatorName?: string | undefined;
    status?: number;
    txnType?: number;
    txnAmount?: number;
    grossAmount?: number;
    amount?: number;
    currency?: string | undefined;
    createdDate?: string;

    constructor(data?: IPartnerTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appTransactionId = _data["appTransactionId"];
            this.atmId = _data["atmId"];
            this.atmName = _data["atmName"];
            this.operatorType = _data["operatorType"];
            this.network = _data["network"];
            this.bankName = _data["bankName"];
            this.operatorName = _data["operatorName"];
            this.status = _data["status"];
            this.txnType = _data["txnType"];
            this.txnAmount = _data["txnAmount"];
            this.grossAmount = _data["grossAmount"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): PartnerTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appTransactionId"] = this.appTransactionId;
        data["atmId"] = this.atmId;
        data["atmName"] = this.atmName;
        data["operatorType"] = this.operatorType;
        data["network"] = this.network;
        data["bankName"] = this.bankName;
        data["operatorName"] = this.operatorName;
        data["status"] = this.status;
        data["txnType"] = this.txnType;
        data["txnAmount"] = this.txnAmount;
        data["grossAmount"] = this.grossAmount;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IPartnerTransactionDto {
    id?: number;
    appTransactionId?: number;
    atmId?: string | undefined;
    atmName?: string | undefined;
    operatorType?: number;
    network?: string | undefined;
    bankName?: string | undefined;
    operatorName?: string | undefined;
    status?: number;
    txnType?: number;
    txnAmount?: number;
    grossAmount?: number;
    amount?: number;
    currency?: string | undefined;
    createdDate?: string;
}

export class GetMyInvestorAtmsResponseModel implements IGetMyInvestorAtmsResponseModel {
    data?: InvestorAtmDto[] | undefined;

    constructor(data?: IGetMyInvestorAtmsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InvestorAtmDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyInvestorAtmsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyInvestorAtmsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMyInvestorAtmsResponseModel {
    data?: InvestorAtmDto[] | undefined;
}

export class UpdateInvestorProfileResponseModel implements IUpdateInvestorProfileResponseModel {
    data?: InvestorDto | undefined;

    constructor(data?: IUpdateInvestorProfileResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? InvestorDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateInvestorProfileResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvestorProfileResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateInvestorProfileResponseModel {
    data?: InvestorDto | undefined;
}

export class UpdateInvestorProfileRequestModel implements IUpdateInvestorProfileRequestModel {
    fullName?: string | undefined;
    imageUrl?: string | undefined;

    constructor(data?: IUpdateInvestorProfileRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): UpdateInvestorProfileRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvestorProfileRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IUpdateInvestorProfileRequestModel {
    fullName?: string | undefined;
    imageUrl?: string | undefined;
}

export class CreateWithdrawalResponseModel implements ICreateWithdrawalResponseModel {
    id?: number;

    constructor(data?: ICreateWithdrawalResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateWithdrawalResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWithdrawalResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateWithdrawalResponseModel {
    id?: number;
}

export class CreateWithdrawalRequestModel implements ICreateWithdrawalRequestModel {
    amount?: number;
    currency?: string | undefined;
    paymentDestination?: string | undefined;
    note?: string | undefined;
    payerId?: string | undefined;
    requestedById?: string | undefined;

    constructor(data?: ICreateWithdrawalRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.paymentDestination = _data["paymentDestination"];
            this.note = _data["note"];
            this.payerId = _data["payerId"];
            this.requestedById = _data["requestedById"];
        }
    }

    static fromJS(data: any): CreateWithdrawalRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWithdrawalRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["paymentDestination"] = this.paymentDestination;
        data["note"] = this.note;
        data["payerId"] = this.payerId;
        data["requestedById"] = this.requestedById;
        return data;
    }
}

export interface ICreateWithdrawalRequestModel {
    amount?: number;
    currency?: string | undefined;
    paymentDestination?: string | undefined;
    note?: string | undefined;
    payerId?: string | undefined;
    requestedById?: string | undefined;
}

export class CancelWithdrawalResponseModel implements ICancelWithdrawalResponseModel {

    constructor(data?: ICancelWithdrawalResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CancelWithdrawalResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CancelWithdrawalResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICancelWithdrawalResponseModel {
}

export class GetWithdrawalRequestsResponseModel implements IGetWithdrawalRequestsResponseModel {
    data?: WithdrawalRequestDto[] | undefined;
    count?: number;

    constructor(data?: IGetWithdrawalRequestsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WithdrawalRequestDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetWithdrawalRequestsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetWithdrawalRequestsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetWithdrawalRequestsResponseModel {
    data?: WithdrawalRequestDto[] | undefined;
    count?: number;
}

export class WithdrawalRequestDto implements IWithdrawalRequestDto {
    id?: number;
    requestedById?: string | undefined;
    requesterName?: string | undefined;
    amount?: number;
    currency?: string | undefined;
    payerId?: string | undefined;
    payerName?: string | undefined;
    paymentDestination?: string | undefined;
    note?: string | undefined;
    status?: number;
    adminMessage?: string | undefined;
    proofImageUrl?: string | undefined;
    reviewedById?: string | undefined;
    reviewerName?: string | undefined;
    reviewedAt?: string | undefined;
    createdDate?: string;
    requesterAvailableBalance?: number;

    constructor(data?: IWithdrawalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestedById = _data["requestedById"];
            this.requesterName = _data["requesterName"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.payerId = _data["payerId"];
            this.payerName = _data["payerName"];
            this.paymentDestination = _data["paymentDestination"];
            this.note = _data["note"];
            this.status = _data["status"];
            this.adminMessage = _data["adminMessage"];
            this.proofImageUrl = _data["proofImageUrl"];
            this.reviewedById = _data["reviewedById"];
            this.reviewerName = _data["reviewerName"];
            this.reviewedAt = _data["reviewedAt"];
            this.createdDate = _data["createdDate"];
            this.requesterAvailableBalance = _data["requesterAvailableBalance"];
        }
    }

    static fromJS(data: any): WithdrawalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestedById"] = this.requestedById;
        data["requesterName"] = this.requesterName;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["payerId"] = this.payerId;
        data["payerName"] = this.payerName;
        data["paymentDestination"] = this.paymentDestination;
        data["note"] = this.note;
        data["status"] = this.status;
        data["adminMessage"] = this.adminMessage;
        data["proofImageUrl"] = this.proofImageUrl;
        data["reviewedById"] = this.reviewedById;
        data["reviewerName"] = this.reviewerName;
        data["reviewedAt"] = this.reviewedAt;
        data["createdDate"] = this.createdDate;
        data["requesterAvailableBalance"] = this.requesterAvailableBalance;
        return data;
    }
}

export interface IWithdrawalRequestDto {
    id?: number;
    requestedById?: string | undefined;
    requesterName?: string | undefined;
    amount?: number;
    currency?: string | undefined;
    payerId?: string | undefined;
    payerName?: string | undefined;
    paymentDestination?: string | undefined;
    note?: string | undefined;
    status?: number;
    adminMessage?: string | undefined;
    proofImageUrl?: string | undefined;
    reviewedById?: string | undefined;
    reviewerName?: string | undefined;
    reviewedAt?: string | undefined;
    createdDate?: string;
    requesterAvailableBalance?: number;
}

export class GetAtmInvestorsResponseModel implements IGetAtmInvestorsResponseModel {
    data?: AtmInvestorDto[] | undefined;

    constructor(data?: IGetAtmInvestorsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AtmInvestorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAtmInvestorsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmInvestorsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAtmInvestorsResponseModel {
    data?: AtmInvestorDto[] | undefined;
}

export class AtmInvestorDto implements IAtmInvestorDto {
    investorId?: string | undefined;
    atmId?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    isEnabled?: boolean;
    sharePct?: number;
    isActive?: boolean;
    createdDate?: string;

    constructor(data?: IAtmInvestorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorId = _data["investorId"];
            this.atmId = _data["atmId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.imageUrl = _data["imageUrl"];
            this.isEnabled = _data["isEnabled"];
            this.sharePct = _data["sharePct"];
            this.isActive = _data["isActive"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): AtmInvestorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AtmInvestorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorId"] = this.investorId;
        data["atmId"] = this.atmId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["imageUrl"] = this.imageUrl;
        data["isEnabled"] = this.isEnabled;
        data["sharePct"] = this.sharePct;
        data["isActive"] = this.isActive;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IAtmInvestorDto {
    investorId?: string | undefined;
    atmId?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    isEnabled?: boolean;
    sharePct?: number;
    isActive?: boolean;
    createdDate?: string;
}

export class GetIpWhitelistResponseModel implements IGetIpWhitelistResponseModel {
    enabled?: boolean;
    currentIp?: string | undefined;
    data?: IpWhitelistEntryDto[] | undefined;

    constructor(data?: IGetIpWhitelistResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.currentIp = _data["currentIp"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IpWhitelistEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIpWhitelistResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetIpWhitelistResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["currentIp"] = this.currentIp;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetIpWhitelistResponseModel {
    enabled?: boolean;
    currentIp?: string | undefined;
    data?: IpWhitelistEntryDto[] | undefined;
}

export class IpWhitelistEntryDto implements IIpWhitelistEntryDto {
    id?: number;
    ipAddress?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;

    constructor(data?: IIpWhitelistEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ipAddress = _data["ipAddress"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): IpWhitelistEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new IpWhitelistEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ipAddress"] = this.ipAddress;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IIpWhitelistEntryDto {
    id?: number;
    ipAddress?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;
}

export class IpWhitelistEntryResponseModel implements IIpWhitelistEntryResponseModel {
    data?: IpWhitelistEntryDto | undefined;

    constructor(data?: IIpWhitelistEntryResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? IpWhitelistEntryDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): IpWhitelistEntryResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new IpWhitelistEntryResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IIpWhitelistEntryResponseModel {
    data?: IpWhitelistEntryDto | undefined;
}

export class CreateIpWhitelistEntryRequestModel implements ICreateIpWhitelistEntryRequestModel {
    ipAddress?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICreateIpWhitelistEntryRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ipAddress = _data["ipAddress"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateIpWhitelistEntryRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIpWhitelistEntryRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ipAddress"] = this.ipAddress;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateIpWhitelistEntryRequestModel {
    ipAddress?: string | undefined;
    description?: string | undefined;
}

export class UpdateIpWhitelistSettingsRequestModel implements IUpdateIpWhitelistSettingsRequestModel {
    enabled?: boolean;

    constructor(data?: IUpdateIpWhitelistSettingsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): UpdateIpWhitelistSettingsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIpWhitelistSettingsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IUpdateIpWhitelistSettingsRequestModel {
    enabled?: boolean;
}

export class UpdateIpWhitelistEntryRequestModel implements IUpdateIpWhitelistEntryRequestModel {
    ipAddress?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IUpdateIpWhitelistEntryRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ipAddress = _data["ipAddress"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdateIpWhitelistEntryRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIpWhitelistEntryRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ipAddress"] = this.ipAddress;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpdateIpWhitelistEntryRequestModel {
    ipAddress?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean;
}

export class DeleteIpWhitelistEntryResponseModel implements IDeleteIpWhitelistEntryResponseModel {

    constructor(data?: IDeleteIpWhitelistEntryResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteIpWhitelistEntryResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteIpWhitelistEntryResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteIpWhitelistEntryResponseModel {
}

export class CreateAppSessionKycResponseModel implements ICreateAppSessionKycResponseModel {

    constructor(data?: ICreateAppSessionKycResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateAppSessionKycResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppSessionKycResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICreateAppSessionKycResponseModel {
}

export class CreateAppSessionKycRequestModel implements ICreateAppSessionKycRequestModel {
    sessionId?: string | undefined;
    documentType?: string | undefined;
    surname?: string | undefined;
    givenName?: string | undefined;
    sex?: string | undefined;
    nationality?: string | undefined;
    birthDate?: string | undefined;
    documentNo?: string | undefined;
    issuePlace?: string | undefined;
    issueDate?: string | undefined;
    expiryDate?: string | undefined;

    constructor(data?: ICreateAppSessionKycRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.documentType = _data["documentType"];
            this.surname = _data["surname"];
            this.givenName = _data["givenName"];
            this.sex = _data["sex"];
            this.nationality = _data["nationality"];
            this.birthDate = _data["birthDate"];
            this.documentNo = _data["documentNo"];
            this.issuePlace = _data["issuePlace"];
            this.issueDate = _data["issueDate"];
            this.expiryDate = _data["expiryDate"];
        }
    }

    static fromJS(data: any): CreateAppSessionKycRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppSessionKycRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["documentType"] = this.documentType;
        data["surname"] = this.surname;
        data["givenName"] = this.givenName;
        data["sex"] = this.sex;
        data["nationality"] = this.nationality;
        data["birthDate"] = this.birthDate;
        data["documentNo"] = this.documentNo;
        data["issuePlace"] = this.issuePlace;
        data["issueDate"] = this.issueDate;
        data["expiryDate"] = this.expiryDate;
        return data;
    }
}

export interface ICreateAppSessionKycRequestModel {
    sessionId?: string | undefined;
    documentType?: string | undefined;
    surname?: string | undefined;
    givenName?: string | undefined;
    sex?: string | undefined;
    nationality?: string | undefined;
    birthDate?: string | undefined;
    documentNo?: string | undefined;
    issuePlace?: string | undefined;
    issueDate?: string | undefined;
    expiryDate?: string | undefined;
}

export class GetAppSessionKycsResponseModel implements IGetAppSessionKycsResponseModel {
    data?: AppSessionKycDto[] | undefined;
    count?: number;

    constructor(data?: IGetAppSessionKycsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AppSessionKycDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAppSessionKycsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppSessionKycsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetAppSessionKycsResponseModel {
    data?: AppSessionKycDto[] | undefined;
    count?: number;
}

export class AppSessionKycDto implements IAppSessionKycDto {
    atmId?: string | undefined;
    atm?: string | undefined;
    sessionId?: string | undefined;
    documentType?: string | undefined;
    surname?: string | undefined;
    givenName?: string | undefined;
    sex?: string | undefined;
    nationality?: string | undefined;
    birthDate?: string | undefined;
    documentNo?: string | undefined;
    issuePlace?: string | undefined;
    issueDate?: string | undefined;
    expiryDate?: string | undefined;
    createdDate?: string;

    constructor(data?: IAppSessionKycDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atmId = _data["atmId"];
            this.atm = _data["atm"];
            this.sessionId = _data["sessionId"];
            this.documentType = _data["documentType"];
            this.surname = _data["surname"];
            this.givenName = _data["givenName"];
            this.sex = _data["sex"];
            this.nationality = _data["nationality"];
            this.birthDate = _data["birthDate"];
            this.documentNo = _data["documentNo"];
            this.issuePlace = _data["issuePlace"];
            this.issueDate = _data["issueDate"];
            this.expiryDate = _data["expiryDate"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): AppSessionKycDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSessionKycDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmId"] = this.atmId;
        data["atm"] = this.atm;
        data["sessionId"] = this.sessionId;
        data["documentType"] = this.documentType;
        data["surname"] = this.surname;
        data["givenName"] = this.givenName;
        data["sex"] = this.sex;
        data["nationality"] = this.nationality;
        data["birthDate"] = this.birthDate;
        data["documentNo"] = this.documentNo;
        data["issuePlace"] = this.issuePlace;
        data["issueDate"] = this.issueDate;
        data["expiryDate"] = this.expiryDate;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IAppSessionKycDto {
    atmId?: string | undefined;
    atm?: string | undefined;
    sessionId?: string | undefined;
    documentType?: string | undefined;
    surname?: string | undefined;
    givenName?: string | undefined;
    sex?: string | undefined;
    nationality?: string | undefined;
    birthDate?: string | undefined;
    documentNo?: string | undefined;
    issuePlace?: string | undefined;
    issueDate?: string | undefined;
    expiryDate?: string | undefined;
    createdDate?: string;
}

export class M2ULoginResponseModel implements IM2ULoginResponseModel {

    constructor(data?: IM2ULoginResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): M2ULoginResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new M2ULoginResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IM2ULoginResponseModel {
}

export class M2ULoginRequestModel implements IM2ULoginRequestModel {
    sessionId?: string | undefined;

    constructor(data?: IM2ULoginRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): M2ULoginRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new M2ULoginRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IM2ULoginRequestModel {
    sessionId?: string | undefined;
}

export class GetM2UTellerDataResponseModel implements IGetM2UTellerDataResponseModel {
    pid?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    cpid?: string | undefined;
    cashPointName?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    userLocked?: string | undefined;
    wallets?: M2UWalletDto[] | undefined;
    permissions?: M2UPermissionsDto | undefined;

    constructor(data?: IGetM2UTellerDataResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pid = _data["pid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.cpid = _data["cpid"];
            this.cashPointName = _data["cashPointName"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.userLocked = _data["userLocked"];
            if (Array.isArray(_data["wallets"])) {
                this.wallets = [] as any;
                for (let item of _data["wallets"])
                    this.wallets!.push(M2UWalletDto.fromJS(item));
            }
            this.permissions = _data["permissions"] ? M2UPermissionsDto.fromJS(_data["permissions"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetM2UTellerDataResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetM2UTellerDataResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pid"] = this.pid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["cpid"] = this.cpid;
        data["cashPointName"] = this.cashPointName;
        data["city"] = this.city;
        data["country"] = this.country;
        data["userLocked"] = this.userLocked;
        if (Array.isArray(this.wallets)) {
            data["wallets"] = [];
            for (let item of this.wallets)
                data["wallets"].push(item ? item.toJSON() : undefined as any);
        }
        data["permissions"] = this.permissions ? this.permissions.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetM2UTellerDataResponseModel {
    pid?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    cpid?: string | undefined;
    cashPointName?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    userLocked?: string | undefined;
    wallets?: M2UWalletDto[] | undefined;
    permissions?: M2UPermissionsDto | undefined;
}

export class M2UWalletDto implements IM2UWalletDto {
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    balance?: string | undefined;
    currencyCode?: string | undefined;
    debt?: string | undefined;
    walletQRCode?: string | undefined;

    constructor(data?: IM2UWalletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.balance = _data["balance"];
            this.currencyCode = _data["currencyCode"];
            this.debt = _data["debt"];
            this.walletQRCode = _data["walletQRCode"];
        }
    }

    static fromJS(data: any): M2UWalletDto {
        data = typeof data === 'object' ? data : {};
        let result = new M2UWalletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["balance"] = this.balance;
        data["currencyCode"] = this.currencyCode;
        data["debt"] = this.debt;
        data["walletQRCode"] = this.walletQRCode;
        return data;
    }
}

export interface IM2UWalletDto {
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    balance?: string | undefined;
    currencyCode?: string | undefined;
    debt?: string | undefined;
    walletQRCode?: string | undefined;
}

export class M2UPermissionsDto implements IM2UPermissionsDto {
    allowWalletWithdrawal?: string | undefined;
    allowWalletDeposit?: string | undefined;
    allowCancelTrans?: string | undefined;
    allowModifyTrans?: string | undefined;
    allowBillPayment?: string | undefined;
    allowBankAccountCreation?: string | undefined;
    allowBankDeposit?: string | undefined;
    allowBankWithdrawal?: string | undefined;
    allowBankStatement?: string | undefined;
    allowViewAccountBalance?: string | undefined;

    constructor(data?: IM2UPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowWalletWithdrawal = _data["allowWalletWithdrawal"];
            this.allowWalletDeposit = _data["allowWalletDeposit"];
            this.allowCancelTrans = _data["allowCancelTrans"];
            this.allowModifyTrans = _data["allowModifyTrans"];
            this.allowBillPayment = _data["allowBillPayment"];
            this.allowBankAccountCreation = _data["allowBankAccountCreation"];
            this.allowBankDeposit = _data["allowBankDeposit"];
            this.allowBankWithdrawal = _data["allowBankWithdrawal"];
            this.allowBankStatement = _data["allowBankStatement"];
            this.allowViewAccountBalance = _data["allowViewAccountBalance"];
        }
    }

    static fromJS(data: any): M2UPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new M2UPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowWalletWithdrawal"] = this.allowWalletWithdrawal;
        data["allowWalletDeposit"] = this.allowWalletDeposit;
        data["allowCancelTrans"] = this.allowCancelTrans;
        data["allowModifyTrans"] = this.allowModifyTrans;
        data["allowBillPayment"] = this.allowBillPayment;
        data["allowBankAccountCreation"] = this.allowBankAccountCreation;
        data["allowBankDeposit"] = this.allowBankDeposit;
        data["allowBankWithdrawal"] = this.allowBankWithdrawal;
        data["allowBankStatement"] = this.allowBankStatement;
        data["allowViewAccountBalance"] = this.allowViewAccountBalance;
        return data;
    }
}

export interface IM2UPermissionsDto {
    allowWalletWithdrawal?: string | undefined;
    allowWalletDeposit?: string | undefined;
    allowCancelTrans?: string | undefined;
    allowModifyTrans?: string | undefined;
    allowBillPayment?: string | undefined;
    allowBankAccountCreation?: string | undefined;
    allowBankDeposit?: string | undefined;
    allowBankWithdrawal?: string | undefined;
    allowBankStatement?: string | undefined;
    allowViewAccountBalance?: string | undefined;
}

export class GetM2UTransferConfirmationResponseModel implements IGetM2UTransferConfirmationResponseModel {
    amount?: string | undefined;
    amountToBeReceived?: string | undefined;
    fees?: string | undefined;
    externalFees?: string | undefined;
    exchangeFees?: string | undefined;
    taxes?: string | undefined;
    totalAmount?: string | undefined;
    exchangeRate?: string | undefined;

    constructor(data?: IGetM2UTransferConfirmationResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.amountToBeReceived = _data["amountToBeReceived"];
            this.fees = _data["fees"];
            this.externalFees = _data["externalFees"];
            this.exchangeFees = _data["exchangeFees"];
            this.taxes = _data["taxes"];
            this.totalAmount = _data["totalAmount"];
            this.exchangeRate = _data["exchangeRate"];
        }
    }

    static fromJS(data: any): GetM2UTransferConfirmationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetM2UTransferConfirmationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["amountToBeReceived"] = this.amountToBeReceived;
        data["fees"] = this.fees;
        data["externalFees"] = this.externalFees;
        data["exchangeFees"] = this.exchangeFees;
        data["taxes"] = this.taxes;
        data["totalAmount"] = this.totalAmount;
        data["exchangeRate"] = this.exchangeRate;
        return data;
    }
}

export interface IGetM2UTransferConfirmationResponseModel {
    amount?: string | undefined;
    amountToBeReceived?: string | undefined;
    fees?: string | undefined;
    externalFees?: string | undefined;
    exchangeFees?: string | undefined;
    taxes?: string | undefined;
    totalAmount?: string | undefined;
    exchangeRate?: string | undefined;
}

export class M2UAddMoneyResponseModel implements IM2UAddMoneyResponseModel {
    amountToBeSent?: string | undefined;
    amount?: string | undefined;
    fees?: string | undefined;
    totalAmount?: string | undefined;
    exchangeRate?: string | undefined;
    walletBalance?: string | undefined;

    constructor(data?: IM2UAddMoneyResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountToBeSent = _data["amountToBeSent"];
            this.amount = _data["amount"];
            this.fees = _data["fees"];
            this.totalAmount = _data["totalAmount"];
            this.exchangeRate = _data["exchangeRate"];
            this.walletBalance = _data["walletBalance"];
        }
    }

    static fromJS(data: any): M2UAddMoneyResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new M2UAddMoneyResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountToBeSent"] = this.amountToBeSent;
        data["amount"] = this.amount;
        data["fees"] = this.fees;
        data["totalAmount"] = this.totalAmount;
        data["exchangeRate"] = this.exchangeRate;
        data["walletBalance"] = this.walletBalance;
        return data;
    }
}

export interface IM2UAddMoneyResponseModel {
    amountToBeSent?: string | undefined;
    amount?: string | undefined;
    fees?: string | undefined;
    totalAmount?: string | undefined;
    exchangeRate?: string | undefined;
    walletBalance?: string | undefined;
}

export class M2UAddMoneyRequestModel implements IM2UAddMoneyRequestModel {
    amount?: string | undefined;
    targetCurrency?: string | undefined;
    sourceWallet?: string | undefined;
    targetWallet?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    contactPID?: string | undefined;
    otp?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: IM2UAddMoneyRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.targetCurrency = _data["targetCurrency"];
            this.sourceWallet = _data["sourceWallet"];
            this.targetWallet = _data["targetWallet"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.contactPID = _data["contactPID"];
            this.otp = _data["otp"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): M2UAddMoneyRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new M2UAddMoneyRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["targetCurrency"] = this.targetCurrency;
        data["sourceWallet"] = this.sourceWallet;
        data["targetWallet"] = this.targetWallet;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["contactPID"] = this.contactPID;
        data["otp"] = this.otp;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IM2UAddMoneyRequestModel {
    amount?: string | undefined;
    targetCurrency?: string | undefined;
    sourceWallet?: string | undefined;
    targetWallet?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    contactPID?: string | undefined;
    otp?: string | undefined;
    sessionId?: string | undefined;
}

export class FindM2UCashUserResponseModel implements IFindM2UCashUserResponseModel {
    userFound?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;

    constructor(data?: IFindM2UCashUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userFound = _data["userFound"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any): FindM2UCashUserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FindM2UCashUserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userFound"] = this.userFound;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface IFindM2UCashUserResponseModel {
    userFound?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
}

export class LocateM2UUserResponseModel implements ILocateM2UUserResponseModel {
    pid?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    accountVerified?: string | undefined;
    mainPhone?: string | undefined;
    wallets?: M2UWalletDto[] | undefined;

    constructor(data?: ILocateM2UUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pid = _data["pid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.accountVerified = _data["accountVerified"];
            this.mainPhone = _data["mainPhone"];
            if (Array.isArray(_data["wallets"])) {
                this.wallets = [] as any;
                for (let item of _data["wallets"])
                    this.wallets!.push(M2UWalletDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocateM2UUserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocateM2UUserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pid"] = this.pid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["accountVerified"] = this.accountVerified;
        data["mainPhone"] = this.mainPhone;
        if (Array.isArray(this.wallets)) {
            data["wallets"] = [];
            for (let item of this.wallets)
                data["wallets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILocateM2UUserResponseModel {
    pid?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    accountVerified?: string | undefined;
    mainPhone?: string | undefined;
    wallets?: M2UWalletDto[] | undefined;
}

export class M2USendCashResponseModel implements IM2USendCashResponseModel {
    data?: AppTransactionDto | undefined;
    transferNumber?: string | undefined;
    securityCode?: string | undefined;
    voucherQRCode?: string | undefined;
    amountToBeSent?: string | undefined;
    amount?: string | undefined;
    fees?: string | undefined;
    totalAmount?: string | undefined;
    exchangeRate?: string | undefined;
    date?: string | undefined;
    walletBalance?: string | undefined;

    constructor(data?: IM2USendCashResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AppTransactionDto.fromJS(_data["data"]) : undefined as any;
            this.transferNumber = _data["transferNumber"];
            this.securityCode = _data["securityCode"];
            this.voucherQRCode = _data["voucherQRCode"];
            this.amountToBeSent = _data["amountToBeSent"];
            this.amount = _data["amount"];
            this.fees = _data["fees"];
            this.totalAmount = _data["totalAmount"];
            this.exchangeRate = _data["exchangeRate"];
            this.date = _data["date"];
            this.walletBalance = _data["walletBalance"];
        }
    }

    static fromJS(data: any): M2USendCashResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new M2USendCashResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["transferNumber"] = this.transferNumber;
        data["securityCode"] = this.securityCode;
        data["voucherQRCode"] = this.voucherQRCode;
        data["amountToBeSent"] = this.amountToBeSent;
        data["amount"] = this.amount;
        data["fees"] = this.fees;
        data["totalAmount"] = this.totalAmount;
        data["exchangeRate"] = this.exchangeRate;
        data["date"] = this.date;
        data["walletBalance"] = this.walletBalance;
        return data;
    }
}

export interface IM2USendCashResponseModel {
    data?: AppTransactionDto | undefined;
    transferNumber?: string | undefined;
    securityCode?: string | undefined;
    voucherQRCode?: string | undefined;
    amountToBeSent?: string | undefined;
    amount?: string | undefined;
    fees?: string | undefined;
    totalAmount?: string | undefined;
    exchangeRate?: string | undefined;
    date?: string | undefined;
    walletBalance?: string | undefined;
}

export class M2USendCashRequestModel implements IM2USendCashRequestModel {
    destCurrency?: string | undefined;
    destCountryCode?: string | undefined;
    targetPhoneNumber?: string | undefined;
    destFirstName?: string | undefined;
    destLastName?: string | undefined;
    amount?: string | undefined;
    sourceWallet?: string | undefined;
    senderFirstName?: string | undefined;
    senderLastName?: string | undefined;
    senderPhoneNumber?: string | undefined;
    otp?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: IM2USendCashRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destCurrency = _data["destCurrency"];
            this.destCountryCode = _data["destCountryCode"];
            this.targetPhoneNumber = _data["targetPhoneNumber"];
            this.destFirstName = _data["destFirstName"];
            this.destLastName = _data["destLastName"];
            this.amount = _data["amount"];
            this.sourceWallet = _data["sourceWallet"];
            this.senderFirstName = _data["senderFirstName"];
            this.senderLastName = _data["senderLastName"];
            this.senderPhoneNumber = _data["senderPhoneNumber"];
            this.otp = _data["otp"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): M2USendCashRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new M2USendCashRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destCurrency"] = this.destCurrency;
        data["destCountryCode"] = this.destCountryCode;
        data["targetPhoneNumber"] = this.targetPhoneNumber;
        data["destFirstName"] = this.destFirstName;
        data["destLastName"] = this.destLastName;
        data["amount"] = this.amount;
        data["sourceWallet"] = this.sourceWallet;
        data["senderFirstName"] = this.senderFirstName;
        data["senderLastName"] = this.senderLastName;
        data["senderPhoneNumber"] = this.senderPhoneNumber;
        data["otp"] = this.otp;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IM2USendCashRequestModel {
    destCurrency?: string | undefined;
    destCountryCode?: string | undefined;
    targetPhoneNumber?: string | undefined;
    destFirstName?: string | undefined;
    destLastName?: string | undefined;
    amount?: string | undefined;
    sourceWallet?: string | undefined;
    senderFirstName?: string | undefined;
    senderLastName?: string | undefined;
    senderPhoneNumber?: string | undefined;
    otp?: string | undefined;
    sessionId?: string | undefined;
}

export class GetM2UCashTransferStatusResponseModel implements IGetM2UCashTransferStatusResponseModel {
    returnCode?: string | undefined;
    description?: string | undefined;
    amount?: string | undefined;
    currency?: string | undefined;
    transferNumber?: string | undefined;
    displayTransferNumber?: string | undefined;
    securityCode?: string | undefined;
    voucherQRCode?: string | undefined;
    beneficiary?: M2UBeneficiaryDto | undefined;

    constructor(data?: IGetM2UCashTransferStatusResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnCode = _data["returnCode"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.transferNumber = _data["transferNumber"];
            this.displayTransferNumber = _data["displayTransferNumber"];
            this.securityCode = _data["securityCode"];
            this.voucherQRCode = _data["voucherQRCode"];
            this.beneficiary = _data["beneficiary"] ? M2UBeneficiaryDto.fromJS(_data["beneficiary"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetM2UCashTransferStatusResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetM2UCashTransferStatusResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnCode"] = this.returnCode;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["transferNumber"] = this.transferNumber;
        data["displayTransferNumber"] = this.displayTransferNumber;
        data["securityCode"] = this.securityCode;
        data["voucherQRCode"] = this.voucherQRCode;
        data["beneficiary"] = this.beneficiary ? this.beneficiary.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetM2UCashTransferStatusResponseModel {
    returnCode?: string | undefined;
    description?: string | undefined;
    amount?: string | undefined;
    currency?: string | undefined;
    transferNumber?: string | undefined;
    displayTransferNumber?: string | undefined;
    securityCode?: string | undefined;
    voucherQRCode?: string | undefined;
    beneficiary?: M2UBeneficiaryDto | undefined;
}

export class M2UBeneficiaryDto implements IM2UBeneficiaryDto {
    beneficiaryFound?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    amountToBeReceived?: string | undefined;
    currency?: string | undefined;

    constructor(data?: IM2UBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beneficiaryFound = _data["beneficiaryFound"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.amountToBeReceived = _data["amountToBeReceived"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): M2UBeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new M2UBeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beneficiaryFound"] = this.beneficiaryFound;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["amountToBeReceived"] = this.amountToBeReceived;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IM2UBeneficiaryDto {
    beneficiaryFound?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    amountToBeReceived?: string | undefined;
    currency?: string | undefined;
}

export class M2UPayCashResponseModel implements IM2UPayCashResponseModel {
    data?: AppTransactionDto | undefined;
    amountToBeReceived?: string | undefined;
    amount?: string | undefined;
    fees?: string | undefined;
    totalAmount?: string | undefined;
    exchangeRate?: string | undefined;

    constructor(data?: IM2UPayCashResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AppTransactionDto.fromJS(_data["data"]) : undefined as any;
            this.amountToBeReceived = _data["amountToBeReceived"];
            this.amount = _data["amount"];
            this.fees = _data["fees"];
            this.totalAmount = _data["totalAmount"];
            this.exchangeRate = _data["exchangeRate"];
        }
    }

    static fromJS(data: any): M2UPayCashResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new M2UPayCashResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["amountToBeReceived"] = this.amountToBeReceived;
        data["amount"] = this.amount;
        data["fees"] = this.fees;
        data["totalAmount"] = this.totalAmount;
        data["exchangeRate"] = this.exchangeRate;
        return data;
    }
}

export interface IM2UPayCashResponseModel {
    data?: AppTransactionDto | undefined;
    amountToBeReceived?: string | undefined;
    amount?: string | undefined;
    fees?: string | undefined;
    totalAmount?: string | undefined;
    exchangeRate?: string | undefined;
}

export class M2UPayCashRequestModel implements IM2UPayCashRequestModel {
    securityCode?: string | undefined;
    voucherNumber?: string | undefined;
    targetPhoneNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    walletNumber?: string | undefined;
    otp?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: IM2UPayCashRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityCode = _data["securityCode"];
            this.voucherNumber = _data["voucherNumber"];
            this.targetPhoneNumber = _data["targetPhoneNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.walletNumber = _data["walletNumber"];
            this.otp = _data["otp"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): M2UPayCashRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new M2UPayCashRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityCode"] = this.securityCode;
        data["voucherNumber"] = this.voucherNumber;
        data["targetPhoneNumber"] = this.targetPhoneNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["walletNumber"] = this.walletNumber;
        data["otp"] = this.otp;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IM2UPayCashRequestModel {
    securityCode?: string | undefined;
    voucherNumber?: string | undefined;
    targetPhoneNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    walletNumber?: string | undefined;
    otp?: string | undefined;
    sessionId?: string | undefined;
}

export class M2UCancelCashResponseModel implements IM2UCancelCashResponseModel {
    amountToBeReceived?: string | undefined;
    amount?: string | undefined;
    fees?: string | undefined;
    totalAmount?: string | undefined;

    constructor(data?: IM2UCancelCashResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountToBeReceived = _data["amountToBeReceived"];
            this.amount = _data["amount"];
            this.fees = _data["fees"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): M2UCancelCashResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new M2UCancelCashResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountToBeReceived"] = this.amountToBeReceived;
        data["amount"] = this.amount;
        data["fees"] = this.fees;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IM2UCancelCashResponseModel {
    amountToBeReceived?: string | undefined;
    amount?: string | undefined;
    fees?: string | undefined;
    totalAmount?: string | undefined;
}

export class M2UCancelCashRequestModel implements IM2UCancelCashRequestModel {
    securityCode?: string | undefined;
    voucherNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    senderPhoneNumber?: string | undefined;
    walletNumber?: string | undefined;
    otp?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: IM2UCancelCashRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityCode = _data["securityCode"];
            this.voucherNumber = _data["voucherNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.senderPhoneNumber = _data["senderPhoneNumber"];
            this.walletNumber = _data["walletNumber"];
            this.otp = _data["otp"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): M2UCancelCashRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new M2UCancelCashRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityCode"] = this.securityCode;
        data["voucherNumber"] = this.voucherNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["senderPhoneNumber"] = this.senderPhoneNumber;
        data["walletNumber"] = this.walletNumber;
        data["otp"] = this.otp;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IM2UCancelCashRequestModel {
    securityCode?: string | undefined;
    voucherNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    senderPhoneNumber?: string | undefined;
    walletNumber?: string | undefined;
    otp?: string | undefined;
    sessionId?: string | undefined;
}

export class M2UModifyCashResponseModel implements IM2UModifyCashResponseModel {
    cpid?: string | undefined;
    pid?: string | undefined;
    description?: string | undefined;

    constructor(data?: IM2UModifyCashResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cpid = _data["cpid"];
            this.pid = _data["pid"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): M2UModifyCashResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new M2UModifyCashResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpid"] = this.cpid;
        data["pid"] = this.pid;
        data["description"] = this.description;
        return data;
    }
}

export interface IM2UModifyCashResponseModel {
    cpid?: string | undefined;
    pid?: string | undefined;
    description?: string | undefined;
}

export class M2UModifyCashRequestModel implements IM2UModifyCashRequestModel {
    securityCode?: string | undefined;
    voucherNumber?: string | undefined;
    targetPhoneNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otp?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: IM2UModifyCashRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.securityCode = _data["securityCode"];
            this.voucherNumber = _data["voucherNumber"];
            this.targetPhoneNumber = _data["targetPhoneNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.otp = _data["otp"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): M2UModifyCashRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new M2UModifyCashRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityCode"] = this.securityCode;
        data["voucherNumber"] = this.voucherNumber;
        data["targetPhoneNumber"] = this.targetPhoneNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["otp"] = this.otp;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IM2UModifyCashRequestModel {
    securityCode?: string | undefined;
    voucherNumber?: string | undefined;
    targetPhoneNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otp?: string | undefined;
    sessionId?: string | undefined;
}

export class MojoPayInitPaymentResponseModel implements IMojoPayInitPaymentResponseModel {
    data?: AppTransactionDto | undefined;
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    mojoPayTransactionId?: string | undefined;

    constructor(data?: IMojoPayInitPaymentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AppTransactionDto.fromJS(_data["data"]) : undefined as any;
            this.statusCode = _data["statusCode"];
            this.statusMessage = _data["statusMessage"];
            this.mojoPayTransactionId = _data["mojoPayTransactionId"];
        }
    }

    static fromJS(data: any): MojoPayInitPaymentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayInitPaymentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["statusCode"] = this.statusCode;
        data["statusMessage"] = this.statusMessage;
        data["mojoPayTransactionId"] = this.mojoPayTransactionId;
        return data;
    }
}

export interface IMojoPayInitPaymentResponseModel {
    data?: AppTransactionDto | undefined;
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    mojoPayTransactionId?: string | undefined;
}

export class MojoPayInitPaymentRequestModel implements IMojoPayInitPaymentRequestModel {
    customerName?: string | undefined;
    network?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    feeTypeCode?: string | undefined;
    currency?: string | undefined;
    countryCode?: string | undefined;
    amount?: number;
    orderDesc?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: IMojoPayInitPaymentRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.network = _data["network"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.feeTypeCode = _data["feeTypeCode"];
            this.currency = _data["currency"];
            this.countryCode = _data["countryCode"];
            this.amount = _data["amount"];
            this.orderDesc = _data["orderDesc"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): MojoPayInitPaymentRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayInitPaymentRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["network"] = this.network;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["feeTypeCode"] = this.feeTypeCode;
        data["currency"] = this.currency;
        data["countryCode"] = this.countryCode;
        data["amount"] = this.amount;
        data["orderDesc"] = this.orderDesc;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IMojoPayInitPaymentRequestModel {
    customerName?: string | undefined;
    network?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    feeTypeCode?: string | undefined;
    currency?: string | undefined;
    countryCode?: string | undefined;
    amount?: number;
    orderDesc?: string | undefined;
    sessionId?: string | undefined;
}

export class MojoPayGetTransactionStatusResponseModel implements IMojoPayGetTransactionStatusResponseModel {
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    mojoPayTransactionId?: string | undefined;
    orderId?: string | undefined;
    paymentMode?: string | undefined;
    remarks?: string | undefined;
    orderAmount?: number;
    netAmount?: number;
    netAmountDetails?: MojoPayNetAmountDetailsDto | undefined;
    localStatus?: string | undefined;

    constructor(data?: IMojoPayGetTransactionStatusResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.statusMessage = _data["statusMessage"];
            this.mojoPayTransactionId = _data["mojoPayTransactionId"];
            this.orderId = _data["orderId"];
            this.paymentMode = _data["paymentMode"];
            this.remarks = _data["remarks"];
            this.orderAmount = _data["orderAmount"];
            this.netAmount = _data["netAmount"];
            this.netAmountDetails = _data["netAmountDetails"] ? MojoPayNetAmountDetailsDto.fromJS(_data["netAmountDetails"]) : undefined as any;
            this.localStatus = _data["localStatus"];
        }
    }

    static fromJS(data: any): MojoPayGetTransactionStatusResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayGetTransactionStatusResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusMessage"] = this.statusMessage;
        data["mojoPayTransactionId"] = this.mojoPayTransactionId;
        data["orderId"] = this.orderId;
        data["paymentMode"] = this.paymentMode;
        data["remarks"] = this.remarks;
        data["orderAmount"] = this.orderAmount;
        data["netAmount"] = this.netAmount;
        data["netAmountDetails"] = this.netAmountDetails ? this.netAmountDetails.toJSON() : undefined as any;
        data["localStatus"] = this.localStatus;
        return data;
    }
}

export interface IMojoPayGetTransactionStatusResponseModel {
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    mojoPayTransactionId?: string | undefined;
    orderId?: string | undefined;
    paymentMode?: string | undefined;
    remarks?: string | undefined;
    orderAmount?: number;
    netAmount?: number;
    netAmountDetails?: MojoPayNetAmountDetailsDto | undefined;
    localStatus?: string | undefined;
}

export class MojoPayNetAmountDetailsDto implements IMojoPayNetAmountDetailsDto {
    baseAmount?: number;
    serviceCharge?: number;
    taxCharges?: number;
    otherCharges?: number;

    constructor(data?: IMojoPayNetAmountDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseAmount = _data["baseAmount"];
            this.serviceCharge = _data["serviceCharge"];
            this.taxCharges = _data["taxCharges"];
            this.otherCharges = _data["otherCharges"];
        }
    }

    static fromJS(data: any): MojoPayNetAmountDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayNetAmountDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseAmount"] = this.baseAmount;
        data["serviceCharge"] = this.serviceCharge;
        data["taxCharges"] = this.taxCharges;
        data["otherCharges"] = this.otherCharges;
        return data;
    }
}

export interface IMojoPayNetAmountDetailsDto {
    baseAmount?: number;
    serviceCharge?: number;
    taxCharges?: number;
    otherCharges?: number;
}

export class MojoPayHandleCallbackResponseModel implements IMojoPayHandleCallbackResponseModel {
    acknowledged?: boolean;

    constructor(data?: IMojoPayHandleCallbackResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acknowledged = _data["acknowledged"];
        }
    }

    static fromJS(data: any): MojoPayHandleCallbackResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayHandleCallbackResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acknowledged"] = this.acknowledged;
        return data;
    }
}

export interface IMojoPayHandleCallbackResponseModel {
    acknowledged?: boolean;
}

export class MojoPayCallbackDto implements IMojoPayCallbackDto {
    validation?: string | undefined;
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    transactionId?: number;
    orderId?: string | undefined;
    mobile?: string | undefined;
    remarks?: string | undefined;
    signature?: string | undefined;
    orderAmount?: number;
    netAmount?: number;
    netAmountDetails?: MojoPayNetAmountDetailsDto | undefined;

    constructor(data?: IMojoPayCallbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validation = _data["validation"];
            this.statusCode = _data["statusCode"];
            this.statusMessage = _data["statusMessage"];
            this.transactionId = _data["transactionId"];
            this.orderId = _data["orderId"];
            this.mobile = _data["mobile"];
            this.remarks = _data["remarks"];
            this.signature = _data["signature"];
            this.orderAmount = _data["orderAmount"];
            this.netAmount = _data["netAmount"];
            this.netAmountDetails = _data["netAmountDetails"] ? MojoPayNetAmountDetailsDto.fromJS(_data["netAmountDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): MojoPayCallbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayCallbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation;
        data["statusCode"] = this.statusCode;
        data["statusMessage"] = this.statusMessage;
        data["transactionId"] = this.transactionId;
        data["orderId"] = this.orderId;
        data["mobile"] = this.mobile;
        data["remarks"] = this.remarks;
        data["signature"] = this.signature;
        data["orderAmount"] = this.orderAmount;
        data["netAmount"] = this.netAmount;
        data["netAmountDetails"] = this.netAmountDetails ? this.netAmountDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IMojoPayCallbackDto {
    validation?: string | undefined;
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    transactionId?: number;
    orderId?: string | undefined;
    mobile?: string | undefined;
    remarks?: string | undefined;
    signature?: string | undefined;
    orderAmount?: number;
    netAmount?: number;
    netAmountDetails?: MojoPayNetAmountDetailsDto | undefined;
}

export class MojoPayDisburseMomoResponseModel implements IMojoPayDisburseMomoResponseModel {
    data?: AppTransactionDto | undefined;
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    mojoPayTransactionId?: string | undefined;

    constructor(data?: IMojoPayDisburseMomoResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AppTransactionDto.fromJS(_data["data"]) : undefined as any;
            this.statusCode = _data["statusCode"];
            this.statusMessage = _data["statusMessage"];
            this.mojoPayTransactionId = _data["mojoPayTransactionId"];
        }
    }

    static fromJS(data: any): MojoPayDisburseMomoResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayDisburseMomoResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["statusCode"] = this.statusCode;
        data["statusMessage"] = this.statusMessage;
        data["mojoPayTransactionId"] = this.mojoPayTransactionId;
        return data;
    }
}

export interface IMojoPayDisburseMomoResponseModel {
    data?: AppTransactionDto | undefined;
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    mojoPayTransactionId?: string | undefined;
}

export class MojoPayDisburseMomoRequestModel implements IMojoPayDisburseMomoRequestModel {
    payerName?: string | undefined;
    payerEmail?: string | undefined;
    payerMobile?: string | undefined;
    customerName?: string | undefined;
    network?: string | undefined;
    mobile?: string | undefined;
    currency?: string | undefined;
    amount?: number;
    orderDesc?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: IMojoPayDisburseMomoRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payerName = _data["payerName"];
            this.payerEmail = _data["payerEmail"];
            this.payerMobile = _data["payerMobile"];
            this.customerName = _data["customerName"];
            this.network = _data["network"];
            this.mobile = _data["mobile"];
            this.currency = _data["currency"];
            this.amount = _data["amount"];
            this.orderDesc = _data["orderDesc"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): MojoPayDisburseMomoRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayDisburseMomoRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payerName"] = this.payerName;
        data["payerEmail"] = this.payerEmail;
        data["payerMobile"] = this.payerMobile;
        data["customerName"] = this.customerName;
        data["network"] = this.network;
        data["mobile"] = this.mobile;
        data["currency"] = this.currency;
        data["amount"] = this.amount;
        data["orderDesc"] = this.orderDesc;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IMojoPayDisburseMomoRequestModel {
    payerName?: string | undefined;
    payerEmail?: string | undefined;
    payerMobile?: string | undefined;
    customerName?: string | undefined;
    network?: string | undefined;
    mobile?: string | undefined;
    currency?: string | undefined;
    amount?: number;
    orderDesc?: string | undefined;
    sessionId?: string | undefined;
}

export class MojoPayDisburseBankResponseModel implements IMojoPayDisburseBankResponseModel {
    data?: AppTransactionDto | undefined;
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    mojoPayTransactionId?: string | undefined;

    constructor(data?: IMojoPayDisburseBankResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AppTransactionDto.fromJS(_data["data"]) : undefined as any;
            this.statusCode = _data["statusCode"];
            this.statusMessage = _data["statusMessage"];
            this.mojoPayTransactionId = _data["mojoPayTransactionId"];
        }
    }

    static fromJS(data: any): MojoPayDisburseBankResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayDisburseBankResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["statusCode"] = this.statusCode;
        data["statusMessage"] = this.statusMessage;
        data["mojoPayTransactionId"] = this.mojoPayTransactionId;
        return data;
    }
}

export interface IMojoPayDisburseBankResponseModel {
    data?: AppTransactionDto | undefined;
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    mojoPayTransactionId?: string | undefined;
}

export class MojoPayDisburseBankRequestModel implements IMojoPayDisburseBankRequestModel {
    bankCode?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    currency?: string | undefined;
    amount?: number;
    orderDesc?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: IMojoPayDisburseBankRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankCode = _data["bankCode"];
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.currency = _data["currency"];
            this.amount = _data["amount"];
            this.orderDesc = _data["orderDesc"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): MojoPayDisburseBankRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayDisburseBankRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankCode"] = this.bankCode;
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["currency"] = this.currency;
        data["amount"] = this.amount;
        data["orderDesc"] = this.orderDesc;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IMojoPayDisburseBankRequestModel {
    bankCode?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    currency?: string | undefined;
    amount?: number;
    orderDesc?: string | undefined;
    sessionId?: string | undefined;
}

export class MojoPayGetDisbursementStatusResponseModel implements IMojoPayGetDisbursementStatusResponseModel {
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    mojoPayTransactionId?: string | undefined;
    orderId?: string | undefined;
    orderAmount?: number;
    netAmount?: number;
    remarks?: string | undefined;
    localStatus?: string | undefined;

    constructor(data?: IMojoPayGetDisbursementStatusResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.statusMessage = _data["statusMessage"];
            this.mojoPayTransactionId = _data["mojoPayTransactionId"];
            this.orderId = _data["orderId"];
            this.orderAmount = _data["orderAmount"];
            this.netAmount = _data["netAmount"];
            this.remarks = _data["remarks"];
            this.localStatus = _data["localStatus"];
        }
    }

    static fromJS(data: any): MojoPayGetDisbursementStatusResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayGetDisbursementStatusResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusMessage"] = this.statusMessage;
        data["mojoPayTransactionId"] = this.mojoPayTransactionId;
        data["orderId"] = this.orderId;
        data["orderAmount"] = this.orderAmount;
        data["netAmount"] = this.netAmount;
        data["remarks"] = this.remarks;
        data["localStatus"] = this.localStatus;
        return data;
    }
}

export interface IMojoPayGetDisbursementStatusResponseModel {
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    mojoPayTransactionId?: string | undefined;
    orderId?: string | undefined;
    orderAmount?: number;
    netAmount?: number;
    remarks?: string | undefined;
    localStatus?: string | undefined;
}

export class MojoPayHandleDisbursementCallbackResponseModel implements IMojoPayHandleDisbursementCallbackResponseModel {
    acknowledged?: boolean;

    constructor(data?: IMojoPayHandleDisbursementCallbackResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acknowledged = _data["acknowledged"];
        }
    }

    static fromJS(data: any): MojoPayHandleDisbursementCallbackResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayHandleDisbursementCallbackResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acknowledged"] = this.acknowledged;
        return data;
    }
}

export interface IMojoPayHandleDisbursementCallbackResponseModel {
    acknowledged?: boolean;
}

export class MojoPayDisbursementCallbackDto implements IMojoPayDisbursementCallbackDto {
    orderId?: string | undefined;
    transactionDate?: string | undefined;
    amount?: number;
    transactionId?: number;
    transactionStatus?: string | undefined;
    statusMessage?: string | undefined;
    validation?: string | undefined;

    constructor(data?: IMojoPayDisbursementCallbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.transactionDate = _data["transactionDate"];
            this.amount = _data["amount"];
            this.transactionId = _data["transactionId"];
            this.transactionStatus = _data["transactionStatus"];
            this.statusMessage = _data["statusMessage"];
            this.validation = _data["validation"];
        }
    }

    static fromJS(data: any): MojoPayDisbursementCallbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayDisbursementCallbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["transactionDate"] = this.transactionDate;
        data["amount"] = this.amount;
        data["transactionId"] = this.transactionId;
        data["transactionStatus"] = this.transactionStatus;
        data["statusMessage"] = this.statusMessage;
        data["validation"] = this.validation;
        return data;
    }
}

export interface IMojoPayDisbursementCallbackDto {
    orderId?: string | undefined;
    transactionDate?: string | undefined;
    amount?: number;
    transactionId?: number;
    transactionStatus?: string | undefined;
    statusMessage?: string | undefined;
    validation?: string | undefined;
}

export class MojoPayGetBankListResponseModel implements IMojoPayGetBankListResponseModel {
    banks?: MojoPayBankItem[] | undefined;

    constructor(data?: IMojoPayGetBankListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["banks"])) {
                this.banks = [] as any;
                for (let item of _data["banks"])
                    this.banks!.push(MojoPayBankItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MojoPayGetBankListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayGetBankListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.banks)) {
            data["banks"] = [];
            for (let item of this.banks)
                data["banks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMojoPayGetBankListResponseModel {
    banks?: MojoPayBankItem[] | undefined;
}

export class MojoPayBankItem implements IMojoPayBankItem {
    bankCode?: string | undefined;
    bankName?: string | undefined;

    constructor(data?: IMojoPayBankItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankCode = _data["bankCode"];
            this.bankName = _data["bankName"];
        }
    }

    static fromJS(data: any): MojoPayBankItem {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayBankItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        return data;
    }
}

export interface IMojoPayBankItem {
    bankCode?: string | undefined;
    bankName?: string | undefined;
}

export class MojoPayCheckBalanceResponseModel implements IMojoPayCheckBalanceResponseModel {
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    currency?: string | undefined;
    balance?: number;

    constructor(data?: IMojoPayCheckBalanceResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.statusMessage = _data["statusMessage"];
            this.currency = _data["currency"];
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): MojoPayCheckBalanceResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayCheckBalanceResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusMessage"] = this.statusMessage;
        data["currency"] = this.currency;
        data["balance"] = this.balance;
        return data;
    }
}

export interface IMojoPayCheckBalanceResponseModel {
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    currency?: string | undefined;
    balance?: number;
}

export class MojoPayKycResponseModel implements IMojoPayKycResponseModel {
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    accountName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IMojoPayKycResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.statusMessage = _data["statusMessage"];
            this.accountName = _data["accountName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): MojoPayKycResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayKycResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusMessage"] = this.statusMessage;
        data["accountName"] = this.accountName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IMojoPayKycResponseModel {
    statusCode?: string | undefined;
    statusMessage?: string | undefined;
    accountName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class MojoPayBankKycRequestModel implements IMojoPayBankKycRequestModel {
    bankCode?: string | undefined;
    accountNumber?: string | undefined;

    constructor(data?: IMojoPayBankKycRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankCode = _data["bankCode"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): MojoPayBankKycRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayBankKycRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankCode"] = this.bankCode;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface IMojoPayBankKycRequestModel {
    bankCode?: string | undefined;
    accountNumber?: string | undefined;
}

export class MojoPayMomoKycRequestModel implements IMojoPayMomoKycRequestModel {
    network?: string | undefined;
    mobile?: string | undefined;

    constructor(data?: IMojoPayMomoKycRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.network = _data["network"];
            this.mobile = _data["mobile"];
        }
    }

    static fromJS(data: any): MojoPayMomoKycRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new MojoPayMomoKycRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["network"] = this.network;
        data["mobile"] = this.mobile;
        return data;
    }
}

export interface IMojoPayMomoKycRequestModel {
    network?: string | undefined;
    mobile?: string | undefined;
}

export class GenerateTokenResponseModel implements IGenerateTokenResponseModel {

    constructor(data?: IGenerateTokenResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GenerateTokenResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateTokenResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGenerateTokenResponseModel {
}

export class GenerateTokenRequestModel implements IGenerateTokenRequestModel {
    sessionId?: string | undefined;

    constructor(data?: IGenerateTokenRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): GenerateTokenRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateTokenRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IGenerateTokenRequestModel {
    sessionId?: string | undefined;
}

export class GetMtnBalanceResponseModel implements IGetMtnBalanceResponseModel {
    data?: number;

    constructor(data?: IGetMtnBalanceResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GetMtnBalanceResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMtnBalanceResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface IGetMtnBalanceResponseModel {
    data?: number;
}

export class CreateWithdrawRequestResponseModel implements ICreateWithdrawRequestResponseModel {
    data?: AppTransactionDto | undefined;

    constructor(data?: ICreateWithdrawRequestResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AppTransactionDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateWithdrawRequestResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWithdrawRequestResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateWithdrawRequestResponseModel {
    data?: AppTransactionDto | undefined;
}

export class CreateWithdrawRequestRequestModel implements ICreateWithdrawRequestRequestModel {
    phoneNumber?: string | undefined;
    amount?: number;
    currency?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: ICreateWithdrawRequestRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): CreateWithdrawRequestRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWithdrawRequestRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface ICreateWithdrawRequestRequestModel {
    phoneNumber?: string | undefined;
    amount?: number;
    currency?: string | undefined;
    sessionId?: string | undefined;
}

export class GetMtnUserInfoResponseModel implements IGetMtnUserInfoResponseModel {
    data?: MtnUserDto | undefined;

    constructor(data?: IGetMtnUserInfoResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? MtnUserDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMtnUserInfoResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMtnUserInfoResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetMtnUserInfoResponseModel {
    data?: MtnUserDto | undefined;
}

export class MtnUserDto implements IMtnUserDto {
    phoneNumber?: string | undefined;
    sub?: string | undefined;
    name?: string | undefined;
    givenName?: string | undefined;
    familyName?: string | undefined;
    isActive?: boolean;

    constructor(data?: IMtnUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.sub = _data["sub"];
            this.name = _data["name"];
            this.givenName = _data["givenName"];
            this.familyName = _data["familyName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MtnUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new MtnUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["sub"] = this.sub;
        data["name"] = this.name;
        data["givenName"] = this.givenName;
        data["familyName"] = this.familyName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMtnUserDto {
    phoneNumber?: string | undefined;
    sub?: string | undefined;
    name?: string | undefined;
    givenName?: string | undefined;
    familyName?: string | undefined;
    isActive?: boolean;
}

export class GetMtnTransactionResponseModel implements IGetMtnTransactionResponseModel {
    data?: StatusReasonDto | undefined;

    constructor(data?: IGetMtnTransactionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StatusReasonDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMtnTransactionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMtnTransactionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetMtnTransactionResponseModel {
    data?: StatusReasonDto | undefined;
}

export class StatusReasonDto implements IStatusReasonDto {
    status?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IStatusReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): StatusReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IStatusReasonDto {
    status?: string | undefined;
    reason?: string | undefined;
}

export class CreateTransferRequestResponseModel implements ICreateTransferRequestResponseModel {
    data?: AppTransactionDto | undefined;

    constructor(data?: ICreateTransferRequestResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AppTransactionDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateTransferRequestResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransferRequestResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateTransferRequestResponseModel {
    data?: AppTransactionDto | undefined;
}

export class CreateTransferRequestRequestModel implements ICreateTransferRequestRequestModel {
    phoneNumber?: string | undefined;
    amount?: number;
    currency?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: ICreateTransferRequestRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): CreateTransferRequestRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransferRequestRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface ICreateTransferRequestRequestModel {
    phoneNumber?: string | undefined;
    amount?: number;
    currency?: string | undefined;
    sessionId?: string | undefined;
}

export class GetPartnersResponseModel implements IGetPartnersResponseModel {
    data?: PartnerDto[] | undefined;
    count?: number;

    constructor(data?: IGetPartnersResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PartnerDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetPartnersResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnersResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetPartnersResponseModel {
    data?: PartnerDto[] | undefined;
    count?: number;
}

export class PartnerDto implements IPartnerDto {
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;

    constructor(data?: IPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.imageUrl = _data["imageUrl"];
            this.isEnabled = _data["isEnabled"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): PartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["imageUrl"] = this.imageUrl;
        data["isEnabled"] = this.isEnabled;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IPartnerDto {
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;
}

export class GetPartnerByIdResponseModel implements IGetPartnerByIdResponseModel {
    data?: PartnerDto | undefined;
    availableBalance?: number;
    balances?: CurrencyBalance[] | undefined;

    constructor(data?: IGetPartnerByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PartnerDto.fromJS(_data["data"]) : undefined as any;
            this.availableBalance = _data["availableBalance"];
            if (Array.isArray(_data["balances"])) {
                this.balances = [] as any;
                for (let item of _data["balances"])
                    this.balances!.push(CurrencyBalance.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPartnerByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["availableBalance"] = this.availableBalance;
        if (Array.isArray(this.balances)) {
            data["balances"] = [];
            for (let item of this.balances)
                data["balances"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPartnerByIdResponseModel {
    data?: PartnerDto | undefined;
    availableBalance?: number;
    balances?: CurrencyBalance[] | undefined;
}

export class CreatePartnerResponseModel implements ICreatePartnerResponseModel {
    data?: PartnerDto | undefined;

    constructor(data?: ICreatePartnerResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PartnerDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreatePartnerResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreatePartnerResponseModel {
    data?: PartnerDto | undefined;
}

export class CreatePartnerRequestModel implements ICreatePartnerRequestModel {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: ICreatePartnerRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): CreatePartnerRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface ICreatePartnerRequestModel {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
}

export class UpdatePartnerResponseModel implements IUpdatePartnerResponseModel {
    data?: PartnerDto | undefined;

    constructor(data?: IUpdatePartnerResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PartnerDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdatePartnerResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdatePartnerResponseModel {
    data?: PartnerDto | undefined;
}

export class UpdatePartnerRequestModel implements IUpdatePartnerRequestModel {
    id?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IUpdatePartnerRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdatePartnerRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpdatePartnerRequestModel {
    id?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isEnabled?: boolean;
}

export class GetPartnerAtmsResponseModel implements IGetPartnerAtmsResponseModel {
    data?: PartnerAtmDto[] | undefined;

    constructor(data?: IGetPartnerAtmsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PartnerAtmDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPartnerAtmsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerAtmsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPartnerAtmsResponseModel {
    data?: PartnerAtmDto[] | undefined;
}

export class PartnerAtmDto implements IPartnerAtmDto {
    atmId?: string | undefined;
    atmName?: string | undefined;
    sharePct?: number;
    isActive?: boolean;
    createdDate?: string;

    constructor(data?: IPartnerAtmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atmId = _data["atmId"];
            this.atmName = _data["atmName"];
            this.sharePct = _data["sharePct"];
            this.isActive = _data["isActive"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): PartnerAtmDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAtmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmId"] = this.atmId;
        data["atmName"] = this.atmName;
        data["sharePct"] = this.sharePct;
        data["isActive"] = this.isActive;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IPartnerAtmDto {
    atmId?: string | undefined;
    atmName?: string | undefined;
    sharePct?: number;
    isActive?: boolean;
    createdDate?: string;
}

export class GetAtmPartnersResponseModel implements IGetAtmPartnersResponseModel {
    data?: AtmPartnerDto[] | undefined;

    constructor(data?: IGetAtmPartnersResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AtmPartnerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAtmPartnersResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmPartnersResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAtmPartnersResponseModel {
    data?: AtmPartnerDto[] | undefined;
}

export class AtmPartnerDto implements IAtmPartnerDto {
    atmId?: string | undefined;
    partnerId?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    isEnabled?: boolean;
    sharePct?: number;
    isActive?: boolean;
    createdDate?: string;

    constructor(data?: IAtmPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atmId = _data["atmId"];
            this.partnerId = _data["partnerId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.imageUrl = _data["imageUrl"];
            this.isEnabled = _data["isEnabled"];
            this.sharePct = _data["sharePct"];
            this.isActive = _data["isActive"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): AtmPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AtmPartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmId"] = this.atmId;
        data["partnerId"] = this.partnerId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["imageUrl"] = this.imageUrl;
        data["isEnabled"] = this.isEnabled;
        data["sharePct"] = this.sharePct;
        data["isActive"] = this.isActive;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IAtmPartnerDto {
    atmId?: string | undefined;
    partnerId?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    isEnabled?: boolean;
    sharePct?: number;
    isActive?: boolean;
    createdDate?: string;
}

export class AssignPartnerToAtmResponseModel implements IAssignPartnerToAtmResponseModel {

    constructor(data?: IAssignPartnerToAtmResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AssignPartnerToAtmResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignPartnerToAtmResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAssignPartnerToAtmResponseModel {
}

export class AssignPartnerToAtmRequestModel implements IAssignPartnerToAtmRequestModel {
    partnerId?: string | undefined;
    atmId?: string | undefined;

    constructor(data?: IAssignPartnerToAtmRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.atmId = _data["atmId"];
        }
    }

    static fromJS(data: any): AssignPartnerToAtmRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignPartnerToAtmRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["atmId"] = this.atmId;
        return data;
    }
}

export interface IAssignPartnerToAtmRequestModel {
    partnerId?: string | undefined;
    atmId?: string | undefined;
}

export class RemovePartnerFromAtmResponseModel implements IRemovePartnerFromAtmResponseModel {

    constructor(data?: IRemovePartnerFromAtmResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RemovePartnerFromAtmResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemovePartnerFromAtmResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRemovePartnerFromAtmResponseModel {
}

export class GetAtmProfitSharesResponseModel implements IGetAtmProfitSharesResponseModel {
    companySharePct?: number;
    ownerId?: string | undefined;
    ownerName?: string | undefined;
    ownerSharePct?: number;
    partnerShares?: PartnerShareResult[] | undefined;
    investorShares?: InvestorShareResult[] | undefined;

    constructor(data?: IGetAtmProfitSharesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companySharePct = _data["companySharePct"];
            this.ownerId = _data["ownerId"];
            this.ownerName = _data["ownerName"];
            this.ownerSharePct = _data["ownerSharePct"];
            if (Array.isArray(_data["partnerShares"])) {
                this.partnerShares = [] as any;
                for (let item of _data["partnerShares"])
                    this.partnerShares!.push(PartnerShareResult.fromJS(item));
            }
            if (Array.isArray(_data["investorShares"])) {
                this.investorShares = [] as any;
                for (let item of _data["investorShares"])
                    this.investorShares!.push(InvestorShareResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAtmProfitSharesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmProfitSharesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companySharePct"] = this.companySharePct;
        data["ownerId"] = this.ownerId;
        data["ownerName"] = this.ownerName;
        data["ownerSharePct"] = this.ownerSharePct;
        if (Array.isArray(this.partnerShares)) {
            data["partnerShares"] = [];
            for (let item of this.partnerShares)
                data["partnerShares"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.investorShares)) {
            data["investorShares"] = [];
            for (let item of this.investorShares)
                data["investorShares"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAtmProfitSharesResponseModel {
    companySharePct?: number;
    ownerId?: string | undefined;
    ownerName?: string | undefined;
    ownerSharePct?: number;
    partnerShares?: PartnerShareResult[] | undefined;
    investorShares?: InvestorShareResult[] | undefined;
}

export class PartnerShareResult implements IPartnerShareResult {
    partnerId?: string | undefined;
    partnerName?: string | undefined;
    sharePct?: number;

    constructor(data?: IPartnerShareResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.partnerName = _data["partnerName"];
            this.sharePct = _data["sharePct"];
        }
    }

    static fromJS(data: any): PartnerShareResult {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerShareResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["partnerName"] = this.partnerName;
        data["sharePct"] = this.sharePct;
        return data;
    }
}

export interface IPartnerShareResult {
    partnerId?: string | undefined;
    partnerName?: string | undefined;
    sharePct?: number;
}

export class InvestorShareResult implements IInvestorShareResult {
    investorId?: string | undefined;
    investorName?: string | undefined;
    sharePct?: number;
    effectivePct?: number;

    constructor(data?: IInvestorShareResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorId = _data["investorId"];
            this.investorName = _data["investorName"];
            this.sharePct = _data["sharePct"];
            this.effectivePct = _data["effectivePct"];
        }
    }

    static fromJS(data: any): InvestorShareResult {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorShareResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorId"] = this.investorId;
        data["investorName"] = this.investorName;
        data["sharePct"] = this.sharePct;
        data["effectivePct"] = this.effectivePct;
        return data;
    }
}

export interface IInvestorShareResult {
    investorId?: string | undefined;
    investorName?: string | undefined;
    sharePct?: number;
    effectivePct?: number;
}

export class SetAtmProfitSharesResponseModel implements ISetAtmProfitSharesResponseModel {

    constructor(data?: ISetAtmProfitSharesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SetAtmProfitSharesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetAtmProfitSharesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISetAtmProfitSharesResponseModel {
}

export class SetAtmProfitSharesRequestModel implements ISetAtmProfitSharesRequestModel {
    atmId?: string | undefined;
    companySharePct?: number;
    partnerShares?: PartnerShareItem[] | undefined;
    investorShares?: InvestorShareItem[] | undefined;

    constructor(data?: ISetAtmProfitSharesRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atmId = _data["atmId"];
            this.companySharePct = _data["companySharePct"];
            if (Array.isArray(_data["partnerShares"])) {
                this.partnerShares = [] as any;
                for (let item of _data["partnerShares"])
                    this.partnerShares!.push(PartnerShareItem.fromJS(item));
            }
            if (Array.isArray(_data["investorShares"])) {
                this.investorShares = [] as any;
                for (let item of _data["investorShares"])
                    this.investorShares!.push(InvestorShareItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetAtmProfitSharesRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetAtmProfitSharesRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmId"] = this.atmId;
        data["companySharePct"] = this.companySharePct;
        if (Array.isArray(this.partnerShares)) {
            data["partnerShares"] = [];
            for (let item of this.partnerShares)
                data["partnerShares"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.investorShares)) {
            data["investorShares"] = [];
            for (let item of this.investorShares)
                data["investorShares"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetAtmProfitSharesRequestModel {
    atmId?: string | undefined;
    companySharePct?: number;
    partnerShares?: PartnerShareItem[] | undefined;
    investorShares?: InvestorShareItem[] | undefined;
}

export class PartnerShareItem implements IPartnerShareItem {
    partnerId?: string | undefined;
    sharePct?: number;

    constructor(data?: IPartnerShareItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.sharePct = _data["sharePct"];
        }
    }

    static fromJS(data: any): PartnerShareItem {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerShareItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["sharePct"] = this.sharePct;
        return data;
    }
}

export interface IPartnerShareItem {
    partnerId?: string | undefined;
    sharePct?: number;
}

export class InvestorShareItem implements IInvestorShareItem {
    investorId?: string | undefined;
    sharePct?: number;

    constructor(data?: IInvestorShareItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorId = _data["investorId"];
            this.sharePct = _data["sharePct"];
        }
    }

    static fromJS(data: any): InvestorShareItem {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorShareItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorId"] = this.investorId;
        data["sharePct"] = this.sharePct;
        return data;
    }
}

export interface IInvestorShareItem {
    investorId?: string | undefined;
    sharePct?: number;
}

export class GetPartnerAtmServicesResponseModel implements IGetPartnerAtmServicesResponseModel {
    services?: AtmFunctionType[] | undefined;

    constructor(data?: IGetPartnerAtmServicesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPartnerAtmServicesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerAtmServicesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item);
        }
        return data;
    }
}

export interface IGetPartnerAtmServicesResponseModel {
    services?: AtmFunctionType[] | undefined;
}

export class AssignPartnerAtmServiceResponseModel implements IAssignPartnerAtmServiceResponseModel {

    constructor(data?: IAssignPartnerAtmServiceResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AssignPartnerAtmServiceResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignPartnerAtmServiceResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAssignPartnerAtmServiceResponseModel {
}

export class AssignPartnerAtmServiceRequestModel implements IAssignPartnerAtmServiceRequestModel {
    partnerId?: string | undefined;
    atmId?: string | undefined;
    serviceType?: AtmFunctionType;

    constructor(data?: IAssignPartnerAtmServiceRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.atmId = _data["atmId"];
            this.serviceType = _data["serviceType"];
        }
    }

    static fromJS(data: any): AssignPartnerAtmServiceRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignPartnerAtmServiceRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["atmId"] = this.atmId;
        data["serviceType"] = this.serviceType;
        return data;
    }
}

export interface IAssignPartnerAtmServiceRequestModel {
    partnerId?: string | undefined;
    atmId?: string | undefined;
    serviceType?: AtmFunctionType;
}

export class RemovePartnerAtmServiceResponseModel implements IRemovePartnerAtmServiceResponseModel {

    constructor(data?: IRemovePartnerAtmServiceResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RemovePartnerAtmServiceResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemovePartnerAtmServiceResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRemovePartnerAtmServiceResponseModel {
}

export class GetPartnerDashboardResponseModel implements IGetPartnerDashboardResponseModel {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    balances?: CurrencyBalance[] | undefined;
    assignedAtms?: PartnerAtmDto[] | undefined;

    constructor(data?: IGetPartnerDashboardResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.imageUrl = _data["imageUrl"];
            if (Array.isArray(_data["balances"])) {
                this.balances = [] as any;
                for (let item of _data["balances"])
                    this.balances!.push(CurrencyBalance.fromJS(item));
            }
            if (Array.isArray(_data["assignedAtms"])) {
                this.assignedAtms = [] as any;
                for (let item of _data["assignedAtms"])
                    this.assignedAtms!.push(PartnerAtmDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPartnerDashboardResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerDashboardResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["imageUrl"] = this.imageUrl;
        if (Array.isArray(this.balances)) {
            data["balances"] = [];
            for (let item of this.balances)
                data["balances"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignedAtms)) {
            data["assignedAtms"] = [];
            for (let item of this.assignedAtms)
                data["assignedAtms"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPartnerDashboardResponseModel {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    imageUrl?: string | undefined;
    balances?: CurrencyBalance[] | undefined;
    assignedAtms?: PartnerAtmDto[] | undefined;
}

export class GetPartnerTransactionsResponseModel implements IGetPartnerTransactionsResponseModel {
    data?: PartnerTransactionDto[] | undefined;
    count?: number;

    constructor(data?: IGetPartnerTransactionsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PartnerTransactionDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetPartnerTransactionsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerTransactionsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetPartnerTransactionsResponseModel {
    data?: PartnerTransactionDto[] | undefined;
    count?: number;
}

export class UpdatePartnerProfileResponseModel implements IUpdatePartnerProfileResponseModel {
    data?: PartnerDto | undefined;

    constructor(data?: IUpdatePartnerProfileResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PartnerDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdatePartnerProfileResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerProfileResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdatePartnerProfileResponseModel {
    data?: PartnerDto | undefined;
}

export class UpdatePartnerProfileRequestModel implements IUpdatePartnerProfileRequestModel {
    fullName?: string | undefined;
    imageUrl?: string | undefined;

    constructor(data?: IUpdatePartnerProfileRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): UpdatePartnerProfileRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerProfileRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IUpdatePartnerProfileRequestModel {
    fullName?: string | undefined;
    imageUrl?: string | undefined;
}

export class GetPartnerStaffsResponseModel implements IGetPartnerStaffsResponseModel {
    data?: PartnerStaffDto[] | undefined;
    count?: number;

    constructor(data?: IGetPartnerStaffsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PartnerStaffDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetPartnerStaffsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerStaffsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetPartnerStaffsResponseModel {
    data?: PartnerStaffDto[] | undefined;
    count?: number;
}

export class PartnerStaffDto implements IPartnerStaffDto {
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    partnerId?: string | undefined;
    isSupervisor?: boolean;
    isEnabled?: boolean;
    createdDate?: string;

    constructor(data?: IPartnerStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.partnerId = _data["partnerId"];
            this.isSupervisor = _data["isSupervisor"];
            this.isEnabled = _data["isEnabled"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): PartnerStaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerStaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["partnerId"] = this.partnerId;
        data["isSupervisor"] = this.isSupervisor;
        data["isEnabled"] = this.isEnabled;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IPartnerStaffDto {
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    partnerId?: string | undefined;
    isSupervisor?: boolean;
    isEnabled?: boolean;
    createdDate?: string;
}

export class GetPartnerStaffsDropDownResponseModel implements IGetPartnerStaffsDropDownResponseModel {
    data?: DropDownDtoOfString[] | undefined;

    constructor(data?: IGetPartnerStaffsDropDownResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DropDownDtoOfString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPartnerStaffsDropDownResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerStaffsDropDownResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPartnerStaffsDropDownResponseModel {
    data?: DropDownDtoOfString[] | undefined;
}

export class DropDownDtoOfString implements IDropDownDtoOfString {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IDropDownDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DropDownDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IDropDownDtoOfString {
    id?: string | undefined;
    name?: string | undefined;
}

export class CreatePartnerStaffResponseModel implements ICreatePartnerStaffResponseModel {
    data?: PartnerStaffDto | undefined;

    constructor(data?: ICreatePartnerStaffResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PartnerStaffDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreatePartnerStaffResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerStaffResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreatePartnerStaffResponseModel {
    data?: PartnerStaffDto | undefined;
}

export class CreatePartnerStaffRequestModel implements ICreatePartnerStaffRequestModel {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    partnerId?: string | undefined;
    atmId?: string | undefined;
    isSupervisor?: boolean;

    constructor(data?: ICreatePartnerStaffRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.partnerId = _data["partnerId"];
            this.atmId = _data["atmId"];
            this.isSupervisor = _data["isSupervisor"];
        }
    }

    static fromJS(data: any): CreatePartnerStaffRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerStaffRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["partnerId"] = this.partnerId;
        data["atmId"] = this.atmId;
        data["isSupervisor"] = this.isSupervisor;
        return data;
    }
}

export interface ICreatePartnerStaffRequestModel {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    partnerId?: string | undefined;
    atmId?: string | undefined;
    isSupervisor?: boolean;
}

export class UpdatePartnerStaffResponseModel implements IUpdatePartnerStaffResponseModel {
    data?: PartnerStaffDto | undefined;

    constructor(data?: IUpdatePartnerStaffResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PartnerStaffDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdatePartnerStaffResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerStaffResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdatePartnerStaffResponseModel {
    data?: PartnerStaffDto | undefined;
}

export class UpdatePartnerStaffRequestModel implements IUpdatePartnerStaffRequestModel {
    id?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    isSupervisor?: boolean | undefined;

    constructor(data?: IUpdatePartnerStaffRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.isSupervisor = _data["isSupervisor"];
        }
    }

    static fromJS(data: any): UpdatePartnerStaffRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerStaffRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["isSupervisor"] = this.isSupervisor;
        return data;
    }
}

export interface IUpdatePartnerStaffRequestModel {
    id?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    isSupervisor?: boolean | undefined;
}

export class DeletePartnerStaffResponseModel implements IDeletePartnerStaffResponseModel {

    constructor(data?: IDeletePartnerStaffResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeletePartnerStaffResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePartnerStaffResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeletePartnerStaffResponseModel {
}

export class EnablePartnerStaffResponseModel implements IEnablePartnerStaffResponseModel {

    constructor(data?: IEnablePartnerStaffResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): EnablePartnerStaffResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnablePartnerStaffResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IEnablePartnerStaffResponseModel {
}

export class EnablePartnerStaffRequestModel implements IEnablePartnerStaffRequestModel {
    id?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IEnablePartnerStaffRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): EnablePartnerStaffRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnablePartnerStaffRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IEnablePartnerStaffRequestModel {
    id?: string | undefined;
    isEnabled?: boolean;
}

export class GetTicketsResponseModel implements IGetTicketsResponseModel {
    data?: TicketDto[] | undefined;
    count?: number;

    constructor(data?: IGetTicketsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TicketDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetTicketsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTicketsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetTicketsResponseModel {
    data?: TicketDto[] | undefined;
    count?: number;
}

export class TicketDto implements ITicketDto {
    id?: number;
    atmId?: string | undefined;
    atm?: string | undefined;
    staffId?: string | undefined;
    staff?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    regionId?: number;
    region?: string | undefined;
    createdDate?: string;
    status?: number;
    resolvedDate?: string | undefined;
    createdBy?: string | undefined;
    country?: string | undefined;
    countryId?: number;

    constructor(data?: ITicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.atmId = _data["atmId"];
            this.atm = _data["atm"];
            this.staffId = _data["staffId"];
            this.staff = _data["staff"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.regionId = _data["regionId"];
            this.region = _data["region"];
            this.createdDate = _data["createdDate"];
            this.status = _data["status"];
            this.resolvedDate = _data["resolvedDate"];
            this.createdBy = _data["createdBy"];
            this.country = _data["country"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): TicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["atmId"] = this.atmId;
        data["atm"] = this.atm;
        data["staffId"] = this.staffId;
        data["staff"] = this.staff;
        data["title"] = this.title;
        data["description"] = this.description;
        data["regionId"] = this.regionId;
        data["region"] = this.region;
        data["createdDate"] = this.createdDate;
        data["status"] = this.status;
        data["resolvedDate"] = this.resolvedDate;
        data["createdBy"] = this.createdBy;
        data["country"] = this.country;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ITicketDto {
    id?: number;
    atmId?: string | undefined;
    atm?: string | undefined;
    staffId?: string | undefined;
    staff?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    regionId?: number;
    region?: string | undefined;
    createdDate?: string;
    status?: number;
    resolvedDate?: string | undefined;
    createdBy?: string | undefined;
    country?: string | undefined;
    countryId?: number;
}

export class GetTicketByIdResponseModel implements IGetTicketByIdResponseModel {
    data?: TicketDto | undefined;

    constructor(data?: IGetTicketByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TicketDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTicketByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTicketByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTicketByIdResponseModel {
    data?: TicketDto | undefined;
}

export class CreatePartnerTicketResponseModel implements ICreatePartnerTicketResponseModel {
    data?: TicketDto | undefined;

    constructor(data?: ICreatePartnerTicketResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TicketDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreatePartnerTicketResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerTicketResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreatePartnerTicketResponseModel {
    data?: TicketDto | undefined;
}

export class CreatePartnerTicketRequestModel implements ICreatePartnerTicketRequestModel {
    atmId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICreatePartnerTicketRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atmId = _data["atmId"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreatePartnerTicketRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerTicketRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmId"] = this.atmId;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreatePartnerTicketRequestModel {
    atmId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
}

export class UpdatePartnerTicketResponseModel implements IUpdatePartnerTicketResponseModel {
    data?: TicketDto | undefined;

    constructor(data?: IUpdatePartnerTicketResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TicketDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdatePartnerTicketResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerTicketResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdatePartnerTicketResponseModel {
    data?: TicketDto | undefined;
}

export class UpdatePartnerTicketRequestModel implements IUpdatePartnerTicketRequestModel {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUpdatePartnerTicketRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdatePartnerTicketRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerTicketRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdatePartnerTicketRequestModel {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
}

export class DeletePartnerTicketResponseModel implements IDeletePartnerTicketResponseModel {

    constructor(data?: IDeletePartnerTicketResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeletePartnerTicketResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePartnerTicketResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeletePartnerTicketResponseModel {
}

export class GetAtmRealTimeResponseModel implements IGetAtmRealTimeResponseModel {
    data?: AtmRealTimeDto[] | undefined;
    count?: number;

    constructor(data?: IGetAtmRealTimeResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AtmRealTimeDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAtmRealTimeResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAtmRealTimeResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetAtmRealTimeResponseModel {
    data?: AtmRealTimeDto[] | undefined;
    count?: number;
}

export class AtmRealTimeDto implements IAtmRealTimeDto {
    userId?: string | undefined;
    user?: string | undefined;
    action?: string | undefined;
    data?: string | undefined;
    currentScreen?: string | undefined;
    withdrawMoveForwardStatus?: string | undefined;
    withdrawDeliverNotesStatus?: string | undefined;
    printStatus?: string | undefined;
    depositNotes?: string | undefined;
    totalWithdraws?: number;
    totalDeposits?: number;
    updatedDate?: string;
    ipAddress?: string | undefined;
    isOnline?: boolean;
    healthStatus?: number;
    healthCheckedAt?: string | undefined;

    constructor(data?: IAtmRealTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"];
            this.action = _data["action"];
            this.data = _data["data"];
            this.currentScreen = _data["currentScreen"];
            this.withdrawMoveForwardStatus = _data["withdrawMoveForwardStatus"];
            this.withdrawDeliverNotesStatus = _data["withdrawDeliverNotesStatus"];
            this.printStatus = _data["printStatus"];
            this.depositNotes = _data["depositNotes"];
            this.totalWithdraws = _data["totalWithdraws"];
            this.totalDeposits = _data["totalDeposits"];
            this.updatedDate = _data["updatedDate"];
            this.ipAddress = _data["ipAddress"];
            this.isOnline = _data["isOnline"];
            this.healthStatus = _data["healthStatus"];
            this.healthCheckedAt = _data["healthCheckedAt"];
        }
    }

    static fromJS(data: any): AtmRealTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AtmRealTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user;
        data["action"] = this.action;
        data["data"] = this.data;
        data["currentScreen"] = this.currentScreen;
        data["withdrawMoveForwardStatus"] = this.withdrawMoveForwardStatus;
        data["withdrawDeliverNotesStatus"] = this.withdrawDeliverNotesStatus;
        data["printStatus"] = this.printStatus;
        data["depositNotes"] = this.depositNotes;
        data["totalWithdraws"] = this.totalWithdraws;
        data["totalDeposits"] = this.totalDeposits;
        data["updatedDate"] = this.updatedDate;
        data["ipAddress"] = this.ipAddress;
        data["isOnline"] = this.isOnline;
        data["healthStatus"] = this.healthStatus;
        data["healthCheckedAt"] = this.healthCheckedAt;
        return data;
    }
}

export interface IAtmRealTimeDto {
    userId?: string | undefined;
    user?: string | undefined;
    action?: string | undefined;
    data?: string | undefined;
    currentScreen?: string | undefined;
    withdrawMoveForwardStatus?: string | undefined;
    withdrawDeliverNotesStatus?: string | undefined;
    printStatus?: string | undefined;
    depositNotes?: string | undefined;
    totalWithdraws?: number;
    totalDeposits?: number;
    updatedDate?: string;
    ipAddress?: string | undefined;
    isOnline?: boolean;
    healthStatus?: number;
    healthCheckedAt?: string | undefined;
}

export class UpdateAtmRealTimeResponseModel implements IUpdateAtmRealTimeResponseModel {

    constructor(data?: IUpdateAtmRealTimeResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateAtmRealTimeResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAtmRealTimeResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateAtmRealTimeResponseModel {
}

export class UpdateAtmRealTimeRequestModel implements IUpdateAtmRealTimeRequestModel {
    action?: string | undefined;
    data?: string | undefined;
    currentScreen?: string | undefined;
    withdrawMoveForwardStatus?: string | undefined;
    withdrawDeliverNotesStatus?: string | undefined;
    printStatus?: string | undefined;
    depositNotes?: string | undefined;
    isDeposit?: boolean;
    isWithdraw?: boolean;

    constructor(data?: IUpdateAtmRealTimeRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.data = _data["data"];
            this.currentScreen = _data["currentScreen"];
            this.withdrawMoveForwardStatus = _data["withdrawMoveForwardStatus"];
            this.withdrawDeliverNotesStatus = _data["withdrawDeliverNotesStatus"];
            this.printStatus = _data["printStatus"];
            this.depositNotes = _data["depositNotes"];
            this.isDeposit = _data["isDeposit"];
            this.isWithdraw = _data["isWithdraw"];
        }
    }

    static fromJS(data: any): UpdateAtmRealTimeRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAtmRealTimeRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["data"] = this.data;
        data["currentScreen"] = this.currentScreen;
        data["withdrawMoveForwardStatus"] = this.withdrawMoveForwardStatus;
        data["withdrawDeliverNotesStatus"] = this.withdrawDeliverNotesStatus;
        data["printStatus"] = this.printStatus;
        data["depositNotes"] = this.depositNotes;
        data["isDeposit"] = this.isDeposit;
        data["isWithdraw"] = this.isWithdraw;
        return data;
    }
}

export interface IUpdateAtmRealTimeRequestModel {
    action?: string | undefined;
    data?: string | undefined;
    currentScreen?: string | undefined;
    withdrawMoveForwardStatus?: string | undefined;
    withdrawDeliverNotesStatus?: string | undefined;
    printStatus?: string | undefined;
    depositNotes?: string | undefined;
    isDeposit?: boolean;
    isWithdraw?: boolean;
}

export class GetRegionsResponseModel implements IGetRegionsResponseModel {
    data?: RegionDto[] | undefined;
    count?: number;

    constructor(data?: IGetRegionsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RegionDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetRegionsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetRegionsResponseModel {
    data?: RegionDto[] | undefined;
    count?: number;
}

export class RegionDto implements IRegionDto {
    id?: number;
    name?: string | undefined;
    countryId?: number;
    countryName?: string | undefined;
    createdDate?: string;

    constructor(data?: IRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): RegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IRegionDto {
    id?: number;
    name?: string | undefined;
    countryId?: number;
    countryName?: string | undefined;
    createdDate?: string;
}

export class GetRegionsDropDownResponseModel implements IGetRegionsDropDownResponseModel {
    data?: RegionDropDownDto[] | undefined;

    constructor(data?: IGetRegionsDropDownResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RegionDropDownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegionsDropDownResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionsDropDownResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetRegionsDropDownResponseModel {
    data?: RegionDropDownDto[] | undefined;
}

export class RegionDropDownDto implements IRegionDropDownDto {
    name?: string | undefined;
    id?: number;

    constructor(data?: IRegionDropDownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RegionDropDownDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDropDownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IRegionDropDownDto {
    name?: string | undefined;
    id?: number;
}

export class CreateRegionResponseModel implements ICreateRegionResponseModel {
    data?: RegionDto | undefined;

    constructor(data?: ICreateRegionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RegionDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateRegionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateRegionResponseModel {
    data?: RegionDto | undefined;
}

export class CreateRegionRequestModel implements ICreateRegionRequestModel {
    countryId?: number;
    name?: string | undefined;

    constructor(data?: ICreateRegionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateRegionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateRegionRequestModel {
    countryId?: number;
    name?: string | undefined;
}

export class UpdateRegionResponseModel implements IUpdateRegionResponseModel {
    data?: RegionDto | undefined;

    constructor(data?: IUpdateRegionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RegionDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateRegionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateRegionResponseModel {
    data?: RegionDto | undefined;
}

export class UpdateRegionRequestModel implements IUpdateRegionRequestModel {
    id?: number;
    countryId?: number;
    name?: string | undefined;

    constructor(data?: IUpdateRegionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryId = _data["countryId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateRegionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateRegionRequestModel {
    id?: number;
    countryId?: number;
    name?: string | undefined;
}

export class DeleteRegionResponseModel implements IDeleteRegionResponseModel {

    constructor(data?: IDeleteRegionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteRegionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRegionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteRegionResponseModel {
}

export class CreateSessionResponseModel implements ICreateSessionResponseModel {
    data?: string | undefined;

    constructor(data?: ICreateSessionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CreateSessionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSessionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface ICreateSessionResponseModel {
    data?: string | undefined;
}

export class GetAppSessionsResponseModel implements IGetAppSessionsResponseModel {
    data?: AppSessionDto[] | undefined;
    count?: number;

    constructor(data?: IGetAppSessionsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AppSessionDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAppSessionsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppSessionsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetAppSessionsResponseModel {
    data?: AppSessionDto[] | undefined;
    count?: number;
}

export class AppSessionDto implements IAppSessionDto {
    id?: string | undefined;
    atm?: string | undefined;
    atmId?: string | undefined;
    createdDate?: string;

    constructor(data?: IAppSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.atm = _data["atm"];
            this.atmId = _data["atmId"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): AppSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["atm"] = this.atm;
        data["atmId"] = this.atmId;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IAppSessionDto {
    id?: string | undefined;
    atm?: string | undefined;
    atmId?: string | undefined;
    createdDate?: string;
}

export class GetAppSessionDetailByIdResponseModel implements IGetAppSessionDetailByIdResponseModel {
    data?: AppSessionDetailDto | undefined;

    constructor(data?: IGetAppSessionDetailByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AppSessionDetailDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetAppSessionDetailByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppSessionDetailByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetAppSessionDetailByIdResponseModel {
    data?: AppSessionDetailDto | undefined;
}

export class AppSessionDetailDto implements IAppSessionDetailDto {
    id?: string | undefined;
    atm?: string | undefined;
    atmId?: string | undefined;
    logs?: AppLogDto[] | undefined;
    images?: AppSessionImageDto[] | undefined;
    transactions?: AppTransactionDto[] | undefined;
    denominationRecordChanges?: DenominationRecordChangeDto[] | undefined;
    kycs?: AppSessionKycDto[] | undefined;
    createdDate?: string;

    constructor(data?: IAppSessionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.atm = _data["atm"];
            this.atmId = _data["atmId"];
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(AppLogDto.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(AppSessionImageDto.fromJS(item));
            }
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(AppTransactionDto.fromJS(item));
            }
            if (Array.isArray(_data["denominationRecordChanges"])) {
                this.denominationRecordChanges = [] as any;
                for (let item of _data["denominationRecordChanges"])
                    this.denominationRecordChanges!.push(DenominationRecordChangeDto.fromJS(item));
            }
            if (Array.isArray(_data["kycs"])) {
                this.kycs = [] as any;
                for (let item of _data["kycs"])
                    this.kycs!.push(AppSessionKycDto.fromJS(item));
            }
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): AppSessionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSessionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["atm"] = this.atm;
        data["atmId"] = this.atmId;
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.denominationRecordChanges)) {
            data["denominationRecordChanges"] = [];
            for (let item of this.denominationRecordChanges)
                data["denominationRecordChanges"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.kycs)) {
            data["kycs"] = [];
            for (let item of this.kycs)
                data["kycs"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IAppSessionDetailDto {
    id?: string | undefined;
    atm?: string | undefined;
    atmId?: string | undefined;
    logs?: AppLogDto[] | undefined;
    images?: AppSessionImageDto[] | undefined;
    transactions?: AppTransactionDto[] | undefined;
    denominationRecordChanges?: DenominationRecordChangeDto[] | undefined;
    kycs?: AppSessionKycDto[] | undefined;
    createdDate?: string;
}

export class SendVerificationSmsResponseModel implements ISendVerificationSmsResponseModel {

    constructor(data?: ISendVerificationSmsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SendVerificationSmsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISendVerificationSmsResponseModel {
}

export class SendVerificationSmsRequestModel implements ISendVerificationSmsRequestModel {
    sessionId?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ISendVerificationSmsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ISendVerificationSmsRequestModel {
    sessionId?: string | undefined;
    phoneNumber?: string | undefined;
}

export class SendVerificationSmsForLoginResponseModel implements ISendVerificationSmsForLoginResponseModel {

    constructor(data?: ISendVerificationSmsForLoginResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SendVerificationSmsForLoginResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsForLoginResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISendVerificationSmsForLoginResponseModel {
}

export class SendVerificationSmsForLoginRequestModel implements ISendVerificationSmsForLoginRequestModel {
    username?: string | undefined;
    password?: string | undefined;
    role?: string | undefined;

    constructor(data?: ISendVerificationSmsForLoginRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): SendVerificationSmsForLoginRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsForLoginRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["role"] = this.role;
        return data;
    }
}

export interface ISendVerificationSmsForLoginRequestModel {
    username?: string | undefined;
    password?: string | undefined;
    role?: string | undefined;
}

export class VerifyOtpResponseModel implements IVerifyOtpResponseModel {

    constructor(data?: IVerifyOtpResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): VerifyOtpResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyOtpResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IVerifyOtpResponseModel {
}

export class VerifyOtpRequestModel implements IVerifyOtpRequestModel {
    sessionId?: string | undefined;
    phoneNumber?: string | undefined;
    otp?: string | undefined;

    constructor(data?: IVerifyOtpRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.phoneNumber = _data["phoneNumber"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): VerifyOtpRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyOtpRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["phoneNumber"] = this.phoneNumber;
        data["otp"] = this.otp;
        return data;
    }
}

export interface IVerifyOtpRequestModel {
    sessionId?: string | undefined;
    phoneNumber?: string | undefined;
    otp?: string | undefined;
}

export class GetStaffsResponseModel implements IGetStaffsResponseModel {
    count?: number;
    data?: StaffDto[] | undefined;

    constructor(data?: IGetStaffsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StaffDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStaffsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetStaffsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetStaffsResponseModel {
    count?: number;
    data?: StaffDto[] | undefined;
}

export class StaffDto implements IStaffDto {
    regions?: RegionDto[] | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;
    phoneNumber?: string | undefined;
    id?: string | undefined;
    role?: string | undefined;

    constructor(data?: IStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(RegionDto.fromJS(item));
            }
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.isEnabled = _data["isEnabled"];
            this.createdDate = _data["createdDate"];
            this.phoneNumber = _data["phoneNumber"];
            this.id = _data["id"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): StaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item ? item.toJSON() : undefined as any);
        }
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["isEnabled"] = this.isEnabled;
        data["createdDate"] = this.createdDate;
        data["phoneNumber"] = this.phoneNumber;
        data["id"] = this.id;
        data["role"] = this.role;
        return data;
    }
}

export interface IStaffDto {
    regions?: RegionDto[] | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    isEnabled?: boolean;
    createdDate?: string;
    phoneNumber?: string | undefined;
    id?: string | undefined;
    role?: string | undefined;
}

export class GetStaffsDropDownResponseModel implements IGetStaffsDropDownResponseModel {
    data?: DropDownDtoOfString[] | undefined;

    constructor(data?: IGetStaffsDropDownResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DropDownDtoOfString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStaffsDropDownResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetStaffsDropDownResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetStaffsDropDownResponseModel {
    data?: DropDownDtoOfString[] | undefined;
}

export class CreateStaffResponseModel implements ICreateStaffResponseModel {
    data?: StaffDto | undefined;

    constructor(data?: ICreateStaffResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StaffDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateStaffResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateStaffResponseModel {
    data?: StaffDto | undefined;
}

export class CreateStaffRequestModel implements ICreateStaffRequestModel {
    countryId?: number;
    regionIds?: number[] | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    role?: string | undefined;

    constructor(data?: ICreateStaffRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            if (Array.isArray(_data["regionIds"])) {
                this.regionIds = [] as any;
                for (let item of _data["regionIds"])
                    this.regionIds!.push(item);
            }
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): CreateStaffRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStaffRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        if (Array.isArray(this.regionIds)) {
            data["regionIds"] = [];
            for (let item of this.regionIds)
                data["regionIds"].push(item);
        }
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["role"] = this.role;
        return data;
    }
}

export interface ICreateStaffRequestModel {
    countryId?: number;
    regionIds?: number[] | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    role?: string | undefined;
}

export class UpdateStaffResponseModel implements IUpdateStaffResponseModel {
    data?: StaffDto | undefined;

    constructor(data?: IUpdateStaffResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StaffDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateStaffResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStaffResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateStaffResponseModel {
    data?: StaffDto | undefined;
}

export class UpdateStaffRequestModel implements IUpdateStaffRequestModel {
    id?: string | undefined;
    regionIds?: number[] | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    phoneNumber?: string | undefined;
    countryId?: number;

    constructor(data?: IUpdateStaffRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["regionIds"])) {
                this.regionIds = [] as any;
                for (let item of _data["regionIds"])
                    this.regionIds!.push(item);
            }
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.phoneNumber = _data["phoneNumber"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): UpdateStaffRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStaffRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.regionIds)) {
            data["regionIds"] = [];
            for (let item of this.regionIds)
                data["regionIds"].push(item);
        }
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["role"] = this.role;
        data["phoneNumber"] = this.phoneNumber;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface IUpdateStaffRequestModel {
    id?: string | undefined;
    regionIds?: number[] | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    phoneNumber?: string | undefined;
    countryId?: number;
}

export class UpdateStaffEnableResponseModel implements IUpdateStaffEnableResponseModel {

    constructor(data?: IUpdateStaffEnableResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateStaffEnableResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStaffEnableResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateStaffEnableResponseModel {
}

export class UpdateStaffEnableRequestModel implements IUpdateStaffEnableRequestModel {
    id?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IUpdateStaffEnableRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdateStaffEnableRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStaffEnableRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpdateStaffEnableRequestModel {
    id?: string | undefined;
    isEnabled?: boolean;
}

export class DeleteStaffResponseModel implements IDeleteStaffResponseModel {

    constructor(data?: IDeleteStaffResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteStaffResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStaffResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteStaffResponseModel {
}

export class GetTicketCommentsResponseModel implements IGetTicketCommentsResponseModel {
    data?: TicketCommentDto[] | undefined;
    count?: number;

    constructor(data?: IGetTicketCommentsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TicketCommentDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetTicketCommentsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTicketCommentsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetTicketCommentsResponseModel {
    data?: TicketCommentDto[] | undefined;
    count?: number;
}

export class TicketCommentDto implements ITicketCommentDto {
    ticketId?: number;
    userId?: string | undefined;
    user?: string | undefined;
    content?: string | undefined;
    id?: number;
    createdDate?: string;

    constructor(data?: ITicketCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data["ticketId"];
            this.userId = _data["userId"];
            this.user = _data["user"];
            this.content = _data["content"];
            this.id = _data["id"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): TicketCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["userId"] = this.userId;
        data["user"] = this.user;
        data["content"] = this.content;
        data["id"] = this.id;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface ITicketCommentDto {
    ticketId?: number;
    userId?: string | undefined;
    user?: string | undefined;
    content?: string | undefined;
    id?: number;
    createdDate?: string;
}

export class CreateTicketCommentResponseModel implements ICreateTicketCommentResponseModel {
    data?: TicketCommentDto | undefined;

    constructor(data?: ICreateTicketCommentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TicketCommentDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateTicketCommentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketCommentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateTicketCommentResponseModel {
    data?: TicketCommentDto | undefined;
}

export class CreateTicketCommentRequestModel implements ICreateTicketCommentRequestModel {
    ticketId?: number;
    content?: string | undefined;

    constructor(data?: ICreateTicketCommentRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data["ticketId"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CreateTicketCommentRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketCommentRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["content"] = this.content;
        return data;
    }
}

export interface ICreateTicketCommentRequestModel {
    ticketId?: number;
    content?: string | undefined;
}

export class UpdateTicketCommentResponseModel implements IUpdateTicketCommentResponseModel {
    data?: TicketCommentDto | undefined;

    constructor(data?: IUpdateTicketCommentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TicketCommentDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateTicketCommentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketCommentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateTicketCommentResponseModel {
    data?: TicketCommentDto | undefined;
}

export class UpdateTicketCommentRequestModel implements IUpdateTicketCommentRequestModel {
    id?: number;
    content?: string | undefined;

    constructor(data?: IUpdateTicketCommentRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): UpdateTicketCommentRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketCommentRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        return data;
    }
}

export interface IUpdateTicketCommentRequestModel {
    id?: number;
    content?: string | undefined;
}

export class DeleteTicketCommentResponseModel implements IDeleteTicketCommentResponseModel {

    constructor(data?: IDeleteTicketCommentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteTicketCommentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTicketCommentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteTicketCommentResponseModel {
}

export class CreateTicketResponseModel implements ICreateTicketResponseModel {
    data?: TicketDto | undefined;

    constructor(data?: ICreateTicketResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TicketDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateTicketResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateTicketResponseModel {
    data?: TicketDto | undefined;
}

export class CreateTicketRequestModel implements ICreateTicketRequestModel {
    atmId?: string | undefined;
    staffId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    regionId?: number;
    countryId?: number;

    constructor(data?: ICreateTicketRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.atmId = _data["atmId"];
            this.staffId = _data["staffId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.regionId = _data["regionId"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): CreateTicketRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["atmId"] = this.atmId;
        data["staffId"] = this.staffId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["regionId"] = this.regionId;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ICreateTicketRequestModel {
    atmId?: string | undefined;
    staffId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    regionId?: number;
    countryId?: number;
}

export class UpdateTicketResponseModel implements IUpdateTicketResponseModel {
    data?: TicketDto | undefined;

    constructor(data?: IUpdateTicketResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TicketDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateTicketResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateTicketResponseModel {
    data?: TicketDto | undefined;
}

export class UpdateTicketRequestModel implements IUpdateTicketRequestModel {
    id?: number;
    atmId?: string | undefined;
    staffId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    regionId?: number;

    constructor(data?: IUpdateTicketRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.atmId = _data["atmId"];
            this.staffId = _data["staffId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.regionId = _data["regionId"];
        }
    }

    static fromJS(data: any): UpdateTicketRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["atmId"] = this.atmId;
        data["staffId"] = this.staffId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["regionId"] = this.regionId;
        return data;
    }
}

export interface IUpdateTicketRequestModel {
    id?: number;
    atmId?: string | undefined;
    staffId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    regionId?: number;
}

export class DeleteTicketResponseModel implements IDeleteTicketResponseModel {

    constructor(data?: IDeleteTicketResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteTicketResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTicketResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteTicketResponseModel {
}

export class ResolveTicketResponseModel implements IResolveTicketResponseModel {
    data?: TicketDto | undefined;

    constructor(data?: IResolveTicketResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TicketDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResolveTicketResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTicketResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResolveTicketResponseModel {
    data?: TicketDto | undefined;
}

export class GetTransactionCommissionsResponseModel implements IGetTransactionCommissionsResponseModel {
    data?: TransactionCommissionDto[] | undefined;
    count?: number;

    constructor(data?: IGetTransactionCommissionsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TransactionCommissionDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetTransactionCommissionsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionCommissionsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetTransactionCommissionsResponseModel {
    data?: TransactionCommissionDto[] | undefined;
    count?: number;
}

export class TransactionCommissionDto implements ITransactionCommissionDto {
    id?: number;
    appTransactionId?: number;
    atmId?: string | undefined;
    atmName?: string | undefined;
    operatorType?: number;
    network?: string | undefined;
    bankName?: string | undefined;
    operatorName?: string | undefined;
    txnType?: number;
    txnAmount?: number;
    partyRole?: number;
    userId?: string | undefined;
    grossAmount?: number;
    amount?: number;
    sharePct?: number;
    currency?: string | undefined;
    status?: number;
    payerId?: string | undefined;
    reversalOfId?: number | undefined;
    createdDate?: string;
    user?: string | undefined;
    partyName?: string | undefined;

    constructor(data?: ITransactionCommissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appTransactionId = _data["appTransactionId"];
            this.atmId = _data["atmId"];
            this.atmName = _data["atmName"];
            this.operatorType = _data["operatorType"];
            this.network = _data["network"];
            this.bankName = _data["bankName"];
            this.operatorName = _data["operatorName"];
            this.txnType = _data["txnType"];
            this.txnAmount = _data["txnAmount"];
            this.partyRole = _data["partyRole"];
            this.userId = _data["userId"];
            this.grossAmount = _data["grossAmount"];
            this.amount = _data["amount"];
            this.sharePct = _data["sharePct"];
            this.currency = _data["currency"];
            this.status = _data["status"];
            this.payerId = _data["payerId"];
            this.reversalOfId = _data["reversalOfId"];
            this.createdDate = _data["createdDate"];
            this.user = _data["user"];
            this.partyName = _data["partyName"];
        }
    }

    static fromJS(data: any): TransactionCommissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionCommissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appTransactionId"] = this.appTransactionId;
        data["atmId"] = this.atmId;
        data["atmName"] = this.atmName;
        data["operatorType"] = this.operatorType;
        data["network"] = this.network;
        data["bankName"] = this.bankName;
        data["operatorName"] = this.operatorName;
        data["txnType"] = this.txnType;
        data["txnAmount"] = this.txnAmount;
        data["partyRole"] = this.partyRole;
        data["userId"] = this.userId;
        data["grossAmount"] = this.grossAmount;
        data["amount"] = this.amount;
        data["sharePct"] = this.sharePct;
        data["currency"] = this.currency;
        data["status"] = this.status;
        data["payerId"] = this.payerId;
        data["reversalOfId"] = this.reversalOfId;
        data["createdDate"] = this.createdDate;
        data["user"] = this.user;
        data["partyName"] = this.partyName;
        return data;
    }
}

export interface ITransactionCommissionDto {
    id?: number;
    appTransactionId?: number;
    atmId?: string | undefined;
    atmName?: string | undefined;
    operatorType?: number;
    network?: string | undefined;
    bankName?: string | undefined;
    operatorName?: string | undefined;
    txnType?: number;
    txnAmount?: number;
    partyRole?: number;
    userId?: string | undefined;
    grossAmount?: number;
    amount?: number;
    sharePct?: number;
    currency?: string | undefined;
    status?: number;
    payerId?: string | undefined;
    reversalOfId?: number | undefined;
    createdDate?: string;
    user?: string | undefined;
    partyName?: string | undefined;
}

export class GetTransactionCommissionSummaryResponseModel implements IGetTransactionCommissionSummaryResponseModel {
    data?: TransactionCommissionSummaryDto[] | undefined;
    count?: number;
    parties?: CommissionPartyDto[] | undefined;

    constructor(data?: IGetTransactionCommissionSummaryResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TransactionCommissionSummaryDto.fromJS(item));
            }
            this.count = _data["count"];
            if (Array.isArray(_data["parties"])) {
                this.parties = [] as any;
                for (let item of _data["parties"])
                    this.parties!.push(CommissionPartyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTransactionCommissionSummaryResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionCommissionSummaryResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        if (Array.isArray(this.parties)) {
            data["parties"] = [];
            for (let item of this.parties)
                data["parties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTransactionCommissionSummaryResponseModel {
    data?: TransactionCommissionSummaryDto[] | undefined;
    count?: number;
    parties?: CommissionPartyDto[] | undefined;
}

export class TransactionCommissionSummaryDto implements ITransactionCommissionSummaryDto {
    appTransactionId?: number;
    atmId?: string | undefined;
    atmName?: string | undefined;
    operatorType?: number;
    network?: string | undefined;
    bankName?: string | undefined;
    operatorName?: string | undefined;
    txnType?: number;
    txnAmount?: number;
    grossCommission?: number;
    currency?: string | undefined;
    commissionStatus?: number;
    createdDate?: string;
    shares?: CommissionShareDto[] | undefined;

    constructor(data?: ITransactionCommissionSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appTransactionId = _data["appTransactionId"];
            this.atmId = _data["atmId"];
            this.atmName = _data["atmName"];
            this.operatorType = _data["operatorType"];
            this.network = _data["network"];
            this.bankName = _data["bankName"];
            this.operatorName = _data["operatorName"];
            this.txnType = _data["txnType"];
            this.txnAmount = _data["txnAmount"];
            this.grossCommission = _data["grossCommission"];
            this.currency = _data["currency"];
            this.commissionStatus = _data["commissionStatus"];
            this.createdDate = _data["createdDate"];
            if (Array.isArray(_data["shares"])) {
                this.shares = [] as any;
                for (let item of _data["shares"])
                    this.shares!.push(CommissionShareDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionCommissionSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionCommissionSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appTransactionId"] = this.appTransactionId;
        data["atmId"] = this.atmId;
        data["atmName"] = this.atmName;
        data["operatorType"] = this.operatorType;
        data["network"] = this.network;
        data["bankName"] = this.bankName;
        data["operatorName"] = this.operatorName;
        data["txnType"] = this.txnType;
        data["txnAmount"] = this.txnAmount;
        data["grossCommission"] = this.grossCommission;
        data["currency"] = this.currency;
        data["commissionStatus"] = this.commissionStatus;
        data["createdDate"] = this.createdDate;
        if (Array.isArray(this.shares)) {
            data["shares"] = [];
            for (let item of this.shares)
                data["shares"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITransactionCommissionSummaryDto {
    appTransactionId?: number;
    atmId?: string | undefined;
    atmName?: string | undefined;
    operatorType?: number;
    network?: string | undefined;
    bankName?: string | undefined;
    operatorName?: string | undefined;
    txnType?: number;
    txnAmount?: number;
    grossCommission?: number;
    currency?: string | undefined;
    commissionStatus?: number;
    createdDate?: string;
    shares?: CommissionShareDto[] | undefined;
}

export class CommissionShareDto implements ICommissionShareDto {
    key?: string | undefined;
    partyRole?: number;
    userId?: string | undefined;
    partyName?: string | undefined;
    sharePct?: number;
    amount?: number;

    constructor(data?: ICommissionShareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.partyRole = _data["partyRole"];
            this.userId = _data["userId"];
            this.partyName = _data["partyName"];
            this.sharePct = _data["sharePct"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): CommissionShareDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionShareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["partyRole"] = this.partyRole;
        data["userId"] = this.userId;
        data["partyName"] = this.partyName;
        data["sharePct"] = this.sharePct;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ICommissionShareDto {
    key?: string | undefined;
    partyRole?: number;
    userId?: string | undefined;
    partyName?: string | undefined;
    sharePct?: number;
    amount?: number;
}

export class CommissionPartyDto implements ICommissionPartyDto {
    key?: string | undefined;
    partyRole?: number;
    userId?: string | undefined;
    partyName?: string | undefined;

    constructor(data?: ICommissionPartyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.partyRole = _data["partyRole"];
            this.userId = _data["userId"];
            this.partyName = _data["partyName"];
        }
    }

    static fromJS(data: any): CommissionPartyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionPartyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["partyRole"] = this.partyRole;
        data["userId"] = this.userId;
        data["partyName"] = this.partyName;
        return data;
    }
}

export interface ICommissionPartyDto {
    key?: string | undefined;
    partyRole?: number;
    userId?: string | undefined;
    partyName?: string | undefined;
}

export class GetTransactionCommissionsByAppTransactionIdResponseModel implements IGetTransactionCommissionsByAppTransactionIdResponseModel {
    data?: TransactionCommissionDto[] | undefined;

    constructor(data?: IGetTransactionCommissionsByAppTransactionIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TransactionCommissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTransactionCommissionsByAppTransactionIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionCommissionsByAppTransactionIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTransactionCommissionsByAppTransactionIdResponseModel {
    data?: TransactionCommissionDto[] | undefined;
}

export class SendTwoFactorCodeResponseModel implements ISendTwoFactorCodeResponseModel {
    channel?: string | undefined;
    destination?: string | undefined;

    constructor(data?: ISendTwoFactorCodeResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channel = _data["channel"];
            this.destination = _data["destination"];
        }
    }

    static fromJS(data: any): SendTwoFactorCodeResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorCodeResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channel"] = this.channel;
        data["destination"] = this.destination;
        return data;
    }
}

export interface ISendTwoFactorCodeResponseModel {
    channel?: string | undefined;
    destination?: string | undefined;
}

export class SendTwoFactorCodeRequestModel implements ISendTwoFactorCodeRequestModel {
    username?: string | undefined;
    password?: string | undefined;
    role?: string | undefined;
    channel?: TwoFactorChannel;

    constructor(data?: ISendTwoFactorCodeRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.role = _data["role"];
            this.channel = _data["channel"];
        }
    }

    static fromJS(data: any): SendTwoFactorCodeRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorCodeRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["role"] = this.role;
        data["channel"] = this.channel;
        return data;
    }
}

export interface ISendTwoFactorCodeRequestModel {
    username?: string | undefined;
    password?: string | undefined;
    role?: string | undefined;
    channel?: TwoFactorChannel;
}

export enum TwoFactorChannel {
    Email = 0,
    Sms = 1,
}

export class TwoFactorStatusResponseModel implements ITwoFactorStatusResponseModel {
    enabled?: boolean;
    required?: boolean;
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ITwoFactorStatusResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.required = _data["required"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): TwoFactorStatusResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorStatusResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["required"] = this.required;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ITwoFactorStatusResponseModel {
    enabled?: boolean;
    required?: boolean;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class SetTwoFactorRequestModel implements ISetTwoFactorRequestModel {
    enabled?: boolean;

    constructor(data?: ISetTwoFactorRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): SetTwoFactorRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetTwoFactorRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface ISetTwoFactorRequestModel {
    enabled?: boolean;
}

export class TwoFactorRequirementResponseModel implements ITwoFactorRequirementResponseModel {
    required?: boolean;

    constructor(data?: ITwoFactorRequirementResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): TwoFactorRequirementResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorRequirementResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["required"] = this.required;
        return data;
    }
}

export interface ITwoFactorRequirementResponseModel {
    required?: boolean;
}

export class SetTwoFactorRequirementRequestModel implements ISetTwoFactorRequirementRequestModel {
    required?: boolean;

    constructor(data?: ISetTwoFactorRequirementRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): SetTwoFactorRequirementRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetTwoFactorRequirementRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["required"] = this.required;
        return data;
    }
}

export interface ISetTwoFactorRequirementRequestModel {
    required?: boolean;
}

export class ChangeCurrentPasswordResponseModel implements IChangeCurrentPasswordResponseModel {

    constructor(data?: IChangeCurrentPasswordResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ChangeCurrentPasswordResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeCurrentPasswordResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IChangeCurrentPasswordResponseModel {
}

export class ChangeCurrentPasswordRequestModel implements IChangeCurrentPasswordRequestModel {
    currentPassword?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IChangeCurrentPasswordRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ChangeCurrentPasswordRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeCurrentPasswordRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IChangeCurrentPasswordRequestModel {
    currentPassword?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
}

export class GetIsActiveResponseModel implements IGetIsActiveResponseModel {
    isActive?: boolean;

    constructor(data?: IGetIsActiveResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GetIsActiveResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetIsActiveResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGetIsActiveResponseModel {
    isActive?: boolean;
}

export class UpdateFcmIdResponseModel implements IUpdateFcmIdResponseModel {

    constructor(data?: IUpdateFcmIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateFcmIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFcmIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateFcmIdResponseModel {
}

export class UpdateFcmIdRequestModel implements IUpdateFcmIdRequestModel {
    fcmId?: string | undefined;
    deviceId?: string | undefined;

    constructor(data?: IUpdateFcmIdRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fcmId = _data["fcmId"];
            this.deviceId = _data["deviceId"];
        }
    }

    static fromJS(data: any): UpdateFcmIdRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFcmIdRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fcmId"] = this.fcmId;
        data["deviceId"] = this.deviceId;
        return data;
    }
}

export interface IUpdateFcmIdRequestModel {
    fcmId?: string | undefined;
    deviceId?: string | undefined;
}

export class UpdateNotificationSettingResponseModel implements IUpdateNotificationSettingResponseModel {

    constructor(data?: IUpdateNotificationSettingResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateNotificationSettingResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateNotificationSettingResponseModel {
}

export class UpdateNotificationSettingRequestModel implements IUpdateNotificationSettingRequestModel {
    isNotificationEnabled?: boolean;

    constructor(data?: IUpdateNotificationSettingRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isNotificationEnabled = _data["isNotificationEnabled"];
        }
    }

    static fromJS(data: any): UpdateNotificationSettingRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNotificationEnabled"] = this.isNotificationEnabled;
        return data;
    }
}

export interface IUpdateNotificationSettingRequestModel {
    isNotificationEnabled?: boolean;
}

export class UpdatePasswordByIdResponseModel implements IUpdatePasswordByIdResponseModel {

    constructor(data?: IUpdatePasswordByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdatePasswordByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePasswordByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdatePasswordByIdResponseModel {
}

export class UpdatePasswordByIdRequestModel implements IUpdatePasswordByIdRequestModel {
    id?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IUpdatePasswordByIdRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): UpdatePasswordByIdRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePasswordByIdRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IUpdatePasswordByIdRequestModel {
    id?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
}

export class ApproveWithdrawalResponseModel implements IApproveWithdrawalResponseModel {

    constructor(data?: IApproveWithdrawalResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ApproveWithdrawalResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveWithdrawalResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IApproveWithdrawalResponseModel {
}

export class ApproveWithdrawalRequestModel implements IApproveWithdrawalRequestModel {
    id?: number;
    adminMessage?: string | undefined;
    proofImageBase64?: string | undefined;

    constructor(data?: IApproveWithdrawalRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.adminMessage = _data["adminMessage"];
            this.proofImageBase64 = _data["proofImageBase64"];
        }
    }

    static fromJS(data: any): ApproveWithdrawalRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveWithdrawalRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["adminMessage"] = this.adminMessage;
        data["proofImageBase64"] = this.proofImageBase64;
        return data;
    }
}

export interface IApproveWithdrawalRequestModel {
    id?: number;
    adminMessage?: string | undefined;
    proofImageBase64?: string | undefined;
}

export class RejectWithdrawalResponseModel implements IRejectWithdrawalResponseModel {

    constructor(data?: IRejectWithdrawalResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RejectWithdrawalResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RejectWithdrawalResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRejectWithdrawalResponseModel {
}

export class RejectWithdrawalRequestModel implements IRejectWithdrawalRequestModel {
    id?: number;
    adminMessage?: string | undefined;

    constructor(data?: IRejectWithdrawalRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.adminMessage = _data["adminMessage"];
        }
    }

    static fromJS(data: any): RejectWithdrawalRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new RejectWithdrawalRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["adminMessage"] = this.adminMessage;
        return data;
    }
}

export interface IRejectWithdrawalRequestModel {
    id?: number;
    adminMessage?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}